var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouses = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2225,
  height: 149,
  viewBox: "0 0 2225 149",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "luminosity"
  },
  opacity: 0.25,
  clipPath: "url(#clip0_79_16853)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M575.89 106.84L643.37 106.84V54.36L575.89 54.36V106.84Z",
  fill: "#F9BE19"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M643.37 54.35H575.89L557.15 31.86H624.63L643.37 54.35Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M557.15 31.86L575.89 54.35V106.84H538.41V54.35L557.15 31.86Z",
  fill: "#D39C16"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M624.63 80.59H632.13V69.34H624.63V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M623.69 68.41H633.03V81.53H623.66L623.69 68.41ZM631.18 70.29H625.56V79.67H631.18V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M617.12 80.59H624.62V69.34H617.12V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M616.19 68.41H625.56V81.53H616.19V68.41ZM623.69 70.29H618.03V79.67H623.66L623.69 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M617.12 91.85H624.62V80.6H617.12V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M616.19 79.67H625.56V92.79H616.19V79.67ZM623.69 81.54H618.03V90.91H623.66L623.69 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M624.63 91.85H632.13V80.6H624.63V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M623.69 79.67H633.03V92.79H623.66L623.69 79.67ZM631.18 81.54H625.56V90.91H631.18V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M594.64 80.59H602.14V69.34H594.64V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M593.7 68.41H603.03V81.53H593.66L593.7 68.41ZM601.19 70.29H595.57V79.67H601.19V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M587.14 80.59H594.64V69.34H587.14V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M586.2 68.41H595.57V81.53H586.2V68.41ZM593.7 70.29H588.03V79.67H593.66L593.7 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M587.14 91.85H594.64V80.6H587.14V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M586.2 79.67H595.57V92.79H586.2V79.67ZM593.7 81.54H588.03V90.91H593.66L593.7 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M594.64 91.85H602.14V80.6H594.64V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M593.7 79.67H603.03V92.79H593.66L593.7 79.67ZM601.19 81.54H595.57V90.91H601.19V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M557.15 80.59H564.65V69.34H557.15V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M556.21 68.41H565.58V81.53H556.21V68.41ZM563.71 70.29H558.09V79.67H563.71V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M549.65 80.59H557.15V69.34H549.65V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M548.71 68.41H558.09V81.53H548.71V68.41ZM556.21 70.29H550.59V79.67H556.21V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M549.65 91.85H557.15V80.6H549.65V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M548.71 79.67H558.09V92.79H548.71V79.67ZM556.21 81.54H550.59V90.91H556.21V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M557.15 91.85H564.65V80.6H557.15V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M556.21 79.67H565.58V92.79H556.21V79.67ZM563.71 81.54H558.09V90.91H563.71V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M557.15 59.98C560.254 59.98 562.77 57.4638 562.77 54.36C562.77 51.2561 560.254 48.74 557.15 48.74C554.046 48.74 551.53 51.2561 551.53 54.36C551.53 57.4638 554.046 59.98 557.15 59.98Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M596.51 31.49V22.49H607.76V44.98L596.51 31.49Z",
  fill: "#F9BE19"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M594.65 22.5L609.64 22.5V15L594.65 15V22.5Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1108.2 31.86H1078.21V106.83H1108.2V31.86Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1108.2 106.84H1160.68V31.86L1134.44 9.37L1108.2 31.86V106.84Z",
  fill: "#FFA063"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1108.2 31.86H1078.21L1104.45 9.37H1134.44L1108.2 31.86Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1093.21 43.11H1085.71V54.36H1093.21V43.11Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1084.77 42.17H1094.14V55.29H1084.77V42.17ZM1092.27 44.05H1086.64V53.42H1092.27V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1100.71 43.11H1093.21V54.36H1100.71V43.11Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1092.27 42.17H1101.64V55.29H1092.27V42.17ZM1099.76 44.05H1094.14V53.42H1099.76V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1093.21 54.36H1085.71V65.61H1093.21V54.36Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1084.77 53.42H1094.14V66.54H1084.77V53.42ZM1092.27 55.29H1086.64V64.67H1092.27V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1100.71 54.36H1093.21V65.61H1100.71V54.36Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1092.27 53.42H1101.64V66.54H1092.27V53.42ZM1099.76 55.29H1094.14V64.67H1099.76V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1093.21 73.1H1085.71V84.35H1093.21V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1084.77 72.16H1094.14V85.28H1084.77V72.16ZM1092.27 74.03H1086.64V83.41H1092.27V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1100.71 73.1H1093.21V84.35H1100.71V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1092.27 72.16H1101.64V85.28H1092.27V72.16ZM1099.76 74.03H1094.14V83.41H1099.76V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1093.21 84.34H1085.71V95.59H1093.21V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1084.77 83.41H1094.14V96.53H1084.77V83.41ZM1092.27 85.28H1086.64V94.67H1092.27V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1100.71 84.34H1093.21V95.59H1100.71V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1092.27 83.41H1101.64V96.53H1092.27V83.41ZM1099.76 85.28H1094.14V94.67H1099.76V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1123.2 43.11H1115.7V54.36H1123.2V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1114.76 42.17H1124.13V55.29H1114.76V42.17ZM1122.25 44.05H1116.63V53.42H1122.25V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1130.7 43.11H1123.2V54.36H1130.7V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1122.25 42.17H1131.63V55.29H1122.25V42.17ZM1129.75 44.05H1124.13V53.42H1129.75V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1123.2 54.36H1115.7V65.61H1123.2V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1114.76 53.42H1124.13V66.54H1114.76V53.42ZM1122.25 55.29H1116.63V64.67H1122.25V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1130.7 54.36H1123.2V65.61H1130.7V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1122.25 53.42H1131.63V66.54H1122.25V53.42ZM1129.75 55.29H1124.13V64.67H1129.75V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1115.71 106.83H1130.7V73.0899H1115.71V106.83Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1114.76 72.16H1131.63V106.83H1114.76V72.16ZM1129.76 74.03H1116.63V106.83H1129.75L1129.76 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1123.2 73.1H1115.7V84.35H1123.2V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1114.76 72.16H1124.13V85.28H1114.76V72.16ZM1122.25 74.03H1116.63V83.41H1122.25V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1130.7 73.1H1123.2V84.35H1130.7V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1122.25 72.16H1131.63V85.28H1122.25V72.16ZM1129.75 74.03H1124.13V83.41H1129.75V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1145.69 43.11H1138.19V54.36H1145.69V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1137.25 42.17H1146.62V55.29H1137.25V42.17ZM1144.75 44.05H1139.12V53.42H1144.75V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1153.19 43.11H1145.69V54.36H1153.19V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1144.75 42.17H1154.12V55.29H1144.75V42.17ZM1152.24 44.05H1146.62V53.42H1152.24V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1145.69 54.36H1138.19V65.61H1145.69V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1137.25 53.42H1146.62V66.54H1137.25V53.42ZM1144.75 55.29H1139.12V64.67H1144.75V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1153.19 54.36H1145.69V65.61H1153.19V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1144.75 53.42H1154.12V66.54H1144.75V53.42ZM1152.24 55.29H1146.62V64.67H1152.24V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1145.69 73.1H1138.19V84.35H1145.69V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1137.25 72.16H1146.62V85.28H1137.25V72.16ZM1144.75 74.03H1139.12V83.41H1144.75V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1153.19 73.1H1145.69V84.35H1153.19V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1144.75 72.16H1154.12V85.28H1144.75V72.16ZM1152.24 74.03H1146.62V83.41H1152.24V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1145.69 84.34H1138.19V95.59H1145.69V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1137.25 83.41H1146.62V96.53H1137.25V83.41ZM1144.75 85.28H1139.12V94.67H1144.75V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1153.19 84.34H1145.69V95.59H1153.19V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1144.75 83.41H1154.12V96.53H1144.75V83.41ZM1152.24 85.28H1146.62V94.67H1152.24V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1130.69 35.61H1138.19V28.11C1138.19 27.618 1138.09 27.1309 1137.9 26.6765C1137.72 26.2221 1137.44 25.8093 1137.09 25.4619C1136.74 25.1145 1136.33 24.8392 1135.87 24.6518C1135.42 24.4645 1134.93 24.3687 1134.44 24.37C1133.95 24.3687 1133.46 24.4645 1133.01 24.6518C1132.55 24.8392 1132.14 25.1145 1131.79 25.4619C1131.44 25.8093 1131.16 26.2221 1130.98 26.6765C1130.79 27.1309 1130.69 27.618 1130.69 28.11V35.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1129.75 28.11C1129.81 26.9049 1130.32 25.7676 1131.2 24.9345C1132.07 24.1013 1133.23 23.6365 1134.44 23.6365C1135.64 23.6365 1136.8 24.1013 1137.67 24.9345C1138.55 25.7676 1139.06 26.9049 1139.12 28.11V36.55H1129.75V28.11ZM1137.25 28.11C1137.25 27.3647 1136.95 26.65 1136.43 26.123C1135.9 25.596 1135.19 25.3 1134.44 25.3C1133.69 25.3 1132.98 25.596 1132.45 26.123C1131.93 26.65 1131.63 27.3647 1131.63 28.11V34.67H1137.25V28.11Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1113.82 14.73V1.87H1102.58V24.37L1113.82 14.73Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M369.72 31.86H339.73V106.83H369.72V31.86Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M369.72 106.84H422.2V31.86L395.96 9.37L369.72 31.86V106.84Z",
  fill: "#FFA063"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M369.72 31.86H339.73L365.97 9.37H395.96L369.72 31.86Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M354.73 43.11H347.23V54.36H354.73V43.11Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M346.29 42.17H355.66V55.29H346.29V42.17ZM353.78 44.05H348.16V53.42H353.78V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M362.23 43.11H354.73V54.36H362.23V43.11Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M353.78 42.17H363.16V55.29H353.78V42.17ZM361.28 44.05H355.66V53.42H361.28V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M354.73 54.36H347.23V65.61H354.73V54.36Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M346.29 53.42H355.66V66.54H346.29V53.42ZM353.78 55.29H348.16V64.67H353.78V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M362.23 54.36H354.73V65.61H362.23V54.36Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M353.78 53.42H363.16V66.54H353.78V53.42ZM361.28 55.29H355.66V64.67H361.28V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M354.73 73.1H347.23V84.35H354.73V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M346.29 72.16H355.66V85.28H346.29V72.16ZM353.78 74.03H348.16V83.41H353.78V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M362.23 73.1H354.73V84.35H362.23V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M353.78 72.16H363.16V85.28H353.78V72.16ZM361.28 74.03H355.66V83.41H361.28V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M354.73 84.34H347.23V95.59H354.73V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M346.29 83.41H355.66V96.53H346.29V83.41ZM353.78 85.28H348.16V94.67H353.78V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M362.23 84.34H354.73V95.59H362.23V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M353.78 83.41H363.16V96.53H353.78V83.41ZM361.28 85.28H355.66V94.67H361.28V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M384.72 43.11H377.22V54.36H384.72V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M376.28 42.17H385.65V55.29H376.28V42.17ZM383.77 44.05H378.15V53.42H383.77V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M392.22 43.11H384.72V54.36H392.22V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M383.77 42.17H393.15V55.29H383.77V42.17ZM391.27 44.05H385.65V53.42H391.27V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M384.72 54.36H377.22V65.61H384.72V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M376.28 53.42H385.65V66.54H376.28V53.42ZM383.77 55.29H378.15V64.67H383.77V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M392.22 54.36H384.72V65.61H392.22V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M383.77 53.42H393.15V66.54H383.77V53.42ZM391.27 55.29H385.65V64.67H391.27V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M377.23 106.83H392.22V73.0899H377.23V106.83Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M376.28 72.16H393.15V106.83H376.28V72.16ZM391.28 74.03H378.15V106.83H391.27L391.28 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M384.72 73.1H377.22V84.35H384.72V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M376.28 72.16H385.65V85.28H376.28V72.16ZM383.77 74.03H378.15V83.41H383.77V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M392.22 73.1H384.72V84.35H392.22V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M383.77 72.16H393.15V85.28H383.77V72.16ZM391.27 74.03H385.65V83.41H391.27V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M407.21 43.11H399.71V54.36H407.21V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M398.77 42.17H408.14V55.29H398.77V42.17ZM406.27 44.05H400.64V53.42H406.27V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M414.71 43.11H407.21V54.36H414.71V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M406.27 42.17H415.64V55.29H406.27V42.17ZM413.76 44.05H408.14V53.42H413.76V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M407.21 54.36H399.71V65.61H407.21V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M398.77 53.42H408.14V66.54H398.77V53.42ZM406.27 55.29H400.64V64.67H406.27V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M414.71 54.36H407.21V65.61H414.71V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M406.27 53.42H415.64V66.54H406.27V53.42ZM413.76 55.29H408.14V64.67H413.76V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M407.21 73.1H399.71V84.35H407.21V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M398.77 72.16H408.14V85.28H398.77V72.16ZM406.27 74.03H400.64V83.41H406.27V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M414.71 73.1H407.21V84.35H414.71V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M406.27 72.16H415.64V85.28H406.27V72.16ZM413.76 74.03H408.14V83.41H413.76V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M407.21 84.34H399.71V95.59H407.21V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M398.77 83.41H408.14V96.53H398.77V83.41ZM406.27 85.28H400.64V94.67H406.27V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M414.71 84.34H407.21V95.59H414.71V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M406.27 83.41H415.64V96.53H406.27V83.41ZM413.76 85.28H408.14V94.67H413.76V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M392.21 35.61H399.71V28.11C399.71 27.618 399.613 27.1309 399.424 26.6765C399.236 26.2221 398.959 25.8093 398.611 25.4619C398.263 25.1145 397.849 24.8392 397.394 24.6518C396.939 24.4645 396.452 24.3687 395.96 24.37C395.468 24.3687 394.981 24.4645 394.526 24.6518C394.071 24.8392 393.657 25.1145 393.309 25.4619C392.961 25.8093 392.684 26.2221 392.496 26.6765C392.307 27.1309 392.21 27.618 392.21 28.11V35.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M391.27 28.11C391.326 26.9049 391.844 25.7676 392.716 24.9345C393.589 24.1013 394.749 23.6365 395.955 23.6365C397.161 23.6365 398.321 24.1013 399.194 24.9345C400.066 25.7676 400.584 26.9049 400.64 28.11V36.55H391.27V28.11ZM398.77 28.11C398.77 27.3647 398.474 26.65 397.947 26.123C397.42 25.596 396.705 25.3 395.96 25.3C395.215 25.3 394.5 25.596 393.973 26.123C393.446 26.65 393.15 27.3647 393.15 28.11V34.67H398.77V28.11Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M375.34 14.73V1.87H364.1V24.37L375.34 14.73Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1214.1 106.84H1255.33V31.87H1214.1V106.84Z",
  fill: "#F7DC6F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1214.1 106.84H1161.62V31.86L1187.86 9.37L1214.1 31.86V106.84Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1214.1 31.86H1255.34L1229.09 9.37H1187.86L1214.1 31.86Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1234.72 54.35H1242.22V43.1H1234.72V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1233.78 42.17H1243.15V55.29H1233.78V42.17ZM1241.27 44.05H1235.65V53.42H1241.27V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1227.21 54.35H1234.71V43.1H1227.21V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1226.28 42.17H1235.65V55.29H1226.28V42.17ZM1233.78 44.05H1228.15V53.42H1233.78V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1234.72 65.61H1242.22V54.36H1234.72V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1233.78 53.42H1243.15V66.54H1233.78V53.42ZM1241.27 55.29H1235.65V64.67H1241.27V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1227.21 65.61H1234.71V54.36H1227.21V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1226.28 53.42H1235.65V66.54H1226.28V53.42ZM1233.78 55.29H1228.15V64.67H1233.78V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1227.22 106.83H1242.21V73.0899H1227.22V106.83Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1226.28 72.16H1243.15V106.83H1226.28V72.16ZM1241.28 74.03H1228.16V106.83H1241.28V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1234.72 84.34H1242.22V73.09H1234.72V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1233.78 72.16H1243.15V85.28H1233.78V72.16ZM1241.27 74.03H1235.65V83.41H1241.27V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1227.21 84.34H1234.71V73.09H1227.21V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1226.28 72.16H1235.65V85.28H1226.28V72.16ZM1233.78 74.03H1228.15V83.41H1233.78V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1199.1 54.35H1206.6V43.1H1199.1V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1198.16 42.17H1207.54V55.29H1198.16V42.17ZM1205.66 44.05H1200.03V53.42H1205.65L1205.66 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1191.61 54.35H1199.11V43.1H1191.61V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1190.67 42.17H1200.03V55.29H1190.66L1190.67 42.17ZM1198.16 44.05H1192.54V53.42H1198.16V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1199.1 65.61H1206.6V54.36H1199.1V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1198.16 53.42H1207.54V66.54H1198.16V53.42ZM1205.66 55.29H1200.03V64.67H1205.65L1205.66 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1191.61 65.61H1199.11V54.36H1191.61V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1190.67 53.42H1200.03V66.54H1190.66L1190.67 53.42ZM1198.16 55.29H1192.54V64.67H1198.16V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1199.1 84.34H1206.6V73.09H1199.1V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1198.16 72.16H1207.54V85.28H1198.16V72.16ZM1205.66 74.03H1200.03V83.41H1205.65L1205.66 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1191.61 84.34H1199.11V73.09H1191.61V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1190.67 72.16H1200.03V85.28H1190.66L1190.67 72.16ZM1198.16 74.03H1192.54V83.41H1198.16V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1199.1 95.59H1206.6V84.34H1199.1V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1198.16 83.41H1207.54V96.53H1198.16V83.41ZM1205.66 85.28H1200.03V94.67H1205.65L1205.66 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1191.61 95.59H1199.11V84.34H1191.61V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1190.67 83.41H1200.03V96.53H1190.66L1190.67 83.41ZM1198.16 85.28H1192.54V94.67H1198.16V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1176.61 54.35H1184.11V43.1H1176.61V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1175.67 42.17H1185.03V55.29H1175.66L1175.67 42.17ZM1183.17 44.05H1177.55V53.42H1183.17V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1169.12 54.35H1176.62V43.1H1169.12V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1168.17 42.17H1177.55V55.29H1168.17V42.17ZM1175.67 44.05H1170.03V53.42H1175.65L1175.67 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1176.61 65.61H1184.11V54.36H1176.61V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1175.67 53.42H1185.03V66.54H1175.66L1175.67 53.42ZM1183.17 55.29H1177.55V64.67H1183.17V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1169.12 65.61H1176.62V54.36H1169.12V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1168.17 53.42H1177.55V66.54H1168.17V53.42ZM1175.67 55.29H1170.03V64.67H1175.65L1175.67 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1176.61 84.34H1184.11V73.09H1176.61V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1175.67 72.16H1185.03V85.28H1175.66L1175.67 72.16ZM1183.17 74.03H1177.55V83.41H1183.17V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1169.12 84.34H1176.62V73.09H1169.12V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1168.17 72.16H1177.55V85.28H1168.17V72.16ZM1175.67 74.03H1170.03V83.41H1175.65L1175.67 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1176.61 95.59H1184.11V84.34H1176.61V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1175.67 83.41H1185.03V96.53H1175.66L1175.67 83.41ZM1183.17 85.28H1177.55V94.67H1183.17V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1169.12 95.59H1176.62V84.34H1169.12V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1168.17 83.41H1177.55V96.53H1168.17V83.41ZM1175.67 85.28H1170.03V94.67H1175.65L1175.67 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1195.35 26.24H1180.36V33.74H1195.35V26.24Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1179.42 25.3H1196.29V34.67H1179.42V25.3ZM1194.42 27.18H1181.3V32.8H1194.42V27.18Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1221.6 22.49H1244.09V7.5L1232.84 0L1221.6 7.5V22.49Z",
  fill: "#F7DC6F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1210.35 13.12L1221.6 22.49V7.5H1210.35V13.12Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1221.6 7.5H1210.35L1221.6 0H1232.84L1221.6 7.5Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M272.72 54.36H231.49V106.84H272.72V54.36Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M231.49 54.35H272.72L306.46 26.24H265.22L231.49 54.35Z",
  fill: "#7F8C8D"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M272.72 54.35L306.46 26.24L340.2 54.35V106.84H272.72V54.35Z",
  fill: "#5FBB56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M291.47 69.35H283.97V80.6H291.47V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M283.03 68.41H292.4V81.53H283.03V68.41ZM290.52 70.29H284.9V79.67H290.52V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M298.96 69.35H291.46V80.6H298.96V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M290.52 68.41H299.89V81.53H290.52V68.41ZM298.02 70.29H292.4V79.67H298.03L298.02 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M298.96 80.6H291.46V91.85H298.96V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M290.52 79.67H299.89V92.79H290.52V79.67ZM298.02 81.54H292.4V90.91H298.03L298.02 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M291.47 80.6H283.97V91.85H291.47V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M283.03 79.67H292.4V92.79H283.03V79.67ZM290.52 81.54H284.9V90.91H290.52V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M321.46 69.35H313.96V80.6H321.46V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M313.03 68.41H322.41V81.53H313.03V68.41ZM320.53 70.29H314.91V79.67H320.53V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M328.95 69.35H321.45V80.6H328.95V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M320.51 68.41H329.88V81.53H320.51V68.41ZM328.01 70.29H322.39V79.67H328.03L328.01 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M328.95 80.6H321.45V91.85H328.95V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M320.51 79.67H329.88V92.79H320.51V79.67ZM328.01 81.54H322.39V90.91H328.03L328.01 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M321.46 80.6H313.96V91.85H321.46V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M313.03 79.67H322.41V92.79H313.03V79.67ZM320.53 81.54H314.91V90.91H320.53V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M244.61 106.83H259.6V69.3399H244.61V106.83Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M243.66 68.41H260.53V106.83H243.66V68.41ZM258.66 70.29H245.54V106.83H258.66V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M252.1 82.47H248.35V88.09H252.1V82.47Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M272.72 41.23H250.23V26.24L261.48 16.87L272.72 26.24V41.23Z",
  fill: "#5FBB56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M283.97 31.86L272.72 41.23V26.24H283.97V31.86Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M272.72 26.24H283.97L272.72 16.87H261.48L272.72 26.24Z",
  fill: "#7F8C8D"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M306.45 58.1C307.189 58.1013 307.921 57.9569 308.604 57.6751C309.287 57.3932 309.907 56.9795 310.43 56.4575C310.953 55.9355 311.368 55.3155 311.651 54.633C311.934 53.9505 312.08 53.2189 312.08 52.48C312.08 51.7411 311.934 51.0095 311.651 50.327C311.368 49.6445 310.953 49.0245 310.43 48.5025C309.907 47.9805 309.287 47.5668 308.604 47.2849C307.921 47.0031 307.189 46.8587 306.45 46.86C304.959 46.86 303.53 47.4521 302.476 48.5061C301.422 49.56 300.83 50.9895 300.83 52.48C300.83 53.9705 301.422 55.4 302.476 56.4539C303.53 57.5079 304.959 58.1 306.45 58.1Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M156.98 106.84L231.95 106.84V54.36L156.98 54.36V106.84Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M231.95 54.35H156.98L134.49 35.61H209.46L231.95 54.35Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M134.49 35.61L156.98 54.35V106.84H134.49H111.99V54.35L134.49 35.61Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M216.96 80.59H224.46V69.34H216.96V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M216.03 68.41H225.41V81.53H216.03V68.41ZM223.53 70.29H217.91V79.67H223.53V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M209.46 80.59H216.96V69.34H209.46V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M208.52 68.41H217.89V81.53H208.52V68.41ZM216.01 70.29H210.39V79.67H216.03L216.01 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M209.46 91.85H216.96V80.6H209.46V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M208.52 79.67H217.89V92.79H208.52V79.67ZM216.01 81.54H210.39V90.91H216.03L216.01 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M216.96 91.85H224.46V80.6H216.96V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M216.03 79.67H225.41V92.79H216.03V79.67ZM223.53 81.54H217.91V90.91H223.53V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M171.97 80.59H179.47V69.34H171.97V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M171.03 68.41H180.4V81.53H171.03V68.41ZM178.53 70.29H172.91V79.67H178.53V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M164.47 80.59H171.97V69.34H164.47V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M163.53 68.41H172.91V81.53H163.53V68.41ZM171.03 70.29H165.41V79.67H171.03V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M164.47 91.85H171.97V80.6H164.47V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M163.53 79.67H172.91V92.79H163.53V79.67ZM171.03 81.54H165.41V90.91H171.03V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M171.97 91.85H179.47V80.6H171.97V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M171.03 79.67H180.4V92.79H171.03V79.67ZM178.53 81.54H172.91V90.91H178.53V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M126.99 80.59H134.49V69.34H126.99V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M126.03 68.41H135.4V81.53H126.03V68.41ZM133.52 70.29H127.9V79.67H133.52V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M119.49 80.59H126.99V69.34H119.49V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M118.55 68.41H127.92V81.53H118.55V68.41ZM126.05 70.29H120.42V79.67H126.03L126.05 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M119.49 91.85H126.99V80.6H119.49V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M118.55 79.67H127.92V92.79H118.55V79.67ZM126.05 81.54H120.42V90.91H126.03L126.05 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M126.99 91.85H134.49V80.6H126.99V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M126.03 79.67H135.4V92.79H126.03V79.67ZM133.52 81.54H127.9V90.91H133.52V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M141.98 80.59H149.48V69.34H141.98V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M141.03 68.41H150.4V81.53H141.03V68.41ZM148.53 70.29H142.91V79.67H148.53V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M134.49 80.59H141.99V69.34H134.49V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M133.54 68.41H142.92V81.53H133.54V68.41ZM141.04 70.29H135.42V79.67H141.03L141.04 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M134.49 91.85H141.99V80.6H134.49V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M133.54 79.67H142.92V92.79H133.54V79.67ZM141.04 81.54H135.42V90.91H141.03L141.04 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M141.98 91.85H149.48V80.6H141.98V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M141.03 79.67H150.4V92.79H141.03V79.67ZM148.53 81.54H142.91V90.91H148.53V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M175.72 44.98H198.21V26.24L186.97 18.74L175.72 26.24V44.98Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M164.47 35.61L175.72 44.98V26.24H164.47V35.61Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M175.72 26.24H164.47L175.72 18.74H186.97L175.72 26.24Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M186.97 106.83H201.96V69.3399H186.97V106.83Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M186.03 68.41H202.89V106.83H186.03V68.41ZM201.03 70.29H187.9V106.83H201.03V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M194.47 84.34H190.72V89.96H194.47V84.34Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M130.74 59.98H138.24V52.48H130.74V59.98Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M129.8 51.54H139.17V60.91H129.8V51.54ZM137.29 53.42H131.67V59.04H137.29V53.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M183.22 37.48H190.72V29.98H183.22V37.48Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M182.28 29.05H191.65V38.42H182.28V29.05ZM189.77 30.93H184.15V36.55H189.77V30.93Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M800.81 106.84H830.8V58.11L800.81 58.11V106.84Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M830.8 58.1H800.81L774.57 35.61H804.56L830.8 58.1Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M748.33 59.98L774.57 35.61L800.81 58.1V106.84H748.33V59.98Z",
  fill: "#DF7430"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M815.81 80.59H823.31V69.34H815.81V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M814.87 68.41H824.24V81.53H814.87V68.41ZM822.36 70.29H816.74V79.67H822.36V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M808.3 80.59H815.8V69.34H808.3V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M807.37 68.41H816.74V81.53H807.37V68.41ZM814.87 70.29H809.24V79.67H814.87V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M808.3 91.85H815.8V80.6H808.3V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M807.37 79.67H816.74V92.79H807.37V79.67ZM814.87 81.54H809.24V90.91H814.87V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M815.81 91.85H823.31V80.6H815.81V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M814.87 79.67H824.24V92.79H814.87V79.67ZM822.36 81.54H816.74V90.91H822.36V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M785.82 80.59H793.32V69.34H785.82V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M784.88 68.41H794.25V81.53H784.88V68.41ZM792.37 70.29H786.75V79.67H792.37V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M778.32 80.59H785.82V69.34H778.32V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M777.38 68.41H786.75V81.53H777.38V68.41ZM784.88 70.29H779.25V79.67H784.88V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M778.32 91.85H785.82V80.6H778.32V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M777.38 79.67H786.75V92.79H777.38V79.67ZM784.88 81.54H779.25V90.91H784.88V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M785.82 91.85H793.32V80.6H785.82V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M784.88 79.67H794.25V92.79H784.88V79.67ZM792.37 81.54H786.75V90.91H792.37V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M793.32 26.24H804.56V46.86L793.32 37.22V26.24Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M830.8 106.84H860.79V84.35H830.8V106.84Z",
  fill: "#DF7430"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M830.8 73.1L860.79 84.34H830.8V73.1Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M845.8 99.34H853.3V91.84H845.8V99.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M844.86 90.9H854.23V100.27H844.86V90.9ZM852.35 92.78H846.73V98.4H852.35V92.78Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M838.29 99.34H845.79V91.84H838.29V99.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M837.36 90.9H846.73V100.27H837.36V90.9ZM844.86 92.78H839.23V98.4H844.86V92.78Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M755.83 106.83H770.82V69.3399H755.83V106.83Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M754.89 68.41H771.76V106.83H754.89V68.41ZM769.89 70.29H756.76V106.83H769.88L769.89 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M763.33 83.41H759.58V89.03H763.33V83.41Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M770.82 61.85H778.32V50.6H770.82V61.85Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M504.21 54.36H444.23V106.84H504.21V54.36Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M444.23 54.35H504.21L519.2 31.86H459.22L444.23 54.35Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M519.2 31.86L504.21 54.35V106.84H534.2V54.35L519.2 31.86Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M459.23 69.35H451.73V80.6H459.23V69.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M450.78 68.41H460.16V81.53H450.78V68.41ZM458.28 70.29H452.66V79.67H458.28V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M496.71 69.35H489.21V80.6H496.71V69.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M488.27 68.41H497.64V81.53H488.27V68.41ZM495.77 70.29H490.15V79.67H495.77V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M496.71 80.6H489.21V91.85H496.71V80.6Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M488.27 79.67H497.64V92.79H488.27V79.67ZM495.77 81.54H490.15V90.91H495.77V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M459.23 80.6H451.73V91.85H459.23V80.6Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M450.78 79.67H460.16V92.79H450.78V79.67ZM458.28 81.54H452.66V90.91H458.28V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M519.2 69.35H511.7V80.6H519.2V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M510.76 68.41H520.13V81.53H510.76V68.41ZM518.26 70.29H512.64V79.67H518.26V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M526.7 69.35H519.2V80.6H526.7V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M518.26 68.41H527.63V81.53H518.26V68.41ZM525.76 70.29H520.13V79.67H525.76V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M526.7 80.6H519.2V91.85H526.7V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M518.26 79.67H527.63V92.79H518.26V79.67ZM525.76 81.54H520.13V90.91H525.76V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M519.2 80.6H511.7V91.85H519.2V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M510.76 79.67H520.13V92.79H510.76V79.67ZM518.26 81.54H512.64V90.91H518.26V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M466.72 106.83H481.71V69.3399H466.72V106.83Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M465.78 68.41H482.65V106.83H465.78V68.41ZM480.78 70.29H467.65V106.83H480.77L480.78 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M474.22 84.34H470.47V89.96H474.22V84.34Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M522.95 50.61H515.45V58.11H522.95V50.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M514.51 49.67H523.88V59.04H514.51V49.67ZM522.01 51.54H516.39V57.17H522.03L522.01 51.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M421.74 106.84H444.23V84.35H421.74V106.84Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M444.23 84.34H421.74L444.23 69.35V84.34Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M429.23 99.34H436.73V91.84H429.23V99.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M428.29 90.9H437.66V100.27H428.29V90.9ZM435.79 92.78H430.17V98.4H435.79V92.78Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M487.34 20.62H498.58V31.86L487.34 48.73V20.62Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M466.72 20.62H477.97V31.86L466.72 48.73V20.62Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1316.25 54.36H1256.27V106.84H1316.25V54.36Z",
  fill: "#BF2929"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1256.27 54.35H1316.25L1338.74 35.61H1278.76L1256.27 54.35Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1338.74 35.61L1316.25 54.35V106.84H1338.74H1361.23V54.35L1338.74 35.61Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1290.01 69.35H1282.51V80.6H1290.01V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1281.57 68.41H1290.94V81.53H1281.57V68.41ZM1289.07 70.29H1283.45V79.67H1289.03L1289.07 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1290.01 80.6H1282.51V91.85H1290.01V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1281.57 79.67H1290.94V92.79H1281.57V79.67ZM1289.07 81.54H1283.45V90.91H1289.03L1289.07 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1306.88 69.35H1299.38V80.6H1306.88V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1298.44 68.41H1307.81V81.53H1298.44V68.41ZM1305.94 70.29H1300.31V79.67H1305.94V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1306.88 80.6H1299.38V91.85H1306.88V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1298.44 79.67H1307.81V92.79H1298.44V79.67ZM1305.94 81.54H1300.31V90.91H1305.94V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1273.14 69.35H1265.64V80.6H1273.14V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1264.7 68.41H1274.03V81.53H1264.66L1264.7 68.41ZM1272.2 70.29H1266.58V79.67H1272.2V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1273.14 80.6H1265.64V91.85H1273.14V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1264.7 79.67H1274.03V92.79H1264.66L1264.7 79.67ZM1272.2 81.54H1266.58V90.91H1272.2V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1346.23 69.35H1331.24V106.84H1346.23V69.35Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1330.3 68.41H1347.17V106.83H1330.3V68.41ZM1345.3 70.29H1332.18V106.83H1345.3V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1342.49 84.34H1338.74V89.96H1342.49V84.34Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1301.26 44.98H1278.76V26.24L1290.01 18.74L1301.26 26.24V44.98Z",
  fill: "#BF2929"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1312.5 35.61L1301.26 44.98V26.24H1312.5V35.61Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1301.26 26.24H1312.5L1301.26 18.74H1290.01L1301.26 26.24Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1342.49 52.48H1334.99V59.98H1342.49V52.48Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1334.03 51.54H1343.4V60.91H1334.03V51.54ZM1341.53 53.42H1335.91V59.04H1341.53V53.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1293.76 29.99H1286.26V37.49H1293.76V29.99Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1285.32 29.05H1294.69V38.42H1285.32V29.05ZM1292.82 30.93H1287.19V36.55H1292.82V30.93Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1814.82 31.86H1762.34V106.83H1814.82V31.86Z",
  fill: "#DF7430"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1814.82 106.84H1867.3V31.86L1841.06 9.37L1814.82 31.86V106.84Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1814.82 31.86H1762.34L1788.58 9.37H1841.06L1814.82 31.86Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1799.83 43.11H1792.33V54.36H1799.83V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1791.38 42.17H1800.76V55.29H1791.38V42.17ZM1798.88 44.05H1793.26V53.42H1798.88V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1807.32 43.11H1799.82V54.36H1807.32V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1798.88 42.17H1808.25V55.29H1798.88V42.17ZM1806.38 44.05H1800.76V53.42H1806.38V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1799.83 54.36H1792.33V65.61H1799.83V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1791.38 53.42H1800.76V66.54H1791.38V53.42ZM1798.88 55.29H1793.26V64.67H1798.88V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1807.32 54.36H1799.82V65.61H1807.32V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1798.88 53.42H1808.25V66.54H1798.88V53.42ZM1806.38 55.29H1800.76V64.67H1806.38V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1799.83 73.1H1792.33V84.35H1799.83V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1791.38 72.16H1800.76V85.28H1791.38V72.16ZM1798.88 74.03H1793.26V83.41H1798.88V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1807.32 73.1H1799.82V84.35H1807.32V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1798.88 72.16H1808.25V85.28H1798.88V72.16ZM1806.38 74.03H1800.76V83.41H1806.38V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1799.83 84.34H1792.33V95.59H1799.83V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1791.38 83.41H1800.76V96.53H1791.38V83.41ZM1798.88 85.28H1793.26V94.67H1798.88V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1807.32 84.34H1799.82V95.59H1807.32V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1798.88 83.41H1808.25V96.53H1798.88V83.41ZM1806.38 85.28H1800.76V94.67H1806.38V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1777.33 43.11H1769.83V54.36H1777.33V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1768.89 42.17H1778.26V55.29H1768.89V42.17ZM1776.39 44.05H1770.77V53.42H1776.39V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1784.83 43.11H1777.33V54.36H1784.83V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1776.39 42.17H1785.76V55.29H1776.39V42.17ZM1783.89 44.05H1778.26V53.42H1783.89V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1777.33 54.36H1769.83V65.61H1777.33V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1768.89 53.42H1778.26V66.54H1768.89V53.42ZM1776.39 55.29H1770.77V64.67H1776.39V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1784.83 54.36H1777.33V65.61H1784.83V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1776.39 53.42H1785.76V66.54H1776.39V53.42ZM1783.89 55.29H1778.26V64.67H1783.89V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1777.33 73.1H1769.83V84.35H1777.33V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1768.89 72.16H1778.26V85.28H1768.89V72.16ZM1776.39 74.03H1770.77V83.41H1776.39V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1784.83 73.1H1777.33V84.35H1784.83V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1776.39 72.16H1785.76V85.28H1776.39V72.16ZM1783.89 74.03H1778.26V83.41H1783.89V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1777.33 84.34H1769.83V95.59H1777.33V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1768.89 83.41H1778.26V96.53H1768.89V83.41ZM1776.39 85.28H1770.77V94.67H1776.39V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1784.83 84.34H1777.33V95.59H1784.83V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1776.39 83.41H1785.76V96.53H1776.39V83.41ZM1783.89 85.28H1778.26V94.67H1783.89V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1829.82 43.11H1822.32V54.36H1829.82V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1821.37 42.17H1830.75V55.29H1821.37V42.17ZM1828.87 44.05H1823.25V53.42H1828.87V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1837.31 43.11H1829.81V54.36H1837.31V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1828.87 42.17H1838.24V55.29H1828.87V42.17ZM1836.37 44.05H1830.75V53.42H1836.37V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1829.82 54.36H1822.32V65.61H1829.82V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1821.37 53.42H1830.75V66.54H1821.37V53.42ZM1828.87 55.29H1823.25V64.67H1828.87V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1837.31 54.36H1829.81V65.61H1837.31V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1828.87 53.42H1838.24V66.54H1828.87V53.42ZM1836.37 55.29H1830.75V64.67H1836.37V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1852.31 43.11H1844.81V54.36H1852.31V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1843.87 42.17H1853.24V55.29H1843.87V42.17ZM1851.36 44.05H1845.74V53.42H1851.36V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1859.8 43.11H1852.3V54.36H1859.8V43.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1851.36 42.17H1860.73V55.29H1851.36V42.17ZM1858.86 44.05H1853.24V53.42H1858.86V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1852.31 54.36H1844.81V65.61H1852.31V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1843.87 53.42H1853.24V66.54H1843.87V53.42ZM1851.36 55.29H1845.74V64.67H1851.36V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1859.8 54.36H1852.3V65.61H1859.8V54.36Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1851.36 53.42H1860.73V66.54H1851.36V53.42ZM1858.86 55.29H1853.24V64.67H1858.86V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1852.31 73.1H1844.81V84.35H1852.31V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1843.87 72.16H1853.24V85.28H1843.87V72.16ZM1851.36 74.03H1845.74V83.41H1851.36V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1859.8 73.1H1852.3V84.35H1859.8V73.1Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1851.36 72.16H1860.73V85.28H1851.36V72.16ZM1858.86 74.03H1853.24V83.41H1858.86V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1852.31 84.34H1844.81V95.59H1852.31V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1843.87 83.41H1853.24V96.53H1843.87V83.41ZM1851.36 85.28H1845.74V94.67H1851.36V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1859.8 84.34H1852.3V95.59H1859.8V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1851.36 83.41H1860.73V96.53H1851.36V83.41ZM1858.86 85.28H1853.24V94.67H1858.86V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1837.31 35.61H1844.8V28.11C1844.8 27.618 1844.7 27.1309 1844.51 26.6765C1844.33 26.2221 1844.05 25.8093 1843.7 25.4619C1843.35 25.1145 1842.94 24.8392 1842.48 24.6518C1842.03 24.4645 1841.54 24.3687 1841.05 24.37C1840.56 24.3687 1840.07 24.4645 1839.62 24.652C1839.16 24.8395 1838.75 25.1149 1838.4 25.4625C1838.05 25.81 1837.78 26.2229 1837.59 26.6772C1837.4 27.1316 1837.31 27.6185 1837.31 28.11V35.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1836.37 28.11C1836.43 26.9049 1836.94 25.7676 1837.82 24.9345C1838.69 24.1013 1839.85 23.6365 1841.06 23.6365C1842.26 23.6365 1843.42 24.1013 1844.29 24.9345C1845.17 25.7676 1845.68 26.9049 1845.74 28.11V36.55H1836.37V28.11ZM1843.87 28.11C1843.83 27.3924 1843.51 26.7182 1842.99 26.2253C1842.47 25.7323 1841.77 25.4578 1841.06 25.4578C1840.34 25.4578 1839.64 25.7323 1839.12 26.2253C1838.6 26.7182 1838.28 27.3924 1838.24 28.11V34.67H1843.87V28.11Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1805.45 14.73V1.87H1794.2V24.37L1805.45 14.73Z",
  fill: "#FF8537"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1837.31 73.1H1822.32V106.84H1837.31V73.1Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1821.37 72.16H1838.24V106.83H1821.37V72.16ZM1836.37 74.03H1823.25V106.83H1836.37V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1829.81 86.22H1826.06V91.84H1829.81V86.22Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1921.65 52.48H1869.17V106.84H1921.65V52.48Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1921.65 106.84H1974.13V52.48L1947.89 29.99L1921.65 52.48V106.84Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1921.65 52.48H1869.17L1895.41 29.99H1947.89L1921.65 52.48Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1906.66 69.35H1899.16V80.6H1906.66V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1898.22 68.41H1907.59V81.53H1898.22V68.41ZM1905.72 70.29H1900.1V79.67H1905.72V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1914.16 69.35H1906.66V80.6H1914.16V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1905.72 68.41H1915.09V81.53H1905.72V68.41ZM1913.22 70.29H1907.59V79.67H1913.22V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1906.66 80.6H1899.16V91.85H1906.66V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1898.22 79.67H1907.59V92.79H1898.22V79.67ZM1905.72 81.54H1900.1V90.91H1905.72V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1914.16 80.6H1906.66V91.85H1914.16V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1905.72 79.67H1915.09V92.79H1905.72V79.67ZM1913.22 81.54H1907.59V90.91H1913.22V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1884.17 69.35H1876.67V80.6H1884.17V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1875.73 68.41H1885.1V81.53H1875.73V68.41ZM1883.23 70.29H1877.6V79.67H1883.23V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1891.67 69.35H1884.17V80.6H1891.67V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1883.23 68.41H1892.6V81.53H1883.23V68.41ZM1890.72 70.29H1885.1V79.67H1890.72V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1884.17 80.6H1876.67V91.85H1884.17V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1875.73 79.67H1885.1V92.79H1875.73V79.67ZM1883.23 81.54H1877.6V90.91H1883.23V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1891.67 80.6H1884.17V91.85H1891.67V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1883.23 79.67H1892.6V92.79H1883.23V79.67ZM1890.72 81.54H1885.1V90.91H1890.72V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1959.14 69.35H1951.64V80.6H1959.14V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1950.7 68.41H1960.03V81.53H1950.66L1950.7 68.41ZM1958.2 70.29H1952.58V79.67H1958.2V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1966.64 69.35H1959.14V80.6H1966.64V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1958.2 68.41H1967.57V81.53H1958.2V68.41ZM1965.7 70.29H1960.03V79.67H1965.66L1965.7 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1959.14 80.6H1951.64V91.85H1959.14V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1950.7 79.67H1960.03V92.79H1950.66L1950.7 79.67ZM1958.2 81.54H1952.58V90.91H1958.2V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1966.64 80.6H1959.14V91.85H1966.64V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1958.2 79.67H1967.57V92.79H1958.2V79.67ZM1965.7 81.54H1960.03V90.91H1965.66L1965.7 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1944.14 56.23H1951.64V48.73C1951.64 47.7354 1951.24 46.7816 1950.54 46.0783C1949.84 45.3751 1948.88 44.98 1947.89 44.98C1946.9 44.98 1945.94 45.3751 1945.24 46.0783C1944.54 46.7816 1944.14 47.7354 1944.14 48.73V56.23Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1943.2 48.73C1943.2 47.4862 1943.69 46.2933 1944.57 45.4137C1945.45 44.5342 1946.65 44.04 1947.89 44.04C1949.13 44.04 1950.33 44.5342 1951.21 45.4137C1952.09 46.2933 1952.58 47.4862 1952.58 48.73V57.17H1943.2V48.73ZM1950.7 48.73C1950.7 47.9848 1950.4 47.27 1949.88 46.7431C1949.35 46.2161 1948.64 45.92 1947.89 45.92C1947.14 45.92 1946.43 46.2161 1945.9 46.7431C1945.38 47.27 1945.08 47.9848 1945.08 48.73V55.29H1950.7V48.73Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1944.14 69.35H1929.15V106.84H1944.14V69.35Z",
  fill: "#5FBB56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1928.21 68.41H1945.08V106.83H1928.21V68.41ZM1943.21 70.29H1930.09V106.83H1943.21V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1936.65 84.34H1932.9V89.96H1936.65V84.34Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1914.16 43.11H1891.66V28.11L1902.91 18.74L1914.16 28.11V43.11Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1925.4 33.74L1914.16 43.11V28.11H1925.4V33.74Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1914.16 28.11H1925.4L1914.16 18.74H1902.91L1914.16 28.11Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M935.76 106.83H969.5V33.7299H935.76V106.83Z",
  fill: "#6163C7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M887.03 11.25H909.52L935.76 33.74V106.84H860.79V33.74L887.03 11.25Z",
  fill: "#5557AE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M935.76 33.74H969.5L943.26 11.25H909.52L935.76 33.74Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M952.63 54.35H960.13V43.1H952.63V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M951.69 42.17H961.03V55.29H951.66L951.69 42.17ZM959.19 44.05H953.57V53.42H959.19V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M945.13 54.35H952.63V43.1H945.13V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M944.19 42.17H953.57V55.29H944.19V42.17ZM951.69 44.05H946.03V53.42H951.65L951.69 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M952.63 65.61H960.13V54.36H952.63V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M951.69 53.42H961.03V66.54H951.66L951.69 53.42ZM959.19 55.29H953.57V64.67H959.19V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M945.13 65.61H952.63V54.36H945.13V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M944.19 53.42H953.57V66.54H944.19V53.42ZM951.69 55.29H946.03V64.67H951.65L951.69 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M952.63 84.34H960.13V73.09H952.63V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M951.69 72.16H961.03V85.28H951.66L951.69 72.16ZM959.19 74.03H953.57V83.41H959.19V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M945.13 84.34H952.63V73.09H945.13V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M944.19 72.16H953.57V85.28H944.19V72.16ZM951.69 74.03H946.03V83.41H951.65L951.69 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M952.63 95.59H960.13V84.34H952.63V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M951.69 83.41H961.03V96.53H951.66L951.69 83.41ZM959.19 85.28H953.57V94.67H959.19V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M945.13 95.59H952.63V84.34H945.13V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M944.19 83.41H953.57V96.53H944.19V83.41ZM951.69 85.28H946.03V94.67H951.65L951.69 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M890.78 106.83H905.77V73.0899H890.78V106.83Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 72.16H906.71V106.83H889.84V72.16ZM904.84 74.03H891.71V106.83H904.83L904.84 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M898.28 84.34H905.78V73.09H898.28V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M897.34 72.16H906.71V85.28H897.34V72.16ZM904.83 74.03H899.21V83.41H904.83V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M890.77 84.34H898.27V73.09H890.77V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 72.16H899.21V85.28H889.84V72.16ZM897.34 74.03H891.71V83.41H897.34V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M920.76 54.35H928.26V43.1H920.76V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M919.83 42.17H929.2V55.29H919.83V42.17ZM927.33 44.05H921.7V53.42H927.33V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M913.27 54.35H920.77V43.1H913.27V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M912.33 42.17H921.7V55.29H912.33V42.17ZM919.83 44.05H914.21V53.42H919.83V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M920.76 65.61H928.26V54.36H920.76V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M919.83 53.42H929.2V66.54H919.83V53.42ZM927.33 55.29H921.7V64.67H927.33V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M913.27 65.61H920.77V54.36H913.27V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M912.33 53.42H921.7V66.54H912.33V53.42ZM919.83 55.29H914.21V64.67H919.83V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M920.76 84.34H928.26V73.09H920.76V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M919.83 72.16H929.2V85.28H919.83V72.16ZM927.33 74.03H921.7V83.41H927.33V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M913.27 84.34H920.77V73.09H913.27V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M912.33 72.16H921.7V85.28H912.33V72.16ZM919.83 74.03H914.21V83.41H919.83V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M920.76 95.59H928.26V84.34H920.76V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M919.83 83.41H929.2V96.53H919.83V83.41ZM927.33 85.28H921.7V94.67H927.33V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M913.27 95.59H920.77V84.34H913.27V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M912.33 83.41H921.7V96.53H912.33V83.41ZM919.83 85.28H914.21V94.67H919.83V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M898.28 54.35H905.78V43.1H898.28V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M897.34 42.17H906.71V55.29H897.34V42.17ZM904.83 44.05H899.21V53.42H904.83V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M890.77 54.35H898.27V43.1H890.77V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 42.17H899.21V55.29H889.84V42.17ZM897.34 44.05H891.71V53.42H897.34V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M898.28 65.61H905.78V54.36H898.28V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M897.34 53.42H906.71V66.54H897.34V53.42ZM904.83 55.29H899.21V64.67H904.83V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M890.77 65.61H898.27V54.36H890.77V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 53.42H899.21V66.54H889.84V53.42ZM897.34 55.29H891.71V64.67H897.34V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M875.78 54.35H883.28V43.1H875.78V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M874.84 42.17H884.22V55.29H874.84V42.17ZM882.34 44.05H876.72V53.42H882.34V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M868.29 54.35H875.79V43.1H868.29V54.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M867.35 42.17H876.72V55.29H867.35V42.17ZM874.84 44.05H869.22V53.42H874.84V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M875.78 65.61H883.28V54.36H875.78V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M874.84 53.42H884.22V66.54H874.84V53.42ZM882.34 55.29H876.72V64.67H882.34V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M868.29 65.61H875.79V54.36H868.29V65.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M867.35 53.42H876.72V66.54H867.35V53.42ZM874.84 55.29H869.22V64.67H874.84V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M875.78 84.34H883.28V73.09H875.78V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M874.84 72.16H884.22V85.28H874.84V72.16ZM882.34 74.03H876.72V83.41H882.34V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M868.29 84.34H875.79V73.09H868.29V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M867.35 72.16H876.72V85.28H867.35V72.16ZM874.84 74.03H869.22V83.41H874.84V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M875.78 95.59H883.28V84.34H875.78V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M874.84 83.41H884.22V96.53H874.84V83.41ZM882.34 85.28H876.72V94.67H882.34V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M868.29 95.59H875.79V84.34H868.29V95.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M867.35 83.41H876.72V96.53H867.35V83.41ZM874.84 85.28H869.22V94.67H874.84V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M905.78 20.62H898.28V28.12H905.78V20.62Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M897.34 19.67H906.71V29.04H897.34V19.67ZM904.83 21.54H899.21V27.17H904.83V21.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M905.78 28.11H898.28V35.61H905.78V28.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M897.34 27.1801H906.71V36.5501H897.34V27.1801ZM904.83 29.0501H899.21V34.6701H904.83V29.0501Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M898.28 20.62H890.78V28.12H898.28V20.62Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 19.67H899.21V29.04H889.84V19.67ZM897.34 21.54H891.71V27.17H897.34V21.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M898.28 28.11H890.78V35.61H898.28V28.11Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M889.84 27.1801H899.21V36.5501H889.84V27.1801ZM897.34 29.0501H891.71V34.6701H897.34V29.0501Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1003.24 59.98H969.5V106.84H1003.24V59.98Z",
  fill: "#B5930B"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1051.97 37.49H1029.48L1003.24 59.98V106.84H1078.21V59.98L1051.97 37.49Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1003.24 59.98H969.5L995.74 37.49H1029.48L1003.24 59.98Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1040.73 73.1H1033.23V84.35H1040.73V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1032.29 72.16H1041.66V85.28H1032.29V72.16ZM1039.78 74.03H1034.16V83.41H1039.78V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1048.23 73.1H1040.73V84.35H1048.23V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1039.78 72.16H1049.16V85.28H1039.78V72.16ZM1047.28 74.03H1041.66V83.41H1047.28V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1040.73 84.34H1033.23V95.59H1040.73V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1032.29 83.41H1041.66V96.53H1032.29V83.41ZM1039.78 85.28H1034.16V94.67H1039.78V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1048.23 84.34H1040.73V95.59H1048.23V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1039.78 83.41H1049.16V96.53H1039.78V83.41ZM1047.28 85.28H1041.66V94.67H1047.28V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M993.86 73.1H978.87V106.84H993.86V73.1Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M977.93 72.16H994.8V106.83H977.93V72.16ZM992.93 74.03H979.81V106.83H992.93V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M986.37 73.1H978.87V84.35H986.37V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M977.93 72.16H987.3V85.28H977.93V72.16ZM985.43 74.03H979.81V83.41H985.43V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M993.87 73.1H986.37V84.35H993.87V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M985.43 72.16H994.8V85.28H985.43V72.16ZM992.93 74.03H987.3V83.41H992.93V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1018.24 73.1H1010.74V84.35H1018.24V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1009.8 72.16H1019.17V85.28H1009.8V72.16ZM1017.29 74.03H1011.67V83.41H1017.29V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1025.73 73.1H1018.23V84.35H1025.73V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1017.29 72.16H1026.66V85.28H1017.29V72.16ZM1024.79 74.03H1019.17V83.41H1024.79V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1018.24 84.34H1010.74V95.59H1018.24V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1009.8 83.41H1019.17V96.53H1009.8V83.41ZM1017.29 85.28H1011.67V94.67H1017.29V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1025.73 84.34H1018.23V95.59H1025.73V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1017.29 83.41H1026.66V96.53H1017.29V83.41ZM1024.79 85.28H1019.17V94.67H1024.79V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1063.22 73.1H1055.72V84.35H1063.22V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1054.78 72.16H1064.15V85.28H1054.78V72.16ZM1062.28 74.03H1056.65V83.41H1062.28V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1070.72 73.1H1063.22V84.35H1070.72V73.1Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1062.28 72.16H1071.65V85.28H1062.28V72.16ZM1069.77 74.03H1064.15V83.41H1069.77V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1063.22 84.34H1055.72V95.59H1063.22V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1054.78 83.41H1064.15V96.53H1054.78V83.41ZM1062.28 85.28H1056.65V94.67H1062.28V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1070.72 84.34H1063.22V95.59H1070.72V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1062.28 83.41H1071.65V96.53H1062.28V83.41ZM1069.77 85.28H1064.15V94.67H1069.77V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1040.73 52.48H1033.23V59.98H1040.73V52.48Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1032.29 51.54H1041.66V60.91H1032.29V51.54ZM1039.78 53.42H1034.16V59.04H1039.78V53.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1048.23 52.48H1040.73V59.98H1048.23V52.48Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1039.78 51.54H1049.16V60.91H1039.78V51.54ZM1047.28 53.42H1041.66V59.04H1047.28V53.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M995.74 31.86H1006.99V42.84L995.74 52.48V31.86Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M993.88 31.86L1008.87 31.86V24.36H993.88V31.86Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1728.59 106.84H1762.33V54.36L1728.59 54.36V106.84Z",
  fill: "#F9BE19"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1762.34 54.35H1691.11L1672.37 31.86H1743.59L1762.34 54.35Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1709.86 31.86L1728.6 54.35V106.84H1691.11V54.35L1709.86 31.86Z",
  fill: "#D39C16"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1713.6 80.59H1721.1V69.34H1713.6V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1712.66 68.41H1722.03V81.53H1712.65L1712.66 68.41ZM1720.16 70.29H1714.54V79.67H1720.16V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1706.11 80.59H1713.61V69.34H1706.11V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1705.17 68.41H1714.54V81.53H1705.17V68.41ZM1712.66 70.29H1707.03V79.67H1712.65L1712.66 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1706.11 91.85H1713.61V80.6H1706.11V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1705.17 79.67H1714.54V92.79H1705.17V79.67ZM1712.66 81.54H1707.03V90.91H1712.65L1712.66 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1698.6 80.59H1706.1V69.34H1698.6V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1697.67 68.41H1707.03V81.53H1697.66L1697.67 68.41ZM1705.17 70.29H1699.54V79.67H1705.17V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1698.6 91.85H1706.1V80.6H1698.6V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1697.67 79.67H1707.03V92.79H1697.66L1697.67 79.67ZM1705.17 81.54H1699.54V90.91H1705.17V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1713.6 91.85H1721.1V80.6H1713.6V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1712.66 79.67H1722.03V92.79H1712.65L1712.66 79.67ZM1720.16 81.54H1714.54V90.91H1720.16V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1709.86 59.98C1712.96 59.98 1715.48 57.4638 1715.48 54.36C1715.48 51.2561 1712.96 48.74 1709.86 48.74C1706.76 48.74 1704.24 51.2561 1704.24 54.36C1704.24 57.4638 1706.76 59.98 1709.86 59.98Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1672.37 31.86L1691.11 54.35V106.84H1653.63V54.35L1672.37 31.86Z",
  fill: "#F9BE19"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1676.12 80.59H1683.62V69.34H1676.12V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1675.18 68.41H1684.55V81.53H1675.18V68.41ZM1682.67 70.29H1677.03V79.67H1682.65L1682.67 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1668.62 80.59H1676.12V69.34H1668.62V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1667.68 68.41H1677.03V81.53H1667.66L1667.68 68.41ZM1675.18 70.29H1669.55V79.67H1675.18V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1668.62 91.85H1676.12V80.6H1668.62V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1667.68 79.67H1677.03V92.79H1667.66L1667.68 79.67ZM1675.18 81.54H1669.55V90.91H1675.18V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1661.12 80.59H1668.62V69.34H1661.12V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1660.18 68.41H1669.55V81.53H1660.18V68.41ZM1667.68 70.29H1662.03V79.67H1667.65L1667.68 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1661.12 91.85H1668.62V80.6H1661.12V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1660.18 79.67H1669.55V92.79H1660.18V79.67ZM1667.68 81.54H1662.03V90.91H1667.65L1667.68 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1676.12 91.85H1683.62V80.6H1676.12V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1675.18 79.67H1684.55V92.79H1675.18V79.67ZM1682.67 81.54H1677.03V90.91H1682.65L1682.67 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1672.37 59.98C1675.47 59.98 1677.99 57.4638 1677.99 54.36C1677.99 51.2561 1675.47 48.74 1672.37 48.74C1669.27 48.74 1666.75 51.2561 1666.75 54.36C1666.75 57.4638 1669.27 59.98 1672.37 59.98Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1724.85 31.49V22.49H1736.1V44.98L1724.85 31.49Z",
  fill: "#F9BE19"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1722.98 22.5L1737.97 22.5V15L1722.98 15V22.5Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1737.97 106.83H1752.96V69.3399H1737.97V106.83Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1737.03 68.41H1753.9V106.83H1737.03V68.41ZM1752.03 70.29H1738.91V106.83H1752.03V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1745.47 80.59H1752.97V69.34H1745.47V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1744.53 68.41H1753.9V81.53H1744.53V68.41ZM1752.02 70.29H1746.4V79.67H1752.03L1752.02 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1737.97 80.59H1745.47V69.34H1737.97V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1737.03 68.41H1746.4V81.53H1737.03V68.41ZM1744.53 70.29H1738.9V79.67H1744.53V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M0 54.35L37.49 26.24L74.97 54.35V106.84H0V54.35Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M74.97 106.84H112.46V54.36L74.97 54.36V106.84Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M112.46 54.35H74.97L37.49 26.24H74.97L112.46 54.35Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M93.71 80.59H101.21V69.34H93.71V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M92.77 68.41H102.15V81.53H92.77V68.41ZM100.27 70.29H94.65V79.67H100.27V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M86.22 80.59H93.72V69.34H86.22V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M85.28 68.41H94.65V81.53H85.28V68.41ZM92.77 70.29H87.15V79.67H92.77V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M86.22 91.85H93.72V80.6H86.22V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M85.28 79.67H94.65V92.79H85.28V79.67ZM92.77 81.54H87.15V90.91H92.77V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M93.71 91.85H101.21V80.6H93.71V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M92.77 79.67H102.15V92.79H92.77V79.67ZM100.27 81.54H94.65V90.91H100.27V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M59.98 80.59H67.48V69.34H59.98V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M59.03 68.41H68.4V81.53H59.03V68.41ZM66.52 70.29H60.91V79.67H66.53L66.52 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M52.47 80.59H59.97V69.34H52.47V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M51.54 68.41H60.91V81.53H51.54V68.41ZM59.04 70.29H53.41V79.67H59.03L59.04 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M52.47 91.85H59.97V80.6H52.47V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M51.54 79.67H60.91V92.79H51.54V79.67ZM59.04 81.54H53.41V90.91H59.03L59.04 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M59.98 91.85H67.48V80.6H59.98V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M59.03 79.67H68.4V92.79H59.03V79.67ZM66.52 81.54H60.91V90.91H66.53L66.52 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14.99 80.59H22.49V69.34H14.99L14.99 80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14.03 68.41H23.4V81.53H14.03V68.41ZM21.53 70.29H15.93V79.67H21.55L21.53 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M7.5 80.59H15L15 69.34H7.5L7.5 80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M6.56 68.41H15.93V81.53H6.56V68.41ZM14.03 70.29H8.43V79.67H14.03V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M7.5 91.85H15L15 80.6H7.5L7.5 91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M6.56 79.67H15.93V92.79H6.56V79.67ZM14.03 81.53H8.43V90.9H14.03V81.53Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14.99 91.85H22.49V80.6H14.99L14.99 91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M14.03 79.67H23.4V92.79H14.03V79.67ZM21.53 81.54H15.93V90.91H21.55L21.53 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M37.49 58.1C40.5938 58.1 43.11 55.5838 43.11 52.48C43.11 49.3761 40.5938 46.86 37.49 46.86C34.3862 46.86 31.87 49.3761 31.87 52.48C31.87 55.5838 34.3862 58.1 37.49 58.1Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M80.6 44.05L69.35 35.61V18.74H80.6V44.05Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M30 106.83H44.99L44.99 69.3399H30L30 106.83Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M29.03 68.41H45.92V106.83H29.03V68.41ZM44.03 70.29H30.92V106.83H44.03V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M37.49 80.59H44.99V69.34H37.49V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M36.54 68.41H45.92V81.53H36.54V68.41ZM44.04 70.29H38.42V79.67H44.03L44.04 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M29.99 80.59H37.49V69.34H29.99V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M29.03 68.41H38.4V81.53H29.03V68.41ZM36.52 70.29H30.92V79.67H36.54L36.52 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1624.57 106.84H1654.56V31.87H1624.57V106.84Z",
  fill: "#5FBB56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1624.58 106.84H1572.09V31.86L1598.34 9.37L1624.58 31.86V106.84Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1624.58 31.86H1654.56L1628.32 9.37H1598.34L1624.58 31.86Z",
  fill: "#DF7430"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1639.56 54.35H1647.06V43.1H1639.56V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1638.63 42.17H1648.03V55.29H1638.66L1638.63 42.17ZM1646.13 44.05H1640.5V53.42H1646.13V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1632.07 54.35H1639.57V43.1H1632.07V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1631.13 42.17H1640.5V55.29H1631.13V42.17ZM1638.63 44.05H1633.03V53.42H1638.65L1638.63 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1639.56 65.61H1647.06V54.36H1639.56V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1638.63 53.42H1648.03V66.54H1638.66L1638.63 53.42ZM1646.13 55.29H1640.5V64.67H1646.13V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1632.07 65.61H1639.57V54.36H1632.07V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1631.13 53.42H1640.5V66.54H1631.13V53.42ZM1638.63 55.29H1633.03V64.67H1638.65L1638.63 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1639.56 84.34H1647.06V73.09H1639.56V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1638.63 72.16H1648.03V85.28H1638.66L1638.63 72.16ZM1646.13 74.03H1640.5V83.41H1646.13V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1632.07 84.34H1639.57V73.09H1632.07V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1631.13 72.16H1640.5V85.28H1631.13V72.16ZM1638.63 74.03H1633.03V83.41H1638.65L1638.63 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1639.56 95.59H1647.06V84.34H1639.56V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1638.63 83.41H1648.03V96.53H1638.66L1638.63 83.41ZM1646.13 85.28H1640.5V94.67H1646.13V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1632.07 95.59H1639.57V84.34H1632.07V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1631.13 83.41H1640.5V96.53H1631.13V83.41ZM1638.63 85.28H1633.03V94.67H1638.65L1638.63 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1609.57 54.35H1617.07V43.1H1609.57V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1608.64 42.17H1618.03V55.29H1608.66L1608.64 42.17ZM1616.14 44.05H1610.51V53.42H1616.14V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1602.08 54.35H1609.58V43.1H1602.08V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1601.14 42.17H1610.51V55.29H1601.14V42.17ZM1608.64 44.05H1603.03V53.42H1608.65L1608.64 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1609.57 65.61H1617.07V54.36H1609.57V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1608.64 53.42H1618.03V66.54H1608.66L1608.64 53.42ZM1616.14 55.29H1610.51V64.67H1616.14V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1602.08 65.61H1609.58V54.36H1602.08V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1601.14 53.42H1610.51V66.54H1601.14V53.42ZM1608.64 55.29H1603.03V64.67H1608.65L1608.64 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1609.57 84.34H1617.07V73.09H1609.57V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1608.64 72.16H1618.03V85.28H1608.66L1608.64 72.16ZM1616.14 74.03H1610.51V83.41H1616.14V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1602.08 84.34H1609.58V73.09H1602.08V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1601.14 72.16H1610.51V85.28H1601.14V72.16ZM1608.64 74.03H1603.03V83.41H1608.65L1608.64 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1609.57 95.59H1617.07V84.34H1609.57V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1608.64 83.41H1618.03V96.53H1608.66L1608.64 83.41ZM1616.14 85.28H1610.51V94.67H1616.14V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1602.08 95.59H1609.58V84.34H1602.08V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1601.14 83.41H1610.51V96.53H1601.14V83.41ZM1608.64 85.28H1603.03V94.67H1608.65L1608.64 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1587.09 54.35H1594.59V43.1H1587.09V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1586.15 42.17H1595.52V55.29H1586.15V42.17ZM1593.64 44.05H1588.03V53.42H1593.65L1593.64 44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1579.59 54.35H1587.09V43.1H1579.59V54.35Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1578.65 42.17H1588.03V55.29H1578.66L1578.65 42.17ZM1586.15 44.05H1580.52V53.42H1586.15V44.05Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1587.09 65.61H1594.59V54.36H1587.09V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1586.15 53.42H1595.52V66.54H1586.15V53.42ZM1593.64 55.29H1588.03V64.67H1593.65L1593.64 55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1579.59 65.61H1587.09V54.36H1579.59V65.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1578.65 53.42H1588.03V66.54H1578.66L1578.65 53.42ZM1586.15 55.29H1580.52V64.67H1586.15V55.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1587.09 84.34H1594.59V73.09H1587.09V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1586.15 72.16H1595.52V85.28H1586.15V72.16ZM1593.64 74.03H1588.03V83.41H1593.65L1593.64 74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1579.59 84.34H1587.09V73.09H1579.59V84.34Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1578.65 72.16H1588.03V85.28H1578.66L1578.65 72.16ZM1586.15 74.03H1580.52V83.41H1586.15V74.03Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1587.09 95.59H1594.59V84.34H1587.09V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1586.15 83.41H1595.52V96.53H1586.15V83.41ZM1593.64 85.28H1588.03V94.67H1593.65L1593.64 85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1579.59 95.59H1587.09V84.34H1579.59V95.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1578.65 83.41H1588.03V96.53H1578.66L1578.65 83.41ZM1586.15 85.28H1580.52V94.67H1586.15V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1598.33 35.61C1601.43 35.61 1603.95 33.0938 1603.95 29.99C1603.95 26.8862 1601.43 24.37 1598.33 24.37C1595.23 24.37 1592.71 26.8862 1592.71 29.99C1592.71 33.0938 1595.23 35.61 1598.33 35.61Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1618.95 14.73V1.87H1630.2V24.37L1618.95 14.73Z",
  fill: "#5FBB56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1520.55 106.84H1550.54V48.74L1520.55 48.74V106.84Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1550.54 48.73H1520.55L1494.31 22.49H1524.3L1550.54 48.73Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1550.54 54.35L1573.03 76.85H1550.54V54.35Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1468.07 48.73L1494.31 22.49L1520.55 48.73V106.84H1468.07V48.73Z",
  fill: "#298021"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1483.07 69.35H1475.57V80.6H1483.07V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1474.63 68.41H1484.03V81.53H1474.66L1474.63 68.41ZM1482.12 70.29H1476.5V79.67H1482.12V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1490.56 69.35H1483.06V80.6H1490.56V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1482.12 68.41H1491.49V81.53H1482.12V68.41ZM1489.62 70.29H1484.03V79.67H1489.65L1489.62 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1490.56 80.6H1483.06V91.85H1490.56V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1482.12 79.67H1491.49V92.79H1482.12V79.67ZM1489.62 81.54H1484.03V90.91H1489.65L1489.62 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1483.07 80.6H1475.57V91.85H1483.07V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1474.63 79.67H1484.03V92.79H1474.66L1474.63 79.67ZM1482.12 81.54H1476.5V90.91H1482.12V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1505.56 48.73H1498.06V56.23H1505.56V48.73Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1497.12 47.79H1506.49V57.17H1497.12V47.79ZM1504.61 49.67H1499.03V55.29H1504.65L1504.61 49.67Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1498.06 48.73H1490.56V56.23H1498.06V48.73Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1489.62 47.79H1499.03V57.17H1489.66L1489.62 47.79ZM1497.12 49.67H1491.49V55.29H1497.12V49.67Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1490.56 48.73H1483.06V56.23H1490.56V48.73Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1482.12 47.79H1491.49V57.17H1482.12V47.79ZM1489.62 49.67H1484.03V55.29H1489.65L1489.62 49.67Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1505.55 80.59H1513.05V69.34H1505.55V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1504.61 68.41H1514.03V81.53H1504.65L1504.61 68.41ZM1512.11 70.29H1506.49V79.67H1512.11V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1498.06 80.59H1505.56V69.34H1498.06V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1497.12 68.41H1506.49V81.53H1497.12V68.41ZM1504.61 70.29H1499.03V79.67H1504.65L1504.61 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1498.06 91.85H1505.56V80.6H1498.06V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1497.12 79.67H1506.49V92.79H1497.12V79.67ZM1504.61 81.54H1499.03V90.91H1504.65L1504.61 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1505.55 91.85H1513.05V80.6H1505.55V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1504.61 79.67H1514.03V92.79H1504.65L1504.61 79.67ZM1512.11 81.54H1506.49V90.91H1512.11V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1513.05 16.87H1524.3V39.36L1513.05 27.85V16.87Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1526.17 9.37H1511.18V16.87H1526.17V9.37Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1573.03 76.85H1550.54V106.84H1573.03V76.85Z",
  fill: "#37AA2C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1558.04 91.84H1565.54V84.34H1558.04V91.84Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1557.1 83.41H1566.47V92.78H1557.1V83.41ZM1564.59 85.28H1558.97V90.9H1564.59V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1558.04 99.34H1565.54V91.84H1558.04V99.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1557.1 90.9H1566.47V100.27H1557.1V90.9ZM1564.59 92.78H1558.97V98.4H1564.59V92.78Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1543.04 69.35H1528.05V106.84H1543.04V69.35Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1527.11 68.41H1544.03V106.83H1527.16L1527.11 68.41ZM1542.11 70.29H1529.03V106.83H1542.15L1542.11 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1535.55 83.41H1531.8V89.03H1535.55V83.41Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1414.65 48.73H1384.66V106.83H1414.65V48.73Z",
  fill: "#5557AE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1384.66 48.73H1414.65L1440.89 22.49H1410.9L1384.66 48.73Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1384.66 54.35L1362.17 76.85H1384.66V54.35Z",
  fill: "#F1C40F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1467.13 48.73L1440.89 22.49L1414.65 48.73V106.84H1467.13V48.73Z",
  fill: "#6163C7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1399.66 69.35H1392.16V80.6H1399.66V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1391.22 68.41H1400.59V81.53H1391.22V68.41ZM1398.72 70.29H1393.09V79.67H1398.72V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1407.16 69.35H1399.66V80.6H1407.16V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1398.72 68.41H1408.09V81.53H1398.72V68.41ZM1406.21 70.29H1400.59V79.67H1406.21V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1407.16 80.6H1399.66V91.85H1407.16V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1398.72 79.67H1408.09V92.79H1398.72V79.67ZM1406.21 81.54H1400.59V90.91H1406.21V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1399.66 80.6H1392.16V91.85H1399.66V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1391.22 79.67H1400.59V92.79H1391.22V79.67ZM1398.72 81.54H1393.09V90.91H1398.72V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1429.65 69.35H1422.15V80.6H1429.65V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1421.21 68.41H1430.58V81.53H1421.21V68.41ZM1428.7 70.29H1423.08V79.67H1428.7V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1437.15 69.35H1429.65V80.6H1437.15V69.35Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1428.7 68.41H1438.08V81.53H1428.7V68.41ZM1436.2 70.29H1430.58V79.67H1436.2V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1437.15 80.6H1429.65V91.85H1437.15V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1428.7 79.67H1438.08V92.79H1428.7V79.67ZM1436.2 81.54H1430.58V90.91H1436.2V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1429.65 80.6H1422.15V91.85H1429.65V80.6Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1421.21 79.67H1430.58V92.79H1421.21V79.67ZM1428.7 81.54H1423.08V90.91H1428.7V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1422.15 16.87H1410.9V39.36L1422.15 27.85V16.87Z",
  fill: "#5557AE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1384.66 76.85H1362.17V106.84H1384.66V76.85Z",
  fill: "#6163C7"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1377.17 84.34H1369.67V91.84H1377.17V84.34Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1368.73 83.41H1378.1V92.78H1368.73V83.41ZM1376.22 85.28H1370.6V90.9H1376.22V85.28Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1377.17 91.84H1369.67V99.34H1377.17V91.84Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1368.73 90.9H1378.1V100.27H1368.73V90.9ZM1376.22 92.78H1370.6V98.4H1376.22V92.78Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1444.64 106.83H1459.63V69.3399H1444.64V106.83Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1443.7 68.41H1460.57V106.83H1443.7V68.41ZM1458.7 70.29H1445.58V106.83H1458.7V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1452.14 83.41H1448.39V89.03H1452.14V83.41Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1444.64 56.23H1437.14V48.73C1437.14 47.7354 1437.54 46.7816 1438.24 46.0783C1438.94 45.3751 1439.9 44.98 1440.89 44.98C1441.88 44.98 1442.84 45.3751 1443.54 46.0783C1444.24 46.7816 1444.64 47.7354 1444.64 48.73V56.23Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M643.37 54.35L677.11 26.24L710.85 54.35V106.84H643.37V54.35Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M710.84 106.84H748.33V54.36L710.84 54.36V106.84Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M748.33 54.35H710.85L677.11 26.24H714.6L748.33 54.35Z",
  fill: "#7F8C8D"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M729.58 80.59H737.08V69.34H729.58V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M728.65 68.41H738.03V81.53H728.66L728.65 68.41ZM736.15 70.29H730.52V79.67H736.15V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M722.09 80.59H729.59V69.34H722.09V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M721.15 68.41H730.52V81.53H721.15V68.41ZM728.65 70.29H723.03V79.67H728.66L728.65 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M722.09 91.85H729.59V80.6H722.09V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M721.15 79.67H730.52V92.79H721.15V79.67ZM728.65 81.54H723.03V90.91H728.66L728.65 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M729.58 91.85H737.08V80.6H729.58V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M728.65 79.67H738.03V92.79H728.66L728.65 79.67ZM736.15 81.54H730.52V90.91H736.15V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M692.1 80.59H699.6V69.34H692.1V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M691.16 68.41H700.53V81.53H691.16V68.41ZM698.66 70.29H693.03V79.67H698.65L698.66 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M684.6 80.59H692.1V69.34H684.6V80.59Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M683.66 68.41H693.03V81.53H683.65L683.66 68.41ZM691.16 70.29H685.54V79.67H691.16V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M684.6 91.85H692.1V80.6H684.6V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M683.66 79.67H693.03V92.79H683.65L683.66 79.67ZM691.16 81.54H685.54V90.91H691.16V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M692.1 91.85H699.6V80.6H692.1V91.85Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M691.16 79.67H700.53V92.79H691.16V79.67ZM698.66 81.54H693.03V90.91H698.65L698.66 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M662.11 80.59H669.61V69.34H662.11V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M661.17 68.41H670.54V81.53H661.17V68.41ZM668.67 70.29H663.03V79.67H668.65L668.67 70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M654.62 80.59H662.12V69.34H654.62V80.59Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M653.68 68.41H663.03V81.53H653.66L653.68 68.41ZM661.17 70.29H655.55V79.67H661.17V70.29Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M654.62 91.85H662.12V80.6H654.62V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M653.68 79.67H663.03V92.79H653.66L653.68 79.67ZM661.17 81.54H655.55V90.91H661.17V81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M662.11 91.85H669.61V80.6H662.11V91.85Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M661.17 79.67H670.54V92.79H661.17V79.67ZM668.67 81.54H663.03V90.91H668.65L668.67 81.54Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M677.11 59.98C680.214 59.98 682.73 57.4638 682.73 54.36C682.73 51.2561 680.214 48.74 677.11 48.74C674.006 48.74 671.49 51.2561 671.49 54.36C671.49 57.4638 674.006 59.98 677.11 59.98Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M705.22 35.61L716.47 44.98V20.62H705.22V35.61Z",
  fill: "#FF3737"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2143.25 106.84L2224.4 106.84V50.04L2143.25 50.04V106.84Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2224.4 50.03H2143.25L2118.91 29.75H2200.05L2224.4 50.03Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2118.91 29.75L2143.25 50.03V106.84H2118.91H2094.56V50.03L2118.91 29.75Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2208.18 78.4399H2216.29V66.2699H2208.18V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2207.15 65.25H2217.29V79.45H2207.15V65.25ZM2215.26 67.25H2209.18V77.39H2215.26V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2200.06 78.4399H2208.17V66.2699H2200.06V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2199.03 65.25H2209.17V79.45H2199.03V65.25ZM2207.14 67.25H2201.03V77.39H2207.12L2207.14 67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2200.06 90.61H2208.17V78.44H2200.06V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2199.03 77.42H2209.17V91.67H2199.03V77.42ZM2207.14 79.42H2201.03V89.56H2207.12L2207.14 79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2208.18 90.61H2216.29V78.44H2208.18V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2207.15 77.42H2217.29V91.67H2207.15V77.42ZM2215.26 79.42H2209.18V89.56H2215.26V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2159.48 78.4399H2167.59V66.2699H2159.48V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2158.46 65.25H2168.61V79.45H2158.46V65.25ZM2166.58 67.25H2160.49V77.39H2166.58V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2151.37 78.4399H2159.48V66.2699H2151.37V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2150.35 65.25H2160.49V79.45H2150.35V65.25ZM2158.46 67.25H2152.38V77.39H2158.46V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2151.37 90.61H2159.48V78.44H2151.37V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2150.35 77.42H2160.49V91.67H2150.35V77.42ZM2158.46 79.42H2152.38V89.56H2158.46V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2159.48 90.61H2167.59V78.44H2159.48V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2158.46 77.42H2168.61V91.67H2158.46V77.42ZM2166.58 79.42H2160.49V89.56H2166.58V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2110.8 78.4399H2118.91V66.2699H2110.8V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2109.77 65.25H2119.92V79.45H2109.77V65.25ZM2117.89 67.25H2111.8V77.39H2117.89V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2102.69 78.4399H2110.8V66.2699H2102.69V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2101.66 65.25H2111.8V79.45H2101.66V65.25ZM2109.77 67.25H2103.69V77.39H2109.77V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2102.69 90.61H2110.8V78.44H2102.69V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2101.66 77.42H2111.8V91.67H2101.66V77.42ZM2109.77 79.42H2103.69V89.56H2109.77V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2110.8 90.61H2118.91V78.44H2110.8V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2109.77 77.42H2119.92V91.67H2109.77V77.42ZM2117.89 79.42H2111.8V89.56H2117.89V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2127.03 78.4399H2135.14V66.2699H2127.03V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2126.03 65.25H2136.18V79.45H2126.03V65.25ZM2134.15 67.25H2128.03V77.39H2134.12L2134.15 67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2118.92 78.4399H2127.03V66.2699H2118.92V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2117.89 65.25H2128.03V79.45H2117.89V65.25ZM2126 67.25H2119.92V77.39H2126.03L2126 67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2118.92 90.61H2127.03V78.44H2118.92V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2117.89 77.42H2128.03V91.67H2117.89V77.42ZM2126 79.42H2119.92V89.56H2126.03L2126 79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2127.03 90.61H2135.14V78.44H2127.03V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2126.03 77.42H2136.18V91.67H2126.03V77.42ZM2134.15 79.42H2128.03V89.56H2134.12L2134.15 79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2163.54 39.89H2187.88V19.6L2175.71 11.49L2163.54 19.6V39.89Z",
  fill: "#FF3737"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2151.37 29.75L2163.54 39.89V19.6H2151.37V29.75Z",
  fill: "#DF3030"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2163.54 19.6H2151.37L2163.54 11.49H2175.71L2163.54 19.6Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2175.71 106.84H2191.94V66.27H2175.71V106.84Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2174.69 65.25H2192.95V106.83H2174.69V65.25ZM2190.92 67.25H2176.72V106.8H2190.92V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2183.83 82.49H2179.77V88.58H2183.83V82.49Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2114.85 56.12H2122.96V48.01H2114.85V56.12Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2113.83 46.99H2124.03V57.13H2113.83V46.99ZM2121.95 48.99H2115.86V55.07H2121.95V48.99Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2171.66 31.78H2179.77V23.67H2171.66V31.78Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2170.63 22.67H2180.78V32.81H2170.63V22.67ZM2178.75 24.67H2172.66V30.76H2178.75V24.67Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1973.35 50.03L2013.92 19.6L2054.49 50.03V106.84H1973.35V50.03Z",
  fill: "#926445"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2054.5 106.84H2095.07V50.04L2054.5 50.04V106.84Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2095.07 50.03H2054.49L2013.92 19.6H2054.49L2095.07 50.03Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2074.78 78.4399H2082.89V66.2699H2074.78V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2073.76 65.25H2083.91V79.45H2073.76V65.25ZM2081.88 67.25H2075.79V77.39H2081.88V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2066.67 78.4399H2074.78V66.2699H2066.67V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2065.65 65.25H2075.79V79.45H2065.65V65.25ZM2073.76 67.25H2067.68V77.39H2073.76V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2066.67 90.61H2074.78V78.44H2066.67V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2065.65 77.42H2075.79V91.67H2065.65V77.42ZM2073.76 79.42H2067.68V89.56H2073.76V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2074.78 90.61H2082.89V78.44H2074.78V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2073.76 77.42H2083.91V91.67H2073.76V77.42ZM2081.88 79.42H2075.79V89.56H2081.88V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2038.27 78.4399H2046.38V66.2699H2038.27V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2037.25 65.25H2047.39V79.45H2037.25V65.25ZM2045.36 67.25H2039.27V77.39H2045.36V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2030.15 78.4399H2038.26V66.2699H2030.15V78.4399Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2029.13 65.25H2039.27V79.45H2029.13V65.25ZM2037.25 67.25H2031.16V77.39H2037.25V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2030.15 90.61H2038.26V78.44H2030.15V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2029.13 77.42H2039.27V91.67H2029.13V77.42ZM2037.25 79.42H2031.16V89.56H2037.25V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2038.27 90.61H2046.38V78.44H2038.27V90.61Z",
  fill: "#FFDE0F"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2037.25 77.42H2047.39V91.67H2037.25V77.42ZM2045.36 79.42H2039.27V89.56H2045.36V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1989.58 78.4399H1997.69V66.2699H1989.58V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1988.56 65.25H1998.7V79.45H1988.56V65.25ZM1996.67 67.25H1990.59V77.39H1996.67V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1981.47 78.4399H1989.58V66.2699H1981.47V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1980.44 65.25H1990.59V79.45H1980.44V65.25ZM1988.56 67.25H1982.47V77.39H1988.56V67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1981.47 90.61H1989.58V78.44H1981.47V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1980.44 77.42H1990.59V91.67H1980.44V77.42ZM1988.56 79.42H1982.47V89.56H1988.56V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1989.58 90.61H1997.69V78.44H1989.58V90.61Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M1988.56 77.42H1998.7V91.67H1988.56V77.42ZM1996.67 79.42H1990.59V89.56H1996.67V79.42Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2013.92 54.1C2017.28 54.1 2020.01 51.3735 2020.01 48.01C2020.01 44.6466 2017.28 41.92 2013.92 41.92C2010.56 41.92 2007.83 44.6466 2007.83 48.01C2007.83 51.3735 2010.56 54.1 2013.92 54.1Z",
  fill: "#ECF0F1"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2060.58 38.88L2048.41 29.75V11.49H2060.58V38.88Z",
  fill: "#C3855C"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2005.81 106.84H2022.04V66.27H2005.81V106.84Z",
  fill: "#D3BBAF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2004.79 65.25H2023.03V106.83H2004.77L2004.79 65.25ZM2021.02 67.25H2006.82V106.8H2021.03L2021.02 67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2013.92 78.4399H2022.03V66.2699H2013.92V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2012.9 65.25H2023.03V79.45H2012.88L2012.9 65.25ZM2021.02 67.25H2014.93V77.39H2021.03L2021.02 67.25Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2005.81 78.4399H2013.92V66.2699H2005.81V78.4399Z",
  fill: "#8DD4FC"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2004.79 65.25H2014.93V79.45H2004.79V65.25ZM2012.9 67.25H2006.82V77.39H2012.9V67.25Z",
  fill: "white"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1575.5 89.76H1499.47V148.89H1575.5V89.76Z",
  fill: "#F9BE19"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1499.47 89.76H1575.49L1596.62 64.41H1520.59L1499.47 89.76Z",
  fill: "#DF3030"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1596.62 64.41L1575.49 89.76V148.89H1617.73V89.76L1596.62 64.41Z",
  fill: "#D39C16"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1520.59 106.65H1512.14V119.32H1520.59V106.65Z",
  fill: "#8DD4FC"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1521.64 120.38H1511.08V105.6H1521.64V120.38ZM1513.19 118.27H1519.53V107.67H1513.19V118.27Z",
  fill: "white"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1529.04 106.65H1520.59V119.32H1529.04V106.65Z",
  fill: "#8DD4FC"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M1530.08 120.38H1519.53V105.6H1530.08V120.38ZM1521.64 118.27H1527.97V107.67H1521.64V118.27Z",
  fill: "white"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M1529.04 119.32H1520.59V131.99H1529.04V119.32Z",
  fill: "#8DD4FC"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M1530.08 133.05H1519.53V118.27H1530.08V133.05ZM1521.64 130.94H1527.97V120.38H1521.64V130.94Z",
  fill: "white"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M1520.59 119.32H1512.14V131.99H1520.59V119.32Z",
  fill: "#8DD4FC"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M1521.64 133.05H1511.08V118.27H1521.64V133.05ZM1513.19 130.94H1519.53V120.38H1513.19V130.94Z",
  fill: "white"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M1554.38 106.65H1545.93V119.32H1554.38V106.65Z",
  fill: "#8DD4FC"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M1555.43 120.38H1544.87V105.6H1555.43V120.38ZM1547.03 118.27H1553.37V107.67H1547.03V118.27Z",
  fill: "white"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M1562.83 106.65H1554.38V119.32H1562.83V106.65Z",
  fill: "#8DD4FC"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M1563.88 120.38H1553.32V105.6H1563.88V120.38ZM1555.43 118.27H1561.76V107.67H1555.43V118.27Z",
  fill: "white"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M1562.83 119.32H1554.38V131.99H1562.83V119.32Z",
  fill: "#8DD4FC"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M1563.88 133.05H1553.32V118.27H1563.88V133.05ZM1555.43 130.94H1561.76V120.38H1555.43V130.94Z",
  fill: "white"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M1554.38 119.32H1545.93V131.99H1554.38V119.32Z",
  fill: "#8DD4FC"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M1555.43 133.05H1544.87V118.27H1555.43V133.05ZM1546.98 130.94H1553.32V120.38H1547.03L1546.98 130.94Z",
  fill: "white"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M1596.62 106.65H1588.17V119.32H1596.62V106.65Z",
  fill: "#8DD4FC"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M1597.67 120.38H1587.11V105.6H1597.67V120.38ZM1589.22 118.27H1595.55V107.67H1589.22V118.27Z",
  fill: "white"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M1605.06 106.65H1596.61V119.32H1605.06V106.65Z",
  fill: "#8DD4FC"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M1606.11 120.38H1595.55V105.6H1606.11V120.38ZM1597.67 118.27H1604.03V107.67H1597.7L1597.67 118.27Z",
  fill: "white"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M1605.06 119.32H1596.61V131.99H1605.06V119.32Z",
  fill: "#8DD4FC"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M1606.11 133.05H1595.55V118.27H1606.11V133.05ZM1597.67 130.94H1604.03V120.38H1597.7L1597.67 130.94Z",
  fill: "white"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M1596.62 119.32H1588.17V131.99H1596.62V119.32Z",
  fill: "#8DD4FC"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M1597.67 133.05H1587.11V118.27H1597.67V133.05ZM1589.22 130.94H1595.55V120.38H1589.22V130.94Z",
  fill: "white"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M1596.61 96.1C1600.11 96.1 1602.95 93.2615 1602.95 89.76C1602.95 86.2586 1600.11 83.42 1596.61 83.42C1593.11 83.42 1590.27 86.2586 1590.27 89.76C1590.27 93.2615 1593.11 96.1 1596.61 96.1Z",
  fill: "white"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M1552.26 63.99V53.85H1539.59V79.2L1552.26 63.99Z",
  fill: "#F9BE19"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M1554.38 45.41H1537.48V53.86H1554.38V45.41Z",
  fill: "#DF3030"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M975.71 148.89H1009.5V64.41H975.71V148.89Z",
  fill: "#FF8537"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M975.71 148.89H916.58V64.41L946.14 39.0699L975.71 64.41V148.89Z",
  fill: "#FFA063"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M975.71 64.41H1009.5L979.93 39.0699H946.14L975.71 64.41Z",
  fill: "#DF3030"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M992.6 89.76H1001.05V77.09H992.6V89.76Z",
  fill: "#8DD4FC"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.1 90.81H991.54V76.03H1002.1V90.81ZM993.66 88.67H1000.03V78.14H993.7L993.66 88.67Z",
  fill: "white"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M984.16 89.76H992.61V77.09H984.16V89.76Z",
  fill: "#8DD4FC"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M993.66 90.81H983.1V76.03H993.66V90.81ZM985.21 88.67H991.54V78.14H985.21V88.67Z",
  fill: "white"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M992.6 102.42H1001.05V89.75H992.6V102.42Z",
  fill: "#8DD4FC"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.1 103.48H991.54V88.67H1002.1V103.48ZM993.66 101.37H1000.03V90.81H993.7L993.66 101.37Z",
  fill: "white"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M984.16 102.42H992.61V89.75H984.16V102.42Z",
  fill: "#8DD4FC"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M993.66 103.48H983.1V88.67H993.66V103.48ZM985.21 101.37H991.54V90.81H985.21V101.37Z",
  fill: "white"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M992.6 123.54H1001.05V110.87H992.6V123.54Z",
  fill: "#FFDE0F"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.1 124.6H991.54V109.82H1002.1V124.6ZM993.66 122.49H1000.03V111.93H993.7L993.66 122.49Z",
  fill: "white"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M984.16 123.54H992.61V110.87H984.16V123.54Z",
  fill: "#FFDE0F"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M993.66 124.6H983.1V109.82H993.66V124.6ZM985.21 122.49H991.54V111.93H985.21V122.49Z",
  fill: "white"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M992.6 136.22H1001.05V123.55H992.6V136.22Z",
  fill: "#FFDE0F"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.1 137.27H991.54V122.49H1002.1V137.27ZM993.66 135.16H1000.03V124.6H993.7L993.66 135.16Z",
  fill: "white"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M984.16 136.22H992.61V123.55H984.16V136.22Z",
  fill: "#FFDE0F"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M993.66 137.27H983.1V122.49H993.66V137.27ZM985.21 135.16H991.54V124.6H985.21V135.16Z",
  fill: "white"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M958.81 89.76H967.26V77.09H958.81V89.76Z",
  fill: "#FFDE0F"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M968.31 90.81H957.75V76.03H968.31V90.81ZM959.87 88.67H966.2V78.14H959.87V88.67Z",
  fill: "white"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M950.37 89.76H958.82V77.09H950.37V89.76Z",
  fill: "#FFDE0F"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M959.87 90.81H949.31V76.03H959.87V90.81ZM951.42 88.67H957.75V78.14H951.42V88.67Z",
  fill: "white"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M958.81 102.42H967.26V89.75H958.81V102.42Z",
  fill: "#FFDE0F"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M968.31 103.48H957.75V88.67H968.31V103.48ZM959.87 101.37H966.2V90.81H959.87V101.37Z",
  fill: "white"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M950.37 102.42H958.82V89.75H950.37V102.42Z",
  fill: "#FFDE0F"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M959.87 103.48H949.31V88.67H959.87V103.48ZM951.42 101.37H957.75V90.81H951.42V101.37Z",
  fill: "white"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M967.27 110.88H950.37V148.89H967.27V110.88Z",
  fill: "#DF3030"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M968.31 148.89H949.31V109.82H968.31V148.89ZM951.42 148.89H966.2V111.89H951.42V148.89Z",
  fill: "white"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M958.81 123.54H967.26V110.87H958.81V123.54Z",
  fill: "#FFDE0F"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M968.31 124.6H957.75V109.82H968.31V124.6ZM959.87 122.49H966.2V111.93H959.87V122.49Z",
  fill: "white"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M950.37 123.54H958.82V110.87H950.37V123.54Z",
  fill: "#FFDE0F"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M959.87 124.6H949.31V109.82H959.87V124.6ZM951.42 122.49H957.75V111.93H951.42V122.49Z",
  fill: "white"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M933.46 89.76H941.91V77.09H933.46V89.76Z",
  fill: "#FFDE0F"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M942.97 90.81H932.41V76.03H942.97V90.81ZM934.52 88.67H940.86V78.14H934.52V88.67Z",
  fill: "white"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M925.02 89.76H933.47V77.09H925.02V89.76Z",
  fill: "#FFDE0F"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M934.52 90.81H923.96V76.03H934.52V90.81ZM926.03 88.67H932.37V78.14H926.03V88.67Z",
  fill: "white"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M933.46 102.42H941.91V89.75H933.46V102.42Z",
  fill: "#FFDE0F"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M942.97 103.48H932.41V88.67H942.97V103.48ZM934.52 101.37H940.86V90.81H934.52V101.37Z",
  fill: "white"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M925.02 102.42H933.47V89.75H925.02V102.42Z",
  fill: "#FFDE0F"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M934.52 103.48H923.96V88.67H934.52V103.48ZM926.03 101.37H932.37V90.81H926.03V101.37Z",
  fill: "white"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M933.46 123.54H941.91V110.87H933.46V123.54Z",
  fill: "#8DD4FC"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M942.97 124.6H932.41V109.82H942.97V124.6ZM934.52 122.49H940.86V111.93H934.52V122.49Z",
  fill: "white"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M925.02 123.54H933.47V110.87H925.02V123.54Z",
  fill: "#8DD4FC"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M934.52 124.6H923.96V109.82H934.52V124.6ZM926.03 122.49H932.37V111.93H926.03V122.49Z",
  fill: "white"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  d: "M933.46 136.22H941.91V123.55H933.46V136.22Z",
  fill: "#8DD4FC"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  d: "M942.97 137.27H932.41V122.49H942.97V137.27ZM934.52 135.16H940.86V124.6H934.52V135.16Z",
  fill: "white"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  d: "M925.02 136.22H933.47V123.55H925.02V136.22Z",
  fill: "#8DD4FC"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  d: "M934.52 137.27H923.96V122.49H934.52V137.27ZM926.03 135.16H932.37V124.6H926.03V135.16Z",
  fill: "white"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  d: "M950.36 68.67H941.91V60.22C941.913 59.0999 942.36 58.0265 943.153 57.2354C943.946 56.4443 945.02 56 946.14 56C947.259 56 948.333 56.4446 949.124 57.236C949.915 58.0274 950.36 59.1008 950.36 60.22V68.67Z",
  fill: "#FFDE0F"
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  d: "M951.42 69.67H940.86V60.17C940.86 58.7697 941.416 57.4267 942.406 56.4365C943.397 55.4463 944.74 54.89 946.14 54.89C947.54 54.89 948.883 55.4463 949.874 56.4365C950.864 57.4267 951.42 58.7697 951.42 60.17V69.67ZM942.97 67.56H949.31V60.17C949.31 59.3293 948.976 58.523 948.382 57.9285C947.787 57.334 946.981 57 946.14 57C945.299 57 944.493 57.334 943.898 57.9285C943.304 58.523 942.97 59.3293 942.97 60.17V67.56Z",
  fill: "white"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  d: "M969.37 45.1V30.62H982.04V55.97L969.37 45.1Z",
  fill: "#FF8537"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  d: "M1807.81 148.89H1841.6V64.41H1807.81V148.89Z",
  fill: "#FF8537"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  d: "M1807.81 148.89H1748.67V64.41L1778.24 39.0699L1807.81 64.41V148.89Z",
  fill: "#FFA063"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  d: "M1807.81 64.41H1841.6L1812.03 39.0699H1778.24L1807.81 64.41Z",
  fill: "#DF3030"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  d: "M1824.7 89.76H1833.15V77.09H1824.7V89.76Z",
  fill: "#8DD4FC"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  d: "M1834.2 90.81H1823.64V76.03H1834.2V90.81ZM1825.75 88.7H1832.09V78.14H1825.75V88.7Z",
  fill: "white"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  d: "M1816.25 89.76H1824.7V77.09H1816.25V89.76Z",
  fill: "#8DD4FC"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  d: "M1825.75 90.81H1815.19V76.03H1825.75V90.81ZM1817.31 88.7H1823.64V78.14H1817.31V88.7Z",
  fill: "white"
})), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  d: "M1824.7 102.42H1833.15V89.75H1824.7V102.42Z",
  fill: "#8DD4FC"
})), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  d: "M1834.2 103.48H1823.64V88.67H1834.2V103.48ZM1825.75 101.37H1832.09V90.81H1825.75V101.37Z",
  fill: "white"
})), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  d: "M1816.25 102.42H1824.7V89.75H1816.25V102.42Z",
  fill: "#8DD4FC"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  d: "M1825.75 103.48H1815.19V88.67H1825.75V103.48ZM1817.31 101.37H1823.64V90.81H1817.31V101.37Z",
  fill: "white"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  d: "M1824.7 123.54H1833.15V110.87H1824.7V123.54Z",
  fill: "#FFDE0F"
})), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
  d: "M1834.2 124.6H1823.64V109.82H1834.2V124.6ZM1825.75 122.49H1832.09V111.93H1825.75V122.49Z",
  fill: "white"
})), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
  d: "M1816.25 123.54H1824.7V110.87H1816.25V123.54Z",
  fill: "#FFDE0F"
})), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
  d: "M1825.75 124.6H1815.19V109.82H1825.75V124.6ZM1817.31 122.49H1823.64V111.93H1817.31V122.49Z",
  fill: "white"
})), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
  d: "M1824.7 136.22H1833.15V123.55H1824.7V136.22Z",
  fill: "#FFDE0F"
})), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
  d: "M1834.2 137.27H1823.64V122.49H1834.2V137.27ZM1825.75 135.16H1832.09V124.6H1825.75V135.16Z",
  fill: "white"
})), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
  d: "M1816.25 136.22H1824.7V123.55H1816.25V136.22Z",
  fill: "#FFDE0F"
})), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
  d: "M1825.75 137.27H1815.19V122.49H1825.75V137.27ZM1817.31 135.16H1823.64V124.6H1817.31V135.16Z",
  fill: "white"
})), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
  d: "M1790.91 89.76H1799.36V77.09H1790.91V89.76Z",
  fill: "#FFDE0F"
})), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
  d: "M1800.41 90.81H1789.85V76.03H1800.41V90.81ZM1791.96 88.7H1798.3V78.14H1791.96V88.7Z",
  fill: "white"
})), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.46 89.76H1790.91V77.09H1782.46V89.76Z",
  fill: "#FFDE0F"
})), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
  d: "M1791.96 90.81H1781.4V76.03H1791.96V90.81ZM1783.52 88.7H1789.85V78.14H1783.52V88.7Z",
  fill: "white"
})), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
  d: "M1790.91 102.42H1799.36V89.75H1790.91V102.42Z",
  fill: "#FFDE0F"
})), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
  d: "M1800.41 103.48H1789.85V88.67H1800.41V103.48ZM1791.96 101.37H1798.3V90.81H1791.96V101.37Z",
  fill: "white"
})), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.46 102.42H1790.91V89.75H1782.46V102.42Z",
  fill: "#FFDE0F"
})), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
  d: "M1791.96 103.48H1781.4V88.67H1791.96V103.48ZM1783.52 101.37H1789.85V90.81H1783.52V101.37Z",
  fill: "white"
})), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
  d: "M1799.36 110.88H1782.46V148.89H1799.36V110.88Z",
  fill: "#DF3030"
})), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
  d: "M1800.41 148.89H1781.41V109.82H1800.41V148.89ZM1783.52 148.89H1798.3V111.89H1783.52V148.89Z",
  fill: "white"
})), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
  d: "M1790.91 123.54H1799.36V110.87H1790.91V123.54Z",
  fill: "#FFDE0F"
})), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
  d: "M1800.41 124.6H1789.85V109.82H1800.41V124.6ZM1791.96 122.49H1798.3V111.93H1791.96V122.49Z",
  fill: "white"
})), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.46 123.54H1790.91V110.87H1782.46V123.54Z",
  fill: "#FFDE0F"
})), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
  d: "M1791.96 124.6H1781.4V109.82H1791.96V124.6ZM1783.52 122.49H1789.85V111.93H1783.52V122.49Z",
  fill: "white"
})), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
  d: "M1765.57 89.76H1774.02V77.09H1765.57V89.76Z",
  fill: "#FFDE0F"
})), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
  d: "M1775.03 90.81H1764.47V76.03H1775.03V90.81ZM1766.58 88.7H1772.92V78.14H1766.58V88.7Z",
  fill: "white"
})), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
  d: "M1757.12 89.76H1765.57V77.09H1757.12V89.76Z",
  fill: "#FFDE0F"
})), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
  d: "M1766.62 90.81H1756.03V76.03H1766.59L1766.62 90.81ZM1758.17 88.7H1764.51V78.14H1758.17V88.7Z",
  fill: "white"
})), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
  d: "M1765.57 102.42H1774.02V89.75H1765.57V102.42Z",
  fill: "#FFDE0F"
})), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
  d: "M1775.03 103.48H1764.47V88.67H1775.03V103.48ZM1766.58 101.37H1772.92V90.81H1766.58V101.37Z",
  fill: "white"
})), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
  d: "M1757.12 102.42H1765.57V89.75H1757.12V102.42Z",
  fill: "#FFDE0F"
})), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
  d: "M1766.62 103.48H1756.03V88.67H1766.59L1766.62 103.48ZM1758.17 101.37H1764.51V90.81H1758.17V101.37Z",
  fill: "white"
})), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
  d: "M1765.57 123.54H1774.02V110.87H1765.57V123.54Z",
  fill: "#8DD4FC"
})), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
  d: "M1775.03 124.6H1764.47V109.82H1775.03V124.6ZM1766.58 122.49H1772.92V111.93H1766.58V122.49Z",
  fill: "white"
})), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
  d: "M1757.12 123.54H1765.57V110.87H1757.12V123.54Z",
  fill: "#8DD4FC"
})), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
  d: "M1766.62 124.6H1756.03V109.82H1766.59L1766.62 124.6ZM1758.17 122.49H1764.51V111.93H1758.17V122.49Z",
  fill: "white"
})), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
  d: "M1765.57 136.22H1774.02V123.55H1765.57V136.22Z",
  fill: "#8DD4FC"
})), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
  d: "M1775.03 137.27H1764.47V122.49H1775.03V137.27ZM1766.58 135.16H1772.92V124.6H1766.58V135.16Z",
  fill: "white"
})), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
  d: "M1757.12 136.22H1765.57V123.55H1757.12V136.22Z",
  fill: "#8DD4FC"
})), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
  d: "M1766.62 137.27H1756.03V122.49H1766.59L1766.62 137.27ZM1758.17 135.16H1764.51V124.6H1758.17V135.16Z",
  fill: "white"
})), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
  d: "M1782.46 68.67H1774.03V60.22C1774.03 59.665 1774.14 59.1154 1774.35 58.6028C1774.56 58.0901 1774.88 57.6245 1775.27 57.2325C1775.66 56.8405 1776.13 56.5299 1776.64 56.3184C1777.16 56.1069 1777.7 55.9987 1778.26 56C1779.38 56 1780.45 56.4446 1781.24 57.236C1782.04 58.0274 1782.48 59.1008 1782.48 60.22L1782.46 68.67Z",
  fill: "#FFDE0F"
})), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
  d: "M1783.52 69.67H1772.96V60.17C1772.96 58.7697 1773.52 57.4267 1774.51 56.4365C1775.5 55.4463 1776.84 54.89 1778.24 54.89C1779.64 54.89 1780.98 55.4463 1781.97 56.4365C1782.96 57.4267 1783.52 58.7697 1783.52 60.17V69.67ZM1775.07 67.56H1781.4V60.17C1781.42 59.7394 1781.36 59.3084 1781.21 58.9034C1781.06 58.4983 1780.83 58.1278 1780.54 57.8143C1780.24 57.5009 1779.89 57.2513 1779.49 57.0807C1779.09 56.91 1778.67 56.822 1778.23 56.822C1777.8 56.822 1777.38 56.91 1776.98 57.0807C1776.58 57.2513 1776.23 57.5009 1775.93 57.8143C1775.64 58.1278 1775.41 58.4983 1775.26 58.9034C1775.11 59.3084 1775.05 59.7394 1775.07 60.17V67.56Z",
  fill: "white"
})), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
  d: "M1801.47 45.1V30.62H1814.14V55.97L1801.47 45.1Z",
  fill: "#FF8537"
})), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
  d: "M856.38 64.41H809.92V148.89H856.38V64.41Z",
  fill: "#F7DC6F"
})), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
  d: "M856.38 148.89H915.52V64.41L885.95 39.0699L856.38 64.41V148.89Z",
  fill: "#F1C40F"
})), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
  d: "M856.38 64.41H809.92L839.49 39.0699H885.95L856.38 64.41Z",
  fill: "#DF3030"
})), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
  d: "M833.16 77.09H824.71V89.76H833.16V77.09Z",
  fill: "#8DD4FC"
})), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
  d: "M834.21 90.81H823.65V76.03H834.21V90.81ZM825.76 88.67H832.09V78.14H825.76V88.67Z",
  fill: "white"
})), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
  d: "M841.6 77.09H833.15V89.76H841.6V77.09Z",
  fill: "#8DD4FC"
})), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
  d: "M842.65 90.81H832.09V76.03H842.65V90.81ZM834.21 88.67H840.54V78.14H834.21V88.67Z",
  fill: "white"
})), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
  d: "M833.16 89.76H824.71V102.43H833.16V89.76Z",
  fill: "#8DD4FC"
})), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
  d: "M834.21 103.48H823.65V88.67H834.21V103.48ZM825.76 101.37H832.09V90.81H825.76V101.37Z",
  fill: "white"
})), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
  d: "M841.6 89.76H833.15V102.43H841.6V89.76Z",
  fill: "#8DD4FC"
})), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
  d: "M842.65 103.48H832.09V88.67H842.65V103.48ZM834.21 101.37H840.54V90.81H834.21V101.37Z",
  fill: "white"
})), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
  d: "M841.61 110.88H824.71V148.89H841.61V110.88Z",
  fill: "#ECF0F1"
})), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
  d: "M842.65 148.89H823.65V109.82H842.65V148.89ZM825.76 148.89H840.54V111.89H825.76V148.89Z",
  fill: "white"
})), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
  d: "M833.16 110.88H824.71V123.55H833.16V110.88Z",
  fill: "#8DD4FC"
})), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
  d: "M834.21 124.6H823.65V109.82H834.21V124.6ZM825.76 122.49H832.09V111.93H825.76V122.49Z",
  fill: "white"
})), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
  d: "M841.6 110.88H833.15V123.55H841.6V110.88Z",
  fill: "#8DD4FC"
})), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
  d: "M842.65 124.6H832.09V109.82H842.65V124.6ZM834.21 122.49H840.54V111.93H834.21V122.49Z",
  fill: "white"
})), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
  d: "M873.28 77.09H864.83V89.76H873.28V77.09Z",
  fill: "#8DD4FC"
})), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
  d: "M874.33 90.81H863.77V76.03H874.33V90.81ZM865.88 88.67H872.22V78.14H865.88V88.67Z",
  fill: "white"
})), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
  d: "M881.73 77.09H873.28V89.76H881.73V77.09Z",
  fill: "#8DD4FC"
})), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
  d: "M882.78 90.81H872.22V76.03H882.78V90.81ZM874.33 88.67H880.67V78.14H874.33V88.67Z",
  fill: "white"
})), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
  d: "M873.28 89.76H864.83V102.43H873.28V89.76Z",
  fill: "#8DD4FC"
})), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
  d: "M874.33 103.48H863.77V88.67H874.33V103.48ZM865.88 101.37H872.22V90.81H865.88V101.37Z",
  fill: "white"
})), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
  d: "M881.73 89.76H873.28V102.43H881.73V89.76Z",
  fill: "#8DD4FC"
})), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
  d: "M882.78 103.48H872.22V88.67H882.78V103.48ZM874.33 101.37H880.67V90.81H874.33V101.37Z",
  fill: "white"
})), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
  d: "M873.28 110.88H864.83V123.55H873.28V110.88Z",
  fill: "#8DD4FC"
})), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
  d: "M874.33 124.6H863.77V109.82H874.33V124.6ZM865.88 122.49H872.22V111.93H865.88V122.49Z",
  fill: "white"
})), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
  d: "M881.73 110.88H873.28V123.55H881.73V110.88Z",
  fill: "#8DD4FC"
})), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
  d: "M882.78 124.6H872.22V109.82H882.78V124.6ZM874.33 122.49H880.67V111.93H874.33V122.49Z",
  fill: "white"
})), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
  d: "M873.28 123.55H864.83V136.22H873.28V123.55Z",
  fill: "#8DD4FC"
})), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
  d: "M874.33 137.27H863.77V122.49H874.33V137.27ZM865.88 135.16H872.22V124.6H865.88V135.16Z",
  fill: "white"
})), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
  d: "M881.73 123.55H873.28V136.22H881.73V123.55Z",
  fill: "#8DD4FC"
})), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
  d: "M882.78 137.27H872.22V122.49H882.78V137.27ZM874.33 135.16H880.67V124.6H874.33V135.16Z",
  fill: "white"
})), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
  d: "M898.63 77.09H890.18V89.76H898.63V77.09Z",
  fill: "#8DD4FC"
})), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
  d: "M899.68 90.81H889.12V76.03H899.68V90.81ZM891.23 88.67H897.56V78.14H891.23V88.67Z",
  fill: "white"
})), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
  d: "M907.07 77.09H898.62V89.76H907.07V77.09Z",
  fill: "#8DD4FC"
})), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
  d: "M908.12 90.81H897.56V76.03H908.12V90.81ZM899.68 88.67H906.03V78.14H899.7L899.68 88.67Z",
  fill: "white"
})), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
  d: "M898.63 89.76H890.18V102.43H898.63V89.76Z",
  fill: "#8DD4FC"
})), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
  d: "M899.68 103.48H889.12V88.67H899.68V103.48ZM891.23 101.37H897.56V90.81H891.23V101.37Z",
  fill: "white"
})), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
  d: "M907.07 89.76H898.62V102.43H907.07V89.76Z",
  fill: "#8DD4FC"
})), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
  d: "M908.12 103.48H897.56V88.67H908.12V103.48ZM899.68 101.37H906.03V90.81H899.7L899.68 101.37Z",
  fill: "white"
})), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
  d: "M898.63 110.88H890.18V123.55H898.63V110.88Z",
  fill: "#8DD4FC"
})), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
  d: "M899.68 124.6H889.12V109.82H899.68V124.6ZM891.23 122.49H897.56V111.93H891.23V122.49Z",
  fill: "white"
})), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
  d: "M907.07 110.88H898.62V123.55H907.07V110.88Z",
  fill: "#8DD4FC"
})), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
  d: "M908.12 124.6H897.56V109.82H908.12V124.6ZM899.68 122.49H906.03V111.93H899.7L899.68 122.49Z",
  fill: "white"
})), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
  d: "M898.63 123.55H890.18V136.22H898.63V123.55Z",
  fill: "#8DD4FC"
})), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
  d: "M899.68 137.27H889.12V122.49H899.68V137.27ZM891.23 135.16H897.56V124.6H891.23V135.16Z",
  fill: "white"
})), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
  d: "M907.07 123.55H898.62V136.22H907.07V123.55Z",
  fill: "#8DD4FC"
})), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
  d: "M908.12 137.27H897.56V122.49H908.12V137.27ZM899.68 135.16H906.03V124.6H899.7L899.68 135.16Z",
  fill: "white"
})), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
  d: "M894.4 58.08H877.5V66.53H894.4V58.08Z",
  fill: "#8DD4FC"
})), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
  d: "M895.45 67.58H876.45V57.02H895.45V67.58ZM878.56 65.47H893.34V59.13H878.56V65.47Z",
  fill: "white"
})), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
  d: "M847.94 53.85H822.59V36.96L835.27 28.51L847.94 36.96V53.85Z",
  fill: "#F7DC6F"
})), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
  d: "M860.61 43.29L847.94 53.85V36.96H860.61V43.29Z",
  fill: "#F1C40F"
})), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
  d: "M847.94 36.96H860.61L847.94 28.51H835.27L847.94 36.96Z",
  fill: "#DF3030"
})), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
  d: "M1917.11 148.89H1963.57V89.76H1917.11V148.89Z",
  fill: "#37AA2C"
})), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
  d: "M1963.57 89.76H1917.1L1879.09 58.08H1925.55L1963.57 89.76Z",
  fill: "#7F8C8D"
})), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
  d: "M1917.1 89.76L1879.09 58.08L1841.07 89.76V148.89H1917.1V89.76Z",
  fill: "#5FBB56"
})), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
  d: "M1895.98 119.32H1904.43V106.65H1895.98V119.32Z",
  fill: "#FFDE0F"
})), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
  d: "M1905.48 120.38H1894.92V105.6H1905.48V120.38ZM1897.03 118.27H1903.36V107.67H1897.03V118.27Z",
  fill: "white"
})), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
  d: "M1887.54 119.32H1895.99V106.65H1887.54V119.32Z",
  fill: "#FFDE0F"
})), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
  d: "M1897.03 120.38H1886.47V105.6H1897.03V120.38ZM1888.58 118.27H1894.91V107.67H1888.58V118.27Z",
  fill: "white"
})), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
  d: "M1887.54 132H1895.99V119.33H1887.54V132Z",
  fill: "#FFDE0F"
})), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
  d: "M1897.03 133.05H1886.47V118.27H1897.03V133.05ZM1888.58 130.94H1894.91V120.38H1888.58V130.94Z",
  fill: "white"
})), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
  d: "M1895.98 132H1904.43V119.33H1895.98V132Z",
  fill: "#FFDE0F"
})), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
  d: "M1905.48 133.05H1894.92V118.27H1905.48V133.05ZM1897.04 130.94H1903.37V120.38H1897.03L1897.04 130.94Z",
  fill: "white"
})), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
  d: "M1862.19 119.32H1870.64V106.65H1862.19V119.32Z",
  fill: "#FFDE0F"
})), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
  d: "M1871.69 120.38H1861.13V105.6H1871.69V120.38ZM1863.25 118.27H1869.58V107.67H1863.25V118.27Z",
  fill: "white"
})), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
  d: "M1853.75 119.32H1862.2V106.65H1853.75V119.32Z",
  fill: "#FFDE0F"
})), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
  d: "M1863.25 120.38H1852.69V105.6H1863.25V120.38ZM1854.8 118.27H1861.13V107.67H1854.8V118.27Z",
  fill: "white"
})), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
  d: "M1853.75 132H1862.2V119.33H1853.75V132Z",
  fill: "#FFDE0F"
})), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
  d: "M1863.25 133.05H1852.69V118.27H1863.25V133.05ZM1854.8 130.94H1861.13V120.38H1854.8V130.94Z",
  fill: "white"
})), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
  d: "M1862.19 132H1870.64V119.33H1862.19V132Z",
  fill: "#FFDE0F"
})), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
  d: "M1871.69 133.05H1861.13V118.27H1871.69V133.05ZM1863.25 130.94H1869.58V120.38H1863.25V130.94Z",
  fill: "white"
})), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
  d: "M1948.79 106.65H1931.89V148.89H1948.79V106.65Z",
  fill: "#DF3030"
})), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
  d: "M1949.83 148.89H1930.83V105.6H1949.83V148.89ZM1932.94 148.89H1947.72V107.67H1932.94V148.89Z",
  fill: "white"
})), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
  d: "M1944.55 121.44H1940.33V127.78H1944.55V121.44Z",
  fill: "white"
})), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
  d: "M1917.1 74.97H1942.45V58.08L1929.78 47.52L1917.1 58.08V74.97Z",
  fill: "#5FBB56"
})), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
  d: "M1904.43 64.41L1917.1 74.97V58.08H1904.43V64.41Z",
  fill: "#37AA2C"
})), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
  d: "M1917.1 58.08H1904.43L1917.1 47.52H1929.78L1917.1 58.08Z",
  fill: "#7F8C8D"
})), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
  d: "M1879.08 93.9799C1877.4 93.9773 1875.79 93.3082 1874.6 92.1195C1873.42 90.9308 1872.75 89.3197 1872.75 87.6399C1872.75 85.9611 1873.42 84.3511 1874.6 83.164C1875.79 81.9769 1877.4 81.3099 1879.08 81.3099C1879.91 81.3086 1880.74 81.4714 1881.51 81.7889C1882.27 82.1064 1882.97 82.5725 1883.56 83.1604C1884.15 83.7483 1884.62 84.4466 1884.94 85.2152C1885.26 85.9839 1885.42 86.8078 1885.42 87.6399C1885.42 89.3214 1884.75 90.934 1883.56 92.123C1882.37 93.312 1880.76 93.9799 1879.08 93.9799Z",
  fill: "#ECF0F1"
})), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
  d: "M2047.52 89.76H1963.04V148.89H2047.52V89.76Z",
  fill: "#FF3737"
})), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
  d: "M1963.04 89.76H2047.52L2072.86 68.64H1988.39L1963.04 89.76Z",
  fill: "#926445"
})), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
  d: "M2072.86 68.64L2047.52 89.76V148.89H2072.86H2098.21V89.76L2072.86 68.64Z",
  fill: "#DF3030"
})), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
  d: "M1979.94 106.65H1971.49V119.32H1979.94V106.65Z",
  fill: "#FFDE0F"
})), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
  d: "M1981.03 120.38H1970.43V105.6H1981.03V120.38ZM1972.58 118.27H1978.92V107.67H1972.58V118.27Z",
  fill: "white"
})), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
  d: "M1988.39 106.65H1979.94V119.32H1988.39V106.65Z",
  fill: "#FFDE0F"
})), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
  d: "M1989.44 120.38H1978.88V105.6H1989.44V120.38ZM1981.03 118.27H1987.37V107.67H1981.03V118.27Z",
  fill: "white"
})), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
  d: "M1988.39 119.32H1979.94V131.99H1988.39V119.32Z",
  fill: "#FFDE0F"
})), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
  d: "M1989.44 133.05H1978.88V118.27H1989.44V133.05ZM1980.99 130.94H1987.33V120.38H1981.03L1980.99 130.94Z",
  fill: "white"
})), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
  d: "M1979.94 119.32H1971.49V131.99H1979.94V119.32Z",
  fill: "#FFDE0F"
})), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
  d: "M1981.03 133.05H1970.43V118.27H1981.03V133.05ZM1972.58 130.94H1978.92V120.38H1972.58V130.94Z",
  fill: "white"
})), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
  d: "M2030.63 106.65H2022.18V119.32H2030.63V106.65Z",
  fill: "#8DD4FC"
})), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
  d: "M2031.68 120.38H2021.12V105.6H2031.68V120.38ZM2023.23 118.27H2029.56V107.67H2023.23V118.27Z",
  fill: "white"
})), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
  d: "M2039.07 106.65H2030.62V119.32H2039.07V106.65Z",
  fill: "#8DD4FC"
})), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
  d: "M2040.12 120.38H2029.56V105.6H2040.12V120.38ZM2031.68 118.27H2038.03V107.67H2031.7L2031.68 118.27Z",
  fill: "white"
})), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
  d: "M2039.07 119.32H2030.62V131.99H2039.07V119.32Z",
  fill: "#8DD4FC"
})), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
  d: "M2040.12 133.05H2029.56V118.27H2040.12V133.05ZM2031.68 130.94H2038.03V120.38H2031.7L2031.68 130.94Z",
  fill: "white"
})), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
  d: "M2030.63 119.32H2022.18V131.99H2030.63V119.32Z",
  fill: "#8DD4FC"
})), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
  d: "M2031.68 133.05H2021.12V118.27H2031.68V133.05ZM2023.23 130.94H2029.56V120.38H2023.23V130.94Z",
  fill: "white"
})), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
  d: "M2081.31 106.65H2072.86V119.32H2081.31V106.65Z",
  fill: "#8DD4FC"
})), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
  d: "M2082.36 120.38H2071.8V105.6H2082.36V120.38ZM2073.91 118.27H2080.25V107.67H2073.91V118.27Z",
  fill: "white"
})), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
  d: "M2089.76 106.65H2081.31V119.32H2089.76V106.65Z",
  fill: "#FFDE0F"
})), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
  d: "M2090.81 120.38H2080.25V105.6H2090.81V120.38ZM2082.36 118.27H2088.7V107.67H2082.36V118.27Z",
  fill: "white"
})), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
  d: "M2089.76 119.32H2081.31V131.99H2089.76V119.32Z",
  fill: "#FFDE0F"
})), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
  d: "M2090.81 133.05H2080.25V118.27H2090.81V133.05ZM2082.36 130.94H2088.7V120.38H2082.36V130.94Z",
  fill: "white"
})), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
  d: "M2081.31 119.32H2072.86V131.99H2081.31V119.32Z",
  fill: "#8DD4FC"
})), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
  d: "M2082.36 133.05H2071.8V118.27H2082.36V133.05ZM2073.91 130.94H2080.25V120.38H2073.91V130.94Z",
  fill: "white"
})), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
  d: "M2064.42 106.65H2055.97V119.32H2064.42V106.65Z",
  fill: "#8DD4FC"
})), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
  d: "M2065.47 120.38H2054.91V105.6H2065.47V120.38ZM2057.03 118.27H2063.36V107.67H2057.03V118.27Z",
  fill: "white"
})), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
  d: "M2072.86 106.65H2064.41V119.32H2072.86V106.65Z",
  fill: "#FFDE0F"
})), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
  d: "M2073.91 120.38H2063.35V105.6H2073.91V120.38ZM2065.47 118.27H2071.8V107.67H2065.47V118.27Z",
  fill: "white"
})), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
  d: "M2072.86 119.32H2064.41V131.99H2072.86V119.32Z",
  fill: "#FFDE0F"
})), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
  d: "M2073.91 133.05H2063.35V118.27H2073.91V133.05ZM2065.47 130.94H2071.8V120.38H2065.47V130.94Z",
  fill: "white"
})), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
  d: "M2064.42 119.32H2055.97V131.99H2064.42V119.32Z",
  fill: "#8DD4FC"
})), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
  d: "M2065.47 133.05H2054.91V118.27H2065.47V133.05ZM2057.02 130.94H2063.35V120.38H2057.03L2057.02 130.94Z",
  fill: "white"
})), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
  d: "M2026.4 79.2H2001.06V58.08L2013.73 49.63L2026.4 58.08V79.2Z",
  fill: "#FF3737"
})), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
  d: "M2039.07 68.64L2026.4 79.2V58.08H2039.07V68.64Z",
  fill: "#DF3030"
})), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
  d: "M2026.4 58.08H2039.07L2026.4 49.63H2013.73L2026.4 58.08Z",
  fill: "#926445"
})), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
  d: "M2013.73 106.65H1996.83V148.89H2013.73V106.65Z",
  fill: "#926445"
})), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
  d: "M2014.78 148.89H1995.78V105.6H2014.78V148.89ZM1997.89 148.89H2012.67V107.67H1997.89V148.89Z",
  fill: "white"
})), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
  d: "M2009.5 123.55H2005.28V129.89H2009.5V123.55Z",
  fill: "white"
})), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
  d: "M2077.09 87.64H2068.64V96.09H2077.09V87.64Z",
  fill: "#8DD4FC"
})), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
  d: "M2078.14 97.15H2067.58V86.59H2078.14V97.15ZM2069.69 95.04H2076.03V88.67H2069.69V95.04Z",
  fill: "white"
})), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
  d: "M2017.95 62.3H2009.5V70.75H2017.95V62.3Z",
  fill: "#8DD4FC"
})), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
  d: "M2019.03 71.8H2008.47V61.24H2019.03V71.8ZM2010.59 69.69H2016.92V63.36H2010.59V69.69Z",
  fill: "white"
})), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
  d: "M1322.06 93.98H1288.27V148.89H1322.06V93.98Z",
  fill: "#FF8537"
})), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
  d: "M1288.27 93.98H1322.07L1351.63 68.64H1317.84L1288.27 93.98Z",
  fill: "#37AA2C"
})), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
  d: "M1381.2 96.09L1351.63 68.64L1322.07 93.98V148.89H1381.2V96.09Z",
  fill: "#DF7430"
})), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
  d: "M1305.17 106.65H1296.72V119.32H1305.17V106.65Z",
  fill: "#FFDE0F"
})), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
  d: "M1306.22 120.38H1295.66V105.6H1306.22V120.38ZM1297.77 118.27H1304.11V107.67H1297.77V118.27Z",
  fill: "white"
})), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
  d: "M1313.62 106.65H1305.17V119.32H1313.62V106.65Z",
  fill: "#FFDE0F"
})), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
  d: "M1314.67 120.38H1304.11V105.6H1314.67V120.38ZM1306.22 118.27H1312.56V107.67H1306.22V118.27Z",
  fill: "white"
})), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
  d: "M1313.62 119.32H1305.17V131.99H1313.62V119.32Z",
  fill: "#FFDE0F"
})), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
  d: "M1314.67 133.05H1304.11V118.27H1314.67V133.05ZM1306.22 130.94H1312.56V120.38H1306.22V130.94Z",
  fill: "white"
})), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
  d: "M1305.17 119.32H1296.72V131.99H1305.17V119.32Z",
  fill: "#FFDE0F"
})), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
  d: "M1306.22 133.05H1295.66V118.27H1306.22V133.05ZM1297.77 130.94H1304.11V120.38H1297.77V130.94Z",
  fill: "white"
})), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
  d: "M1338.96 106.65H1330.51V119.32H1338.96V106.65Z",
  fill: "#FFDE0F"
})), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
  d: "M1340.03 120.38H1329.47V105.6H1340.03V120.38ZM1331.58 118.27H1337.92V107.67H1331.58V118.27Z",
  fill: "white"
})), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
  d: "M1347.41 106.65H1338.96V119.32H1347.41V106.65Z",
  fill: "#FFDE0F"
})), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
  d: "M1348.46 120.38H1337.9V105.6H1348.46V120.38ZM1340.03 118.27H1346.37V107.67H1340.03V118.27Z",
  fill: "white"
})), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
  d: "M1347.41 119.32H1338.96V131.99H1347.41V119.32Z",
  fill: "#FFDE0F"
})), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
  d: "M1348.46 133.05H1337.9V118.27H1348.46V133.05ZM1340.01 130.94H1346.35V120.38H1340.03L1340.01 130.94Z",
  fill: "white"
})), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
  d: "M1338.96 119.32H1330.51V131.99H1338.96V119.32Z",
  fill: "#FFDE0F"
})), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
  d: "M1340.03 133.05H1329.47V118.27H1340.03V133.05ZM1331.58 130.94H1337.92V120.38H1331.58V130.94Z",
  fill: "white"
})), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
  d: "M1330.51 58.08H1317.84V81.31L1330.51 70.45V58.08Z",
  fill: "#D3BBAF"
})), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
  d: "M1288.27 123.55H1254.48V148.89H1288.27V123.55Z",
  fill: "#DF7430"
})), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
  d: "M1288.27 110.88L1254.48 123.55H1288.27V110.88Z",
  fill: "#37AA2C"
})), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
  d: "M1271.38 132H1262.93V140.45H1271.38V132Z",
  fill: "#FFDE0F"
})), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
  d: "M1272.43 141.5H1261.87V130.94H1272.43V141.5ZM1263.98 139.39H1270.32V133.05H1264.03L1263.98 139.39Z",
  fill: "white"
})), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
  d: "M1279.83 132H1271.38V140.45H1279.83V132Z",
  fill: "#FFDE0F"
})), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
  d: "M1280.88 141.5H1270.32V130.94H1280.88V141.5ZM1272.43 139.39H1278.77V133.05H1272.43V139.39Z",
  fill: "white"
})), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
  d: "M1372.76 106.65H1355.86V148.89H1372.76V106.65Z",
  fill: "#D3BBAF"
})), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
  d: "M1373.8 148.89H1354.8V105.6H1373.8V148.89ZM1356.91 148.89H1371.69V107.67H1356.91V148.89Z",
  fill: "white"
})), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
  d: "M1368.52 122.49H1364.3V128.83H1368.52V122.49Z",
  fill: "white"
})), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
  d: "M1355.86 85.53H1347.41V98.2H1355.86V85.53Z",
  fill: "#ECF0F1"
})), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
  d: "M1723.85 89.76H1656.27V148.89H1723.85V89.76Z",
  fill: "#926445"
})), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
  d: "M1723.85 89.76H1656.27L1639.38 64.41H1706.96L1723.85 89.76Z",
  fill: "#D3BBAF"
})), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
  d: "M1639.38 64.41L1656.27 89.76V148.89H1622.48V89.76L1639.38 64.41Z",
  fill: "#C3855C"
})), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
  d: "M1706.96 119.32H1715.41V106.65H1706.96V119.32Z",
  fill: "#8DD4FC"
})), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
  d: "M1716.46 120.38H1705.9V105.6H1716.46V120.38ZM1708.03 118.27H1714.37V107.67H1708.03V118.27Z",
  fill: "white"
})), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
  d: "M1664.71 119.32H1673.16V106.65H1664.71V119.32Z",
  fill: "#8DD4FC"
})), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
  d: "M1674.22 120.38H1663.66V105.6H1674.22V120.38ZM1665.77 118.27H1672.11V107.67H1665.77V118.27Z",
  fill: "white"
})), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
  d: "M1664.71 132H1673.16V119.33H1664.71V132Z",
  fill: "#8DD4FC"
})), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
  d: "M1674.22 133.05H1663.66V118.27H1674.22V133.05ZM1665.77 130.94H1672.11V120.38H1665.77V130.94Z",
  fill: "white"
})), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
  d: "M1706.96 132H1715.41V119.33H1706.96V132Z",
  fill: "#8DD4FC"
})), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
  d: "M1716.46 133.05H1705.9V118.27H1716.46V133.05ZM1708.01 130.94H1714.35V120.38H1708.03L1708.01 130.94Z",
  fill: "white"
})), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
  d: "M1639.38 119.32H1647.83V106.65H1639.38V119.32Z",
  fill: "#FFDE0F"
})), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
  d: "M1648.88 120.38H1638.32V105.6H1648.88V120.38ZM1640.43 118.27H1646.76V107.67H1640.43V118.27Z",
  fill: "white"
})), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
  d: "M1630.93 119.32H1639.38V106.65H1630.93V119.32Z",
  fill: "#FFDE0F"
})), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
  d: "M1640.43 120.38H1629.87V105.6H1640.43V120.38ZM1632.03 118.27H1638.37V107.67H1632.03V118.27Z",
  fill: "white"
})), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
  d: "M1630.93 132H1639.38V119.33H1630.93V132Z",
  fill: "#FFDE0F"
})), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
  d: "M1640.43 133.05H1629.87V118.27H1640.43V133.05ZM1631.98 130.94H1638.32V120.38H1632.03L1631.98 130.94Z",
  fill: "white"
})), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
  d: "M1639.38 132H1647.83V119.33H1639.38V132Z",
  fill: "#FFDE0F"
})), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
  d: "M1648.88 133.05H1638.32V118.27H1648.88V133.05ZM1640.43 130.94H1646.76V120.38H1640.43V130.94Z",
  fill: "white"
})), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
  d: "M1698.52 106.65H1681.62V148.89H1698.52V106.65Z",
  fill: "#D3BBAF"
})), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
  d: "M1699.56 148.89H1680.56V105.6H1699.56V148.89ZM1682.67 148.89H1697.45V107.67H1682.67V148.89Z",
  fill: "white"
})), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
  d: "M1694.28 123.55H1690.06V129.89H1694.28V123.55Z",
  fill: "white"
})), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
  d: "M1635.15 93.98H1643.6V85.53H1635.15V93.98Z",
  fill: "#8DD4FC"
})), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
  d: "M1644.65 95.04H1634.09V84.48H1644.65V95.04ZM1636.2 92.92H1642.54V86.59H1636.2V92.92Z",
  fill: "white"
})), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
  d: "M1749.19 123.55H1723.85V148.89H1749.19V123.55Z",
  fill: "#C3855C"
})), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
  d: "M1723.85 123.55H1749.2L1723.85 106.65V123.55Z",
  fill: "#D3BBAF"
})), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
  d: "M1740.75 132H1732.3V140.45H1740.75V132Z",
  fill: "#8DD4FC"
})), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
  d: "M1741.8 141.5H1731.24V130.94H1741.8V141.5ZM1733.35 139.39H1739.69V133.05H1733.35V139.39Z",
  fill: "white"
})), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
  d: "M1675.28 51.74H1662.61V64.41L1675.28 83.42V51.74Z",
  fill: "#926445"
})), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
  d: "M1698.51 51.74H1685.84V64.41L1698.51 83.42V51.74Z",
  fill: "#926445"
})), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
  d: "M741.29 148.89H808.87V89.76H741.29V148.89Z",
  fill: "#BF2929"
})), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
  d: "M808.87 89.76H741.28L715.94 68.64H783.52L808.87 89.76Z",
  fill: "#D3BBAF"
})), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
  d: "M715.94 68.64L741.28 89.76V148.89H715.94H690.6V89.76L715.94 68.64Z",
  fill: "#DF3030"
})), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
  d: "M770.85 119.32H779.3V106.65H770.85V119.32Z",
  fill: "#FFDE0F"
})), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
  d: "M780.35 120.38H769.79V105.6H780.35V120.38ZM771.9 118.27H778.24V107.67H771.9V118.27Z",
  fill: "white"
})), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
  d: "M770.85 132H779.3V119.33H770.85V132Z",
  fill: "#FFDE0F"
})), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
  d: "M780.35 133.05H769.79V118.27H780.35V133.05ZM771.9 130.94H778.24V120.38H771.9V130.94Z",
  fill: "white"
})), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
  d: "M751.84 119.32H760.29V106.65H751.84V119.32Z",
  fill: "#FFDE0F"
})), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
  d: "M761.34 120.38H750.78V105.6H761.34V120.38ZM752.9 118.27H759.23V107.67H752.9V118.27Z",
  fill: "white"
})), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
  d: "M751.84 132H760.29V119.33H751.84V132Z",
  fill: "#FFDE0F"
})), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
  d: "M761.34 133.05H750.78V118.27H761.34V133.05ZM752.9 130.94H759.23V120.38H752.9V130.94Z",
  fill: "white"
})), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
  d: "M789.85 119.32H798.3V106.65H789.85V119.32Z",
  fill: "#FFDE0F"
})), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
  d: "M799.36 120.38H788.8V105.6H799.36V120.38ZM790.91 118.27H797.25V107.67H790.91V118.27Z",
  fill: "white"
})), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
  d: "M789.85 132H798.3V119.33H789.85V132Z",
  fill: "#FFDE0F"
})), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
  d: "M799.36 133.05H788.8V118.27H799.36V133.05ZM790.91 130.94H797.25V120.38H790.91V130.94Z",
  fill: "white"
})), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
  d: "M707.49 148.89H724.39V106.65H707.49V148.89Z",
  fill: "#D3BBAF"
})), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
  d: "M725.44 148.89H706.44V105.6H725.44V148.89ZM708.55 148.89H723.33V107.67H708.55V148.89Z",
  fill: "white"
})), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
  d: "M715.94 123.55H711.72V129.89H715.94V123.55Z",
  fill: "white"
})), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
  d: "M758.18 79.2H783.52V58.08L770.85 49.63L758.18 58.08V79.2Z",
  fill: "#BF2929"
})), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
  d: "M745.51 68.64L758.18 79.2V58.08H745.51V68.64Z",
  fill: "#DF3030"
})), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
  d: "M758.18 58.08H745.51L758.18 49.63H770.85L758.18 58.08Z",
  fill: "#D3BBAF"
})), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
  d: "M711.72 96.1H720.17V87.65H711.72V96.1Z",
  fill: "#8DD4FC"
})), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
  d: "M721.22 97.15H710.66V86.59H721.22V97.15ZM712.77 95.04H719.11V88.67H712.77V95.04Z",
  fill: "white"
})), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
  d: "M766.63 70.75H775.08V62.3H766.63V70.75Z",
  fill: "#8DD4FC"
})), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
  d: "M776.13 71.8H765.57V61.24H776.13V71.8ZM767.68 69.67H774.03V63.34H767.69L767.68 69.67Z",
  fill: "white"
})), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
  d: "M238.64 64.41H179.51V148.89H238.64V64.41Z",
  fill: "#DF7430"
})), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
  d: "M179.51 148.89H120.38V64.41L149.95 39.0699L179.51 64.41V148.89Z",
  fill: "#FF8537"
})), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
  d: "M179.51 64.41H238.65L209.08 39.0699H149.95L179.51 64.41Z",
  fill: "#C3855C"
})), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
  d: "M196.41 89.76H204.86V77.09H196.41V89.76Z",
  fill: "#FFDE0F"
})), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
  d: "M205.91 90.81H195.35V76.03H205.91V90.81ZM197.46 88.67H203.8V78.14H197.46V88.67Z",
  fill: "white"
})), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
  d: "M187.96 89.76H196.41V77.09H187.96V89.76Z",
  fill: "#FFDE0F"
})), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
  d: "M197.46 90.81H186.9V76.03H197.46V90.81ZM189.03 88.67H195.37V78.14H189.03V88.67Z",
  fill: "white"
})), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
  d: "M196.41 102.42H204.86V89.75H196.41V102.42Z",
  fill: "#FFDE0F"
})), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
  d: "M205.91 103.48H195.35V88.67H205.91V103.48ZM197.46 101.37H203.8V90.81H197.46V101.37Z",
  fill: "white"
})), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
  d: "M187.96 102.42H196.41V89.75H187.96V102.42Z",
  fill: "#FFDE0F"
})), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
  d: "M197.46 103.48H186.9V88.67H197.46V103.48ZM189.03 101.37H195.37V90.81H189.03V101.37Z",
  fill: "white"
})), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
  d: "M196.41 123.54H204.86V110.87H196.41V123.54Z",
  fill: "#FFDE0F"
})), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
  d: "M205.91 124.6H195.35V109.82H205.91V124.6ZM197.46 122.49H203.8V111.93H197.46V122.49Z",
  fill: "white"
})), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
  d: "M187.96 123.54H196.41V110.87H187.96V123.54Z",
  fill: "#FFDE0F"
})), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
  d: "M197.46 124.6H186.9V109.82H197.46V124.6ZM189.03 122.49H195.37V111.93H189.03V122.49Z",
  fill: "white"
})), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
  d: "M196.41 136.22H204.86V123.55H196.41V136.22Z",
  fill: "#FFDE0F"
})), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
  d: "M205.91 137.27H195.35V122.49H205.91V137.27ZM197.46 135.16H203.8V124.6H197.46V135.16Z",
  fill: "white"
})), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
  d: "M187.96 136.22H196.41V123.55H187.96V136.22Z",
  fill: "#FFDE0F"
})), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
  d: "M197.46 137.27H186.9V122.49H197.46V137.27ZM189.03 135.16H195.37V124.6H189.03V135.16Z",
  fill: "white"
})), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
  d: "M221.75 89.76H230.2V77.09H221.75V89.76Z",
  fill: "#FFDE0F"
})), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
  d: "M231.25 90.81H220.69V76.03H231.25V90.81ZM222.8 88.67H229.14V78.14H222.8V88.67Z",
  fill: "white"
})), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
  d: "M213.3 89.76H221.75V77.09H213.3V89.76Z",
  fill: "#FFDE0F"
})), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
  d: "M222.8 90.81H212.24V76.03H222.8V90.81ZM214.36 88.67H220.69V78.14H214.36V88.67Z",
  fill: "white"
})), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
  d: "M221.75 102.42H230.2V89.75H221.75V102.42Z",
  fill: "#FFDE0F"
})), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
  d: "M231.25 103.48H220.69V88.67H231.25V103.48ZM222.8 101.37H229.14V90.81H222.8V101.37Z",
  fill: "white"
})), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
  d: "M213.3 102.42H221.75V89.75H213.3V102.42Z",
  fill: "#FFDE0F"
})), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
  d: "M222.8 103.48H212.24V88.67H222.8V103.48ZM214.36 101.37H220.69V90.81H214.36V101.37Z",
  fill: "white"
})), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
  d: "M221.75 123.54H230.2V110.87H221.75V123.54Z",
  fill: "#FFDE0F"
})), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
  d: "M231.25 124.6H220.69V109.82H231.25V124.6ZM222.8 122.49H229.14V111.93H222.8V122.49Z",
  fill: "white"
})), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
  d: "M213.3 123.54H221.75V110.87H213.3V123.54Z",
  fill: "#FFDE0F"
})), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
  d: "M222.8 124.6H212.24V109.82H222.8V124.6ZM214.36 122.49H220.69V111.93H214.36V122.49Z",
  fill: "white"
})), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
  d: "M221.75 136.22H230.2V123.55H221.75V136.22Z",
  fill: "#FFDE0F"
})), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
  d: "M231.25 137.27H220.69V122.49H231.25V137.27ZM222.8 135.16H229.14V124.6H222.8V135.16Z",
  fill: "white"
})), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
  d: "M213.3 136.22H221.75V123.55H213.3V136.22Z",
  fill: "#FFDE0F"
})), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
  d: "M222.8 137.27H212.24V122.49H222.8V137.27ZM214.36 135.16H220.69V124.6H214.36V135.16Z",
  fill: "white"
})), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
  d: "M162.62 89.76H171.07V77.09H162.62V89.76Z",
  fill: "#FFDE0F"
})), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
  d: "M172.12 90.81H161.56V76.03H172.12V90.81ZM163.67 88.67H170.03V78.14H163.69L163.67 88.67Z",
  fill: "white"
})), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
  d: "M154.16 89.76H162.61V77.09H154.16V89.76Z",
  fill: "#FFDE0F"
})), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
  d: "M163.67 90.81H153.11V76.03H163.67V90.81ZM155.22 88.67H161.56V78.14H155.22V88.67Z",
  fill: "white"
})), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
  d: "M162.62 102.42H171.07V89.75H162.62V102.42Z",
  fill: "#FFDE0F"
})), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
  d: "M172.12 103.48H161.56V88.67H172.12V103.48ZM163.67 101.37H170.03V90.81H163.69L163.67 101.37Z",
  fill: "white"
})), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
  d: "M154.16 102.42H162.61V89.75H154.16V102.42Z",
  fill: "#FFDE0F"
})), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
  d: "M163.67 103.48H153.11V88.67H163.67V103.48ZM155.22 101.37H161.56V90.81H155.22V101.37Z",
  fill: "white"
})), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
  d: "M137.27 89.76H145.72V77.09H137.27V89.76Z",
  fill: "#FFDE0F"
})), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
  d: "M146.77 90.81H136.21V76.03H146.77V90.81ZM138.33 88.67H144.66V78.14H138.33V88.67Z",
  fill: "white"
})), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
  d: "M128.83 89.76H137.28V77.09H128.83V89.76Z",
  fill: "#FFDE0F"
})), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
  d: "M138.33 90.81H127.77V76.03H138.33V90.81ZM129.88 88.67H136.21V78.14H129.88V88.67Z",
  fill: "white"
})), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
  d: "M137.27 102.42H145.72V89.75H137.27V102.42Z",
  fill: "#FFDE0F"
})), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
  d: "M146.77 103.48H136.21V88.67H146.77V103.48ZM138.33 101.37H144.66V90.81H138.33V101.37Z",
  fill: "white"
})), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
  d: "M128.83 102.42H137.28V89.75H128.83V102.42Z",
  fill: "#FFDE0F"
})), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
  d: "M138.33 103.48H127.77V88.67H138.33V103.48ZM129.88 101.37H136.21V90.81H129.88V101.37Z",
  fill: "white"
})), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
  d: "M137.27 123.54H145.72V110.87H137.27V123.54Z",
  fill: "#FFDE0F"
})), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
  d: "M146.77 124.6H136.21V109.82H146.77V124.6ZM138.33 122.49H144.66V111.93H138.33V122.49Z",
  fill: "white"
})), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
  d: "M128.83 123.54H137.28V110.87H128.83V123.54Z",
  fill: "#FFDE0F"
})), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
  d: "M138.33 124.6H127.77V109.82H138.33V124.6ZM129.88 122.49H136.21V111.93H129.88V122.49Z",
  fill: "white"
})), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
  d: "M137.27 136.22H145.72V123.55H137.27V136.22Z",
  fill: "#FFDE0F"
})), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
  d: "M146.77 137.27H136.21V122.49H146.77V137.27ZM138.33 135.16H144.66V124.6H138.33V135.16Z",
  fill: "white"
})), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
  d: "M128.83 136.22H137.28V123.55H128.83V136.22Z",
  fill: "#FFDE0F"
})), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
  d: "M138.33 137.27H127.77V122.49H138.33V137.27ZM129.88 135.16H136.21V124.6H129.88V135.16Z",
  fill: "white"
})), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
  d: "M154.17 68.67H145.72V60.22C145.72 59.1008 146.165 58.0274 146.956 57.236C147.747 56.4446 148.821 56 149.94 56C150.495 55.9987 151.045 56.1069 151.558 56.3184C152.071 56.5299 152.538 56.8405 152.93 57.2325C153.323 57.6245 153.635 58.0901 153.848 58.6028C154.061 59.1154 154.17 59.665 154.17 60.22V68.67Z",
  fill: "#8DD4FC"
})), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
  d: "M155.22 69.67H144.66V60.17C144.66 58.7697 145.216 57.4267 146.206 56.4365C147.197 55.4463 148.54 54.89 149.94 54.89C151.34 54.89 152.683 55.4463 153.674 56.4365C154.664 57.4267 155.22 58.7697 155.22 60.17V69.67ZM146.77 67.56H153.11V60.17C153.11 59.3293 152.776 58.523 152.182 57.9285C151.587 57.334 150.781 57 149.94 57C149.099 57 148.293 57.334 147.698 57.9285C147.104 58.523 146.77 59.3293 146.77 60.17V67.56Z",
  fill: "white"
})), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
  d: "M190.07 45.1V30.62H202.75V55.97L190.07 45.1Z",
  fill: "#FF8537"
})), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
  d: "M154.16 148.89H171.06V110.88H154.16V148.89Z",
  fill: "#926445"
})), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
  d: "M172.12 148.89H153.12V109.82H172.12V148.89ZM155.22 148.89H170.03V111.89H155.22V148.89Z",
  fill: "white"
})), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
  d: "M166.84 125.66H162.62V132H166.84V125.66Z",
  fill: "white"
})), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
  d: "M118.26 87.64H59.13V148.89H118.26V87.64Z",
  fill: "#DF3030"
})), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
  d: "M59.13 148.89H0V87.64L29.57 62.3L59.13 87.64V148.89Z",
  fill: "#FF3737"
})), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
  d: "M59.13 87.64H118.27L88.7 62.3H29.57L59.13 87.64Z",
  fill: "#F1C40F"
})), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
  d: "M76.02 119.32H84.47V106.65H76.02V119.32Z",
  fill: "#FFDE0F"
})), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
  d: "M85.53 120.38H74.97V105.6H85.53V120.38ZM77.08 118.27H83.42V107.67H77.08V118.27Z",
  fill: "white"
})), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
  d: "M67.58 119.32H76.03V106.65H67.58V119.32Z",
  fill: "#FFDE0F"
})), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
  d: "M77.08 120.38H66.52V105.6H77.08V120.38ZM68.63 118.27H74.97V107.67H68.63V118.27Z",
  fill: "white"
})), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
  d: "M76.02 132H84.47V119.33H76.02V132Z",
  fill: "#FFDE0F"
})), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
  d: "M85.53 133.05H74.97V118.27H85.53V133.05ZM77.08 130.94H83.42V120.38H77.08V130.94Z",
  fill: "white"
})), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
  d: "M67.58 132H76.03V119.33H67.58V132Z",
  fill: "#FFDE0F"
})), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
  d: "M77.08 133.05H66.52V118.27H77.08V133.05ZM68.63 130.94H74.97V120.38H68.63V130.94Z",
  fill: "white"
})), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
  d: "M101.37 119.32H109.82V106.65H101.37V119.32Z",
  fill: "#FFDE0F"
})), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
  d: "M110.87 120.38H100.31V105.6H110.87V120.38ZM102.42 118.27H108.76V107.67H102.42V118.27Z",
  fill: "white"
})), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
  d: "M92.92 119.32H101.37V106.65H92.92V119.32Z",
  fill: "#FFDE0F"
})), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
  d: "M102.42 120.38H91.86V105.6H102.42V120.38ZM94.03 118.27H100.36V107.67H94.03V118.27Z",
  fill: "white"
})), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
  d: "M101.37 132H109.82V119.33H101.37V132Z",
  fill: "#FFDE0F"
})), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
  d: "M110.87 133.05H100.31V118.27H110.87V133.05ZM102.42 130.94H108.76V120.38H102.42V130.94Z",
  fill: "white"
})), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
  d: "M92.92 132H101.37V119.33H92.92V132Z",
  fill: "#FFDE0F"
})), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
  d: "M102.42 133.05H91.86V118.27H102.42V133.05ZM94.03 130.94H100.36V120.38H94.03V130.94Z",
  fill: "white"
})), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
  d: "M16.89 119.32H25.34V106.65H16.89V119.32Z",
  fill: "#FFDE0F"
})), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
  d: "M26.39 120.38H15.84V105.6H26.39V120.38ZM17.95 118.27H24.28V107.67H17.95V118.27Z",
  fill: "white"
})), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
  d: "M8.45002 119.32H16.9V106.65H8.45002L8.45002 119.32Z",
  fill: "#FFDE0F"
})), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
  d: "M17.95 120.38H7.39001V105.6H17.95V120.38ZM9.50002 118.27H15.84V107.67H9.50002V118.27Z",
  fill: "white"
})), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
  d: "M16.89 132H25.34V119.33H16.89V132Z",
  fill: "#FFDE0F"
})), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
  d: "M26.39 133.05H15.84V118.27H26.39V133.05ZM17.95 130.94H24.28V120.38H17.95V130.94Z",
  fill: "white"
})), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
  d: "M8.45002 132H16.9V119.33H8.45002L8.45002 132Z",
  fill: "#FFDE0F"
})), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
  d: "M17.95 133.05H7.39001V118.27H17.95V133.05ZM9.50002 130.94H15.84V120.38H9.50002V130.94Z",
  fill: "white"
})), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
  d: "M33.79 91.87H25.34V83.42C25.34 82.3008 25.7846 81.2274 26.576 80.436C27.3674 79.6446 28.4408 79.2 29.56 79.2C30.115 79.1986 30.6649 79.3068 31.178 79.5183C31.6912 79.7298 32.1576 80.0404 32.5505 80.4324C32.9434 80.8244 33.2551 81.2901 33.4678 81.8027C33.6805 82.3154 33.79 82.8649 33.79 83.42V91.87Z",
  fill: "#FFDE0F"
})), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
  d: "M34.84 92.92H24.28V83.42C24.28 82.0197 24.8363 80.6767 25.8265 79.6865C26.8167 78.6963 28.1597 78.14 29.56 78.14C30.9604 78.14 32.3034 78.6963 33.2936 79.6865C34.2837 80.6767 34.84 82.0197 34.84 83.42V92.92ZM26.39 90.81H32.73V83.42C32.73 82.5793 32.396 81.773 31.8016 81.1785C31.2071 80.584 30.4008 80.25 29.56 80.25C28.7193 80.25 27.913 80.584 27.3185 81.1785C26.724 81.773 26.39 82.5793 26.39 83.42V90.81Z",
  fill: "white"
})), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
  d: "M33.78 148.89H50.68L50.68 106.65H33.78V148.89Z",
  fill: "#5FBB56"
})), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
  d: "M51.74 148.89H32.74V105.6H51.74V148.89ZM34.84 148.89H49.63V107.67H34.84V148.89Z",
  fill: "white"
})), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
  d: "M46.46 123.55H42.24V129.89H46.46V123.55Z",
  fill: "white"
})), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
  d: "M67.58 77.08H92.92V60.19L80.25 49.63L67.58 60.19V77.08Z",
  fill: "#DF3030"
})), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
  d: "M54.91 66.5299L67.58 77.0799V60.1899H54.91V66.5299Z",
  fill: "#FF3737"
})), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
  d: "M67.58 60.19H54.91L67.58 49.63H80.25L67.58 60.19Z",
  fill: "#F1C40F"
})), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
  d: "M1170 66.53H1131.99V148.9H1170V66.53Z",
  fill: "#6163C7"
})), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
  d: "M1224.92 41.1801H1199.57L1170.01 66.5301V148.89H1254.48V66.5301L1224.92 41.1801Z",
  fill: "#5557AE"
})), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
  d: "M1170.01 66.5301H1131.99L1161.56 41.1801H1199.57L1170.01 66.5301Z",
  fill: "#DF3030"
})), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
  d: "M1151 77.09H1142.55V89.76H1151V77.09Z",
  fill: "#FFDE0F"
})), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
  d: "M1152.03 90.81H1141.47V76.03H1152.03V90.81ZM1143.58 88.7H1149.92V78.14H1143.58V88.7Z",
  fill: "white"
})), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
  d: "M1159.45 77.09H1151V89.76H1159.45V77.09Z",
  fill: "#FFDE0F"
})), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
  d: "M1160.5 90.81H1149.94V76.03H1160.5V90.81ZM1152.03 88.67H1158.37V78.14H1152.03V88.67Z",
  fill: "white"
})), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
  d: "M1151 89.76H1142.55V102.43H1151V89.76Z",
  fill: "#FFDE0F"
})), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
  d: "M1152.03 103.48H1141.47V88.67H1152.03V103.48ZM1143.58 101.37H1149.92V90.81H1143.58V101.37Z",
  fill: "white"
})), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
  d: "M1159.45 89.76H1151V102.43H1159.45V89.76Z",
  fill: "#FFDE0F"
})), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
  d: "M1160.5 103.48H1149.94V88.67H1160.5V103.48ZM1152.03 101.37H1158.37V90.81H1152.03V101.37Z",
  fill: "white"
})), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
  d: "M1151 110.88H1142.55V123.55H1151V110.88Z",
  fill: "#FFDE0F"
})), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
  d: "M1152.03 124.6H1141.47V109.82H1152.03V124.6ZM1143.58 122.49H1149.92V111.93H1143.58V122.49Z",
  fill: "white"
})), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
  d: "M1159.45 110.88H1151V123.55H1159.45V110.88Z",
  fill: "#FFDE0F"
})), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
  d: "M1160.5 124.6H1149.94V109.82H1160.5V124.6ZM1152.05 122.49H1158.39V111.93H1152.03L1152.05 122.49Z",
  fill: "white"
})), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
  d: "M1151 123.55H1142.55V136.22H1151V123.55Z",
  fill: "#FFDE0F"
})), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
  d: "M1152.03 137.27H1141.47V122.49H1152.03V137.27ZM1143.58 135.16H1149.92V124.6H1143.58V135.16Z",
  fill: "white"
})), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
  d: "M1159.45 123.55H1151V136.22H1159.45V123.55Z",
  fill: "#FFDE0F"
})), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
  d: "M1160.5 137.27H1149.94V122.49H1160.5V137.27ZM1152.05 135.16H1158.39V124.6H1152.03L1152.05 135.16Z",
  fill: "white"
})), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.7 110.88H1203.8V148.89H1220.7V110.88Z",
  fill: "#C3855C"
})), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 148.89H1202.74V109.82H1221.74V148.89ZM1204.85 148.89H1219.63V111.89H1204.85V148.89Z",
  fill: "white"
})), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
  d: "M1212.25 110.88H1203.8V123.55H1212.25V110.88Z",
  fill: "#FFDE0F"
})), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.3 124.6H1202.74V109.82H1213.3V124.6ZM1204.85 122.49H1211.18V111.93H1204.85V122.49Z",
  fill: "white"
})), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.69 110.88H1212.24V123.55H1220.69V110.88Z",
  fill: "#FFDE0F"
})), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 124.6H1211.18V109.82H1221.74V124.6ZM1213.3 122.49H1219.63V111.93H1213.3V122.49Z",
  fill: "white"
})), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
  d: "M1186.9 77.09H1178.45V89.76H1186.9V77.09Z",
  fill: "#FFDE0F"
})), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
  d: "M1187.95 90.81H1177.39V76.03H1187.95V90.81ZM1179.51 88.7H1185.84V78.14H1179.51V88.7Z",
  fill: "white"
})), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
  d: "M1195.35 77.09H1186.9V89.76H1195.35V77.09Z",
  fill: "#FFDE0F"
})), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
  d: "M1196.4 90.81H1185.84V76.03H1196.4V90.81ZM1187.95 88.7H1194.29V78.14H1187.95V88.7Z",
  fill: "white"
})), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
  d: "M1186.9 89.76H1178.45V102.43H1186.9V89.76Z",
  fill: "#FFDE0F"
})), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
  d: "M1187.95 103.48H1177.39V88.67H1187.95V103.48ZM1179.51 101.37H1185.84V90.81H1179.51V101.37Z",
  fill: "white"
})), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
  d: "M1195.35 89.76H1186.9V102.43H1195.35V89.76Z",
  fill: "#FFDE0F"
})), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
  d: "M1196.4 103.48H1185.84V88.67H1196.4V103.48ZM1187.95 101.37H1194.29V90.81H1187.95V101.37Z",
  fill: "white"
})), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
  d: "M1186.9 110.88H1178.45V123.55H1186.9V110.88Z",
  fill: "#FFDE0F"
})), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
  d: "M1187.95 124.6H1177.39V109.82H1187.95V124.6ZM1179.51 122.49H1185.84V111.93H1179.51V122.49Z",
  fill: "white"
})), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
  d: "M1195.35 110.88H1186.9V123.55H1195.35V110.88Z",
  fill: "#FFDE0F"
})), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
  d: "M1196.4 124.6H1185.84V109.82H1196.4V124.6ZM1187.95 122.49H1194.29V111.93H1187.95V122.49Z",
  fill: "white"
})), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
  d: "M1186.9 123.55H1178.45V136.22H1186.9V123.55Z",
  fill: "#FFDE0F"
})), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
  d: "M1187.95 137.27H1177.39V122.49H1187.95V137.27ZM1179.51 135.16H1185.84V124.6H1179.51V135.16Z",
  fill: "white"
})), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
  d: "M1195.35 123.55H1186.9V136.22H1195.35V123.55Z",
  fill: "#FFDE0F"
})), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
  d: "M1196.4 137.27H1185.84V122.49H1196.4V137.27ZM1187.95 135.16H1194.29V124.6H1187.95V135.16Z",
  fill: "white"
})), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
  d: "M1212.25 77.09H1203.8V89.76H1212.25V77.09Z",
  fill: "#FFDE0F"
})), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.3 90.81H1202.74V76.03H1213.3V90.81ZM1204.85 88.7H1211.18V78.14H1204.85V88.7Z",
  fill: "white"
})), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.69 77.09H1212.24V89.76H1220.69V77.09Z",
  fill: "#FFDE0F"
})), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 90.81H1211.18V76.03H1221.74V90.81ZM1213.3 88.7H1219.63V78.14H1213.3V88.7Z",
  fill: "white"
})), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
  d: "M1212.25 89.76H1203.8V102.43H1212.25V89.76Z",
  fill: "#FFDE0F"
})), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.3 103.48H1202.74V88.67H1213.3V103.48ZM1204.85 101.37H1211.18V90.81H1204.85V101.37Z",
  fill: "white"
})), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.69 89.76H1212.24V102.43H1220.69V89.76Z",
  fill: "#FFDE0F"
})), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 103.48H1211.18V88.67H1221.74V103.48ZM1213.3 101.37H1219.63V90.81H1213.3V101.37Z",
  fill: "white"
})), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.59 77.09H1229.14V89.76H1237.59V77.09Z",
  fill: "#FFDE0F"
})), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
  d: "M1238.64 90.81H1228.08V76.03H1238.64V90.81ZM1230.19 88.7H1236.53V78.14H1230.19V88.7Z",
  fill: "white"
})), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
  d: "M1246.04 77.09H1237.59V89.76H1246.04V77.09Z",
  fill: "#FFDE0F"
})), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.09 90.81H1236.53V76.03H1247.09V90.81ZM1238.64 88.7H1245.03V78.14H1238.69L1238.64 88.7Z",
  fill: "white"
})), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.59 89.76H1229.14V102.43H1237.59V89.76Z",
  fill: "#FFDE0F"
})), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
  d: "M1238.64 103.48H1228.08V88.67H1238.64V103.48ZM1230.19 101.37H1236.53V90.81H1230.19V101.37Z",
  fill: "white"
})), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
  d: "M1246.04 89.76H1237.59V102.43H1246.04V89.76Z",
  fill: "#FFDE0F"
})), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.09 103.48H1236.53V88.67H1247.09V103.48ZM1238.64 101.37H1245.03V90.81H1238.69L1238.64 101.37Z",
  fill: "white"
})), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.59 110.88H1229.14V123.55H1237.59V110.88Z",
  fill: "#FFDE0F"
})), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
  d: "M1238.64 124.6H1228.08V109.82H1238.64V124.6ZM1230.19 122.49H1236.53V111.93H1230.19V122.49Z",
  fill: "white"
})), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
  d: "M1246.04 110.88H1237.59V123.55H1246.04V110.88Z",
  fill: "#FFDE0F"
})), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.09 124.6H1236.53V109.82H1247.09V124.6ZM1238.64 122.49H1245.03V111.93H1238.69L1238.64 122.49Z",
  fill: "white"
})), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
  d: "M1237.59 123.55H1229.14V136.22H1237.59V123.55Z",
  fill: "#FFDE0F"
})), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
  d: "M1238.64 137.27H1228.08V122.49H1238.64V137.27ZM1230.19 135.16H1236.53V124.6H1230.19V135.16Z",
  fill: "white"
})), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
  d: "M1246.04 123.55H1237.59V136.22H1246.04V123.55Z",
  fill: "#FFDE0F"
})), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
  d: "M1247.09 137.27H1236.53V122.49H1247.09V137.27ZM1238.64 135.16H1245.03V124.6H1238.69L1238.64 135.16Z",
  fill: "white"
})), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
  d: "M1212.25 51.74H1203.8V60.19H1212.25V51.74Z",
  fill: "#FFDE0F"
})), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.3 61.2401H1202.74V50.67H1213.3V61.2401ZM1204.85 59.1301H1211.18V52.8H1204.85V59.1301Z",
  fill: "white"
})), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
  d: "M1212.25 60.1899H1203.8V68.6399H1212.25V60.1899Z",
  fill: "#FFDE0F"
})), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
  d: "M1213.3 69.67H1202.74V59.13H1213.3V69.67ZM1204.85 67.56H1211.18V61.22H1204.85V67.56Z",
  fill: "white"
})), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.69 51.74H1212.24V60.19H1220.69V51.74Z",
  fill: "#FFDE0F"
})), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 61.2401H1211.18V50.67H1221.74V61.2401ZM1213.3 59.1301H1219.63V52.8H1213.3V59.1301Z",
  fill: "white"
})), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
  d: "M1220.69 60.1899H1212.24V68.6399H1220.69V60.1899Z",
  fill: "#FFDE0F"
})), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
  d: "M1221.74 69.67H1211.18V59.13H1221.74V69.67ZM1213.3 67.56H1219.63V61.22H1213.3V67.56Z",
  fill: "white"
})), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
  d: "M1093.98 148.89H1131.99V96.09H1093.98V148.89Z",
  fill: "#B5930B"
})), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
  d: "M1039.07 70.75H1064.41L1093.98 96.09V148.89H1009.5V96.09L1039.07 70.75Z",
  fill: "#F1C40F"
})), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
  d: "M1093.98 96.09H1131.99L1102.42 70.75H1064.41L1093.98 96.09Z",
  fill: "#926445"
})), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
  d: "M1051.74 123.54H1060.19V110.87H1051.74V123.54Z",
  fill: "#8DD4FC"
})), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
  d: "M1061.24 124.6H1050.68V109.82H1061.24V124.6ZM1052.79 122.49H1059.13V111.93H1052.79V122.49Z",
  fill: "white"
})), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
  d: "M1043.28 123.54H1051.73V110.87H1043.28V123.54Z",
  fill: "#8DD4FC"
})), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
  d: "M1052.79 124.6H1042.23V109.82H1052.79V124.6ZM1044.34 122.49H1050.68V111.93H1044.34V122.49Z",
  fill: "white"
})), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
  d: "M1051.74 136.22H1060.19V123.55H1051.74V136.22Z",
  fill: "#8DD4FC"
})), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
  d: "M1061.24 137.27H1050.68V122.49H1061.24V137.27ZM1052.79 135.16H1059.13V124.6H1052.79V135.16Z",
  fill: "white"
})), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
  d: "M1043.28 136.22H1051.73V123.55H1043.28V136.22Z",
  fill: "#8DD4FC"
})), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
  d: "M1052.79 137.27H1042.23V122.49H1052.79V137.27ZM1044.34 135.16H1050.68V124.6H1044.34V135.16Z",
  fill: "white"
})), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
  d: "M1104.53 148.89H1121.43V110.88H1104.53V148.89Z",
  fill: "#926445"
})), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
  d: "M1122.48 148.89H1103.48V109.82H1122.48V148.89ZM1105.59 148.89H1120.37V111.89H1105.59V148.89Z",
  fill: "white"
})), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
  d: "M1112.98 123.54H1121.43V110.87H1112.98V123.54Z",
  fill: "#8DD4FC"
})), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
  d: "M1122.48 124.6H1111.92V109.82H1122.48V124.6ZM1114.04 122.49H1120.37V111.93H1114.03L1114.04 122.49Z",
  fill: "white"
})), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
  d: "M1104.54 123.54H1112.99V110.87H1104.54V123.54Z",
  fill: "#8DD4FC"
})), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
  d: "M1114.03 124.6H1103.47V109.82H1114.03V124.6ZM1105.58 122.49H1111.91V111.93H1105.58V122.49Z",
  fill: "white"
})), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
  d: "M1077.08 123.54H1085.53V110.87H1077.08V123.54Z",
  fill: "#8DD4FC"
})), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
  d: "M1086.58 124.6H1076.03V109.82H1086.59L1086.58 124.6ZM1078.13 122.49H1084.47V111.93H1078.13V122.49Z",
  fill: "white"
})), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
  d: "M1068.63 123.54H1077.08V110.87H1068.63V123.54Z",
  fill: "#8DD4FC"
})), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
  d: "M1078.13 124.6H1067.57V109.82H1078.13V124.6ZM1069.69 122.49H1076.03V111.93H1069.7L1069.69 122.49Z",
  fill: "white"
})), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
  d: "M1077.08 136.22H1085.53V123.55H1077.08V136.22Z",
  fill: "#8DD4FC"
})), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
  d: "M1086.58 137.27H1076.03V122.49H1086.59L1086.58 137.27ZM1078.13 135.16H1084.47V124.6H1078.13V135.16Z",
  fill: "white"
})), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
  d: "M1068.63 136.22H1077.08V123.55H1068.63V136.22Z",
  fill: "#8DD4FC"
})), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
  d: "M1078.13 137.27H1067.57V122.49H1078.13V137.27ZM1069.69 135.16H1076.03V124.6H1069.7L1069.69 135.16Z",
  fill: "white"
})), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
  d: "M1026.39 123.54H1034.84V110.87H1026.39V123.54Z",
  fill: "#8DD4FC"
})), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.89 124.6H1025.33V109.82H1035.89V124.6ZM1027.45 122.49H1033.78V111.93H1027.45V122.49Z",
  fill: "white"
})), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
  d: "M1017.95 123.54H1026.4V110.87H1017.95V123.54Z",
  fill: "#8DD4FC"
})), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
  d: "M1027.45 124.6H1016.89V109.82H1027.45V124.6ZM1019 122.49H1025.33V111.93H1019.03L1019 122.49Z",
  fill: "white"
})), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
  d: "M1026.39 136.22H1034.84V123.55H1026.39V136.22Z",
  fill: "#8DD4FC"
})), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.89 137.27H1025.33V122.49H1035.89V137.27ZM1027.45 135.16H1033.78V124.6H1027.45V135.16Z",
  fill: "white"
})), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
  d: "M1017.95 136.22H1026.4V123.55H1017.95V136.22Z",
  fill: "#8DD4FC"
})), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
  d: "M1027.45 137.27H1016.89V122.49H1027.45V137.27ZM1019 135.16H1025.33V124.6H1019.03L1019 135.16Z",
  fill: "white"
})), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
  d: "M1060.19 87.64H1051.74V96.09H1060.19V87.64Z",
  fill: "#8DD4FC"
})), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
  d: "M1061.24 97.15H1050.68V86.59H1061.24V97.15ZM1052.79 95.04H1059.13V88.67H1052.79V95.04Z",
  fill: "white"
})), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
  d: "M1051.74 87.64H1043.29V96.09H1051.74V87.64Z",
  fill: "#8DD4FC"
})), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
  d: "M1052.79 97.15H1042.23V86.59H1052.79V97.15ZM1044.34 95.04H1050.68V88.67H1044.34V95.04Z",
  fill: "white"
})), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
  d: "M1102.42 64.41H1089.75V76.78L1102.42 87.64V64.41Z",
  fill: "#F1C40F"
})), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
  d: "M1104.54 55.97H1087.64V64.42H1104.54V55.97Z",
  fill: "#926445"
})), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
  d: "M276.66 89.76H238.65V148.89H276.66V89.76Z",
  fill: "#F9BE19"
})), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
  d: "M238.65 89.76H318.9L340.02 64.41H259.77L238.65 89.76Z",
  fill: "#926445"
})), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
  d: "M297.78 64.41L276.66 89.76V148.89H318.9V89.76L297.78 64.41Z",
  fill: "#D39C16"
})), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
  d: "M293.56 106.65H285.11V119.32H293.56V106.65Z",
  fill: "#8DD4FC"
})), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
  d: "M294.61 120.38H284.03V105.6H294.59L294.61 120.38ZM286.16 118.27H292.5V107.67H286.16V118.27Z",
  fill: "white"
})), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
  d: "M302.01 106.65H293.56V119.32H302.01V106.65Z",
  fill: "#8DD4FC"
})), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
  d: "M303.03 120.38H292.5V105.6H303.03V120.38ZM294.58 118.27H300.91V107.67H294.58V118.27Z",
  fill: "white"
})), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
  d: "M302.01 119.32H293.56V131.99H302.01V119.32Z",
  fill: "#8DD4FC"
})), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
  d: "M303.03 133.05H292.5V118.27H303.03V133.05ZM294.58 130.94H300.91V120.38H294.58V130.94Z",
  fill: "white"
})), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
  d: "M310.46 106.65H302.01V119.32H310.46V106.65Z",
  fill: "#8DD4FC"
})), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
  d: "M311.5 120.38H300.94V105.6H311.5V120.38ZM303.03 118.27H309.36V107.67H303.03V118.27Z",
  fill: "white"
})), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
  d: "M310.46 119.32H302.01V131.99H310.46V119.32Z",
  fill: "#8DD4FC"
})), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
  d: "M311.5 133.05H300.94V118.27H311.5V133.05ZM303.03 130.94H309.36V120.38H303.03V130.94Z",
  fill: "white"
})), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
  d: "M293.56 119.32H285.11V131.99H293.56V119.32Z",
  fill: "#8DD4FC"
})), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
  d: "M294.61 133.05H284.03V118.27H294.59L294.61 133.05ZM286.16 130.94H292.5V120.38H286.16V130.94Z",
  fill: "white"
})), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
  d: "M297.78 96.1C301.281 96.1 304.12 93.2615 304.12 89.76C304.12 86.2586 301.281 83.42 297.78 83.42C294.279 83.42 291.44 86.2586 291.44 89.76C291.44 93.2615 294.279 96.1 297.78 96.1Z",
  fill: "#ECF0F1"
})), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
  d: "M340.02 64.41L318.9 89.76V148.89H361.14V89.76L340.02 64.41Z",
  fill: "#F9BE19"
})), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
  d: "M335.8 106.65H327.35V119.32H335.8V106.65Z",
  fill: "#8DD4FC"
})), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
  d: "M336.85 120.38H326.29V105.6H336.85V120.38ZM328.4 118.27H334.74V107.67H328.4V118.27Z",
  fill: "white"
})), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
  d: "M344.25 106.65H335.8V119.32H344.25V106.65Z",
  fill: "#8DD4FC"
})), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
  d: "M345.3 120.38H334.74V105.6H345.3V120.38ZM336.85 118.27H343.18V107.67H336.85V118.27Z",
  fill: "white"
})), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
  d: "M344.25 119.32H335.8V131.99H344.25V119.32Z",
  fill: "#8DD4FC"
})), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
  d: "M345.3 133.05H334.74V118.27H345.3V133.05ZM336.85 130.94H343.18V120.38H336.85V130.94Z",
  fill: "white"
})), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
  d: "M352.69 106.65H344.24V119.32H352.69V106.65Z",
  fill: "#8DD4FC"
})), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
  d: "M353.74 120.38H343.18V105.6H353.74V120.38ZM345.3 118.27H351.63V107.67H345.3V118.27Z",
  fill: "white"
})), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
  d: "M352.69 119.32H344.24V131.99H352.69V119.32Z",
  fill: "#8DD4FC"
})), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
  d: "M353.74 133.05H343.18V118.27H353.74V133.05ZM345.3 130.94H351.63V120.38H345.3V130.94Z",
  fill: "white"
})), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
  d: "M335.8 119.32H327.35V131.99H335.8V119.32Z",
  fill: "#8DD4FC"
})), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
  d: "M336.85 133.05H326.29V118.27H336.85V133.05ZM328.4 130.94H334.74V120.38H328.4V130.94Z",
  fill: "white"
})), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
  d: "M340.02 96.1C343.521 96.1 346.36 93.2615 346.36 89.76C346.36 86.2586 343.521 83.42 340.02 83.42C336.519 83.42 333.68 86.2586 333.68 89.76C333.68 93.2615 336.519 96.1 340.02 96.1Z",
  fill: "#ECF0F1"
})), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
  d: "M280.89 63.99V53.85H268.21V79.2L280.89 63.99Z",
  fill: "#F9BE19"
})), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
  d: "M283 45.41H266.1V53.86H283V45.41Z",
  fill: "#C3855C"
})), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
  d: "M266.11 106.65H249.21V148.89H266.11V106.65Z",
  fill: "#926445"
})), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
  d: "M267.15 148.89H248.15V105.6H267.15V148.89ZM250.26 148.89H265.03V107.67H250.26V148.89Z",
  fill: "white"
})), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
  d: "M257.66 106.65H249.21V119.32H257.66V106.65Z",
  fill: "#8DD4FC"
})), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
  d: "M258.71 120.38H248.15V105.6H258.71V120.38ZM250.26 118.27H256.59V107.67H250.26V118.27Z",
  fill: "white"
})), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
  d: "M266.1 106.65H257.65V119.32H266.1V106.65Z",
  fill: "#8DD4FC"
})), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
  d: "M267.15 120.38H256.59V105.6H267.15V120.38ZM258.71 118.27H265.03V107.67H258.7L258.71 118.27Z",
  fill: "white"
})), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
  d: "M2224.4 89.76L2182.16 58.08L2139.92 89.76V148.89H2224.4V89.76Z",
  fill: "#926445"
})), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
  d: "M2139.92 89.76H2097.68V148.89H2139.92V89.76Z",
  fill: "#C3855C"
})), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
  d: "M2097.68 89.76H2139.92L2182.16 58.08H2139.92L2097.68 89.76Z",
  fill: "#D3BBAF"
})), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
  d: "M2118.8 106.65H2110.35V119.32H2118.8V106.65Z",
  fill: "#8DD4FC"
})), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
  d: "M2119.85 120.38H2109.29V105.6H2119.85V120.38ZM2111.41 118.27H2117.74V107.67H2111.41V118.27Z",
  fill: "white"
})), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
  d: "M2127.25 106.65H2118.8V119.32H2127.25V106.65Z",
  fill: "#8DD4FC"
})), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
  d: "M2128.3 120.38H2117.74V105.6H2128.3V120.38ZM2119.85 118.27H2126.19V107.67H2119.85V118.27Z",
  fill: "white"
})), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
  d: "M2127.25 119.32H2118.8V131.99H2127.25V119.32Z",
  fill: "#8DD4FC"
})), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
  d: "M2128.3 133.05H2117.74V118.27H2128.3V133.05ZM2119.85 130.94H2126.19V120.38H2119.85V130.94Z",
  fill: "white"
})), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
  d: "M2118.8 119.32H2110.35V131.99H2118.8V119.32Z",
  fill: "#8DD4FC"
})), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
  d: "M2119.85 133.05H2109.29V118.27H2119.85V133.05ZM2111.41 130.94H2117.74V120.38H2111.41V130.94Z",
  fill: "white"
})), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
  d: "M2156.82 106.65H2148.37V119.32H2156.82V106.65Z",
  fill: "#FFDE0F"
})), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
  d: "M2157.87 120.38H2147.31V105.6H2157.87V120.38ZM2149.42 118.27H2155.76V107.67H2149.42V118.27Z",
  fill: "white"
})), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
  d: "M2165.27 106.65H2156.82V119.32H2165.27V106.65Z",
  fill: "#FFDE0F"
})), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
  d: "M2166.32 120.38H2155.76V105.6H2166.32V120.38ZM2157.87 118.27H2164.2V107.67H2157.87V118.27Z",
  fill: "white"
})), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
  d: "M2165.27 119.32H2156.82V131.99H2165.27V119.32Z",
  fill: "#FFDE0F"
})), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
  d: "M2166.32 133.05H2155.76V118.27H2166.32V133.05ZM2157.87 130.94H2164.2V120.38H2157.87V130.94Z",
  fill: "white"
})), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
  d: "M2156.82 119.32H2148.37V131.99H2156.82V119.32Z",
  fill: "#FFDE0F"
})), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
  d: "M2157.87 133.05H2147.31V118.27H2157.87V133.05ZM2149.42 130.94H2155.76V120.38H2149.42V130.94Z",
  fill: "white"
})), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
  d: "M2207.5 106.65H2199.05V119.32H2207.5V106.65Z",
  fill: "#8DD4FC"
})), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
  d: "M2208.55 120.38H2198.03V105.6H2208.59L2208.55 120.38ZM2200.11 118.27H2206.44V107.67H2200.11V118.27Z",
  fill: "white"
})), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
  d: "M2215.95 106.65H2207.5V119.32H2215.95V106.65Z",
  fill: "#8DD4FC"
})), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
  d: "M2217.03 120.38H2206.47V105.6H2217.03V120.38ZM2208.58 118.27H2214.92V107.67H2208.58V118.27Z",
  fill: "white"
})), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
  d: "M2215.95 119.32H2207.5V131.99H2215.95V119.32Z",
  fill: "#8DD4FC"
})), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
  d: "M2217.03 133.05H2206.47V118.27H2217.03V133.05ZM2208.58 130.94H2214.92V120.38H2208.58V130.94Z",
  fill: "white"
})), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
  d: "M2207.5 119.32H2199.05V131.99H2207.5V119.32Z",
  fill: "#8DD4FC"
})), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
  d: "M2208.55 133.05H2198.03V118.27H2208.59L2208.55 133.05ZM2200.11 130.94H2206.44V120.38H2200.11V130.94Z",
  fill: "white"
})), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
  d: "M2182.16 93.98C2185.66 93.98 2188.5 91.1415 2188.5 87.64C2188.5 84.1386 2185.66 81.3 2182.16 81.3C2178.66 81.3 2175.82 84.1386 2175.82 87.64C2175.82 91.1415 2178.66 93.98 2182.16 93.98Z",
  fill: "#ECF0F1"
})), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
  d: "M2133.59 78.14L2146.26 68.64V49.63H2133.59V78.14Z",
  fill: "#C3855C"
})), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
  d: "M2190.61 106.65H2173.71V148.89H2190.61V106.65Z",
  fill: "#D3BBAF"
})), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
  d: "M2191.66 148.89H2172.66V105.6H2191.66V148.89ZM2174.76 148.89H2189.55V107.67H2174.76V148.89Z",
  fill: "white"
})), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
  d: "M2182.16 106.65H2173.71V119.32H2182.16V106.65Z",
  fill: "#8DD4FC"
})), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
  d: "M2183.21 120.38H2172.65V105.6H2183.21V120.38ZM2174.76 118.27H2181.1V107.67H2174.76V118.27Z",
  fill: "white"
})), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
  d: "M2190.61 106.65H2182.16V119.32H2190.61V106.65Z",
  fill: "#8DD4FC"
})), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
  d: "M2191.66 120.38H2181.1V105.6H2191.66V120.38ZM2183.21 118.27H2189.55V107.67H2183.21V118.27Z",
  fill: "white"
})), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
  d: "M393.87 64.41H360.08V148.89H393.87V64.41Z",
  fill: "#5FBB56"
})), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
  d: "M393.87 148.89H453.01V64.41L423.44 39.0699L393.87 64.41V148.89Z",
  fill: "#37AA2C"
})), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
  d: "M393.87 64.41H360.08L389.65 39.0699H423.44L393.87 64.41Z",
  fill: "#DF7430"
})), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
  d: "M376.98 77.09H368.53V89.76H376.98V77.09Z",
  fill: "#8DD4FC"
})), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
  d: "M378.03 90.81H367.47V76.03H378.03V90.81ZM369.58 88.67H375.92V78.14H369.58V88.67Z",
  fill: "white"
})), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
  d: "M385.43 77.09H376.98V89.76H385.43V77.09Z",
  fill: "#8DD4FC"
})), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
  d: "M386.48 90.81H375.92V76.03H386.48V90.81ZM378.03 88.67H384.37V78.14H378.03V88.67Z",
  fill: "white"
})), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
  d: "M376.98 89.76H368.53V102.43H376.98V89.76Z",
  fill: "#8DD4FC"
})), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
  d: "M378.03 103.48H367.47V88.67H378.03V103.48ZM369.58 101.37H375.92V90.81H369.58V101.37Z",
  fill: "white"
})), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
  d: "M385.43 89.76H376.98V102.43H385.43V89.76Z",
  fill: "#8DD4FC"
})), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
  d: "M386.48 103.48H375.92V88.67H386.48V103.48ZM378.03 101.37H384.37V90.81H378.03V101.37Z",
  fill: "white"
})), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
  d: "M376.98 110.88H368.53V123.55H376.98V110.88Z",
  fill: "#8DD4FC"
})), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
  d: "M378.03 124.6H367.47V109.82H378.03V124.6ZM369.58 122.49H375.92V111.93H369.58V122.49Z",
  fill: "white"
})), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
  d: "M385.43 110.88H376.98V123.55H385.43V110.88Z",
  fill: "#8DD4FC"
})), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
  d: "M386.48 124.6H375.92V109.82H386.48V124.6ZM378.03 122.49H384.37V111.93H378.03V122.49Z",
  fill: "white"
})), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
  d: "M376.98 123.55H368.53V136.22H376.98V123.55Z",
  fill: "#8DD4FC"
})), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
  d: "M378.03 137.27H367.47V122.49H378.03V137.27ZM369.58 135.16H375.92V124.6H369.58V135.16Z",
  fill: "white"
})), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
  d: "M385.43 123.55H376.98V136.22H385.43V123.55Z",
  fill: "#8DD4FC"
})), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
  d: "M386.48 137.27H375.92V122.49H386.48V137.27ZM378.03 135.16H384.37V124.6H378.03V135.16Z",
  fill: "white"
})), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
  d: "M410.77 77.09H402.32V89.76H410.77V77.09Z",
  fill: "#8DD4FC"
})), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
  d: "M411.82 90.81H401.26V76.03H411.82V90.81ZM403.37 88.67H409.71V78.14H403.37V88.67Z",
  fill: "white"
})), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
  d: "M419.22 77.09H410.77V89.76H419.22V77.09Z",
  fill: "#8DD4FC"
})), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
  d: "M420.27 90.81H409.71V76.03H420.27V90.81ZM411.82 88.67H418.16V78.14H411.82V88.67Z",
  fill: "white"
})), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
  d: "M410.77 89.76H402.32V102.43H410.77V89.76Z",
  fill: "#8DD4FC"
})), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
  d: "M411.82 103.48H401.26V88.67H411.82V103.48ZM403.37 101.37H409.71V90.81H403.37V101.37Z",
  fill: "white"
})), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
  d: "M419.22 89.76H410.77V102.43H419.22V89.76Z",
  fill: "#8DD4FC"
})), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
  d: "M420.27 103.48H409.71V88.67H420.27V103.48ZM411.82 101.37H418.16V90.81H411.82V101.37Z",
  fill: "white"
})), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
  d: "M410.77 110.88H402.32V123.55H410.77V110.88Z",
  fill: "#8DD4FC"
})), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
  d: "M411.82 124.6H401.26V109.82H411.82V124.6ZM403.37 122.49H409.71V111.93H403.37V122.49Z",
  fill: "white"
})), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
  d: "M419.22 110.88H410.77V123.55H419.22V110.88Z",
  fill: "#8DD4FC"
})), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
  d: "M420.27 124.6H409.71V109.82H420.27V124.6ZM411.82 122.49H418.16V111.93H411.82V122.49Z",
  fill: "white"
})), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
  d: "M410.77 123.55H402.32V136.22H410.77V123.55Z",
  fill: "#8DD4FC"
})), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
  d: "M411.82 137.27H401.26V122.49H411.82V137.27ZM403.37 135.16H409.71V124.6H403.37V135.16Z",
  fill: "white"
})), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
  d: "M419.22 123.55H410.77V136.22H419.22V123.55Z",
  fill: "#8DD4FC"
})), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
  d: "M420.27 137.27H409.71V122.49H420.27V137.27ZM411.82 135.16H418.16V124.6H411.82V135.16Z",
  fill: "white"
})), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
  d: "M436.11 77.09H427.66V89.76H436.11V77.09Z",
  fill: "#8DD4FC"
})), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
  d: "M437.16 90.81H426.6V76.03H437.16V90.81ZM428.72 88.67H435.03V78.14H428.7L428.72 88.67Z",
  fill: "white"
})), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
  d: "M444.56 77.09H436.11V89.76H444.56V77.09Z",
  fill: "#8DD4FC"
})), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
  d: "M445.61 90.81H435.03V76.03H445.59L445.61 90.81ZM437.16 88.67H443.5V78.14H437.16V88.67Z",
  fill: "white"
})), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
  d: "M436.11 89.76H427.66V102.43H436.11V89.76Z",
  fill: "#8DD4FC"
})), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
  d: "M437.16 103.48H426.6V88.67H437.16V103.48ZM428.72 101.37H435.03V90.81H428.7L428.72 101.37Z",
  fill: "white"
})), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
  d: "M444.56 89.76H436.11V102.43H444.56V89.76Z",
  fill: "#8DD4FC"
})), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
  d: "M445.61 103.48H435.03V88.67H445.59L445.61 103.48ZM437.16 101.37H443.5V90.81H437.16V101.37Z",
  fill: "white"
})), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
  d: "M436.11 110.88H427.66V123.55H436.11V110.88Z",
  fill: "#8DD4FC"
})), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
  d: "M437.16 124.6H426.6V109.82H437.16V124.6ZM428.72 122.49H435.03V111.93H428.7L428.72 122.49Z",
  fill: "white"
})), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
  d: "M444.56 110.88H436.11V123.55H444.56V110.88Z",
  fill: "#8DD4FC"
})), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
  d: "M445.61 124.6H435.03V109.82H445.59L445.61 124.6ZM437.16 122.49H443.5V111.93H437.16V122.49Z",
  fill: "white"
})), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
  d: "M436.11 123.55H427.66V136.22H436.11V123.55Z",
  fill: "#8DD4FC"
})), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
  d: "M437.16 137.27H426.6V122.49H437.16V137.27ZM428.72 135.16H435.03V124.6H428.7L428.72 135.16Z",
  fill: "white"
})), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
  d: "M444.56 123.55H436.11V136.22H444.56V123.55Z",
  fill: "#8DD4FC"
})), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
  d: "M445.61 137.27H435.03V122.49H445.59L445.61 137.27ZM437.16 135.16H443.5V124.6H437.16V135.16Z",
  fill: "white"
})), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
  d: "M423.44 68.64C426.941 68.64 429.78 65.8014 429.78 62.3C429.78 58.7985 426.941 55.96 423.44 55.96C419.939 55.96 417.1 58.7985 417.1 62.3C417.1 65.8014 419.939 68.64 423.44 68.64Z",
  fill: "#ECF0F1"
})), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
  d: "M400.21 45.1V30.62H387.54V55.97L400.21 45.1Z",
  fill: "#5FBB56"
})), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
  d: "M511.08 83.42H477.29V148.89H511.08V83.42Z",
  fill: "#37AA2C"
})), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
  d: "M477.3 83.42H511.09L540.65 53.85H506.86L477.3 83.42Z",
  fill: "#F1C40F"
})), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
  d: "M477.3 89.76L451.95 115.1H477.3V89.76Z",
  fill: "#F1C40F"
})), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
  d: "M570.22 83.42L540.65 53.85L511.09 83.42V148.89H570.22V83.42Z",
  fill: "#298021"
})), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
  d: "M553.32 119.32H561.77V106.65H553.32V119.32Z",
  fill: "#FFDE0F"
})), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
  d: "M562.82 120.38H552.26V105.6H562.82V120.38ZM554.38 118.27H560.71V107.67H554.38V118.27Z",
  fill: "white"
})), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88 119.32H553.33V106.65H544.88V119.32Z",
  fill: "#FFDE0F"
})), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
  d: "M554.38 120.38H543.82V105.6H554.38V120.38ZM545.93 118.27H552.26V107.67H545.93V118.27Z",
  fill: "white"
})), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88 132H553.33V119.33H544.88V132Z",
  fill: "#FFDE0F"
})), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
  d: "M554.38 133.05H543.82V118.27H554.38V133.05ZM545.93 130.94H552.26V120.38H545.93V130.94Z",
  fill: "white"
})), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
  d: "M553.32 132H561.77V119.33H553.32V132Z",
  fill: "#FFDE0F"
})), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
  d: "M562.82 133.05H552.26V118.27H562.82V133.05ZM554.38 130.94H560.71V120.38H554.38V130.94Z",
  fill: "white"
})), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
  d: "M527.98 91.87H536.43V83.42H527.98V91.87Z",
  fill: "#FFDE0F"
})), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
  d: "M537.48 92.92H526.92V82.36H537.48V92.92ZM529.03 90.81H535.37V84.48H529.03V90.81Z",
  fill: "white"
})), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
  d: "M536.43 91.87H544.88V83.42H536.43V91.87Z",
  fill: "#FFDE0F"
})), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
  d: "M545.93 92.92H535.37V82.36H545.93V92.92ZM537.48 90.81H543.82V84.48H537.48V90.81Z",
  fill: "white"
})), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
  d: "M544.88 91.87H553.33V83.42H544.88V91.87Z",
  fill: "#FFDE0F"
})), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
  d: "M554.38 92.92H543.82V82.36H554.38V92.92ZM545.93 90.81H552.26V84.48H545.93V90.81Z",
  fill: "white"
})), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
  d: "M527.98 106.65H519.53V119.32H527.98V106.65Z",
  fill: "#FFDE0F"
})), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
  d: "M529.03 120.38H518.47V105.6H529.03V120.38ZM520.59 118.27H526.92V107.67H520.59V118.27Z",
  fill: "white"
})), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
  d: "M536.43 106.65H527.98V119.32H536.43V106.65Z",
  fill: "#FFDE0F"
})), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
  d: "M537.48 120.38H526.92V105.6H537.48V120.38ZM529.03 118.27H535.37V107.67H529.03V118.27Z",
  fill: "white"
})), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
  d: "M536.43 119.32H527.98V131.99H536.43V119.32Z",
  fill: "#FFDE0F"
})), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
  d: "M537.48 133.05H526.92V118.27H537.48V133.05ZM529.03 130.94H535.37V120.38H529.03V130.94Z",
  fill: "white"
})), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
  d: "M527.98 119.32H519.53V131.99H527.98V119.32Z",
  fill: "#FFDE0F"
})), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
  d: "M529.03 133.05H518.47V118.27H529.03V133.05ZM520.59 130.94H526.92V120.38H520.59V130.94Z",
  fill: "white"
})), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
  d: "M519.53 47.52H506.86V72.86L519.53 59.89V47.52Z",
  fill: "#37AA2C"
})), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
  d: "M504.74 47.52H521.64V39.07H504.74V47.52Z",
  fill: "#F1C40F"
})), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
  d: "M477.29 115.1H451.95V148.89H477.29V115.1Z",
  fill: "#37AA2C"
})), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
  d: "M468.85 123.55H460.4V132H468.85V123.55Z",
  fill: "#FFDE0F"
})), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
  d: "M469.9 133.05H459.34V122.49H469.9V133.05ZM461.45 130.94H467.79V124.6H461.45V130.94Z",
  fill: "white"
})), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
  d: "M468.85 132H460.4V140.45H468.85V132Z",
  fill: "#FFDE0F"
})), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
  d: "M469.9 141.5H459.34V130.94H469.9V141.5ZM461.45 139.39H467.79V133.05H461.45V139.39Z",
  fill: "white"
})), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
  d: "M485.74 148.89H502.64V106.65H485.74V148.89Z",
  fill: "#926445"
})), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
  d: "M503.69 148.89H484.69V105.6H503.69V148.89ZM486.79 148.89H501.58V107.67H486.79V148.89Z",
  fill: "white"
})), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
  d: "M498.41 122.49H494.19V128.83H498.41V122.49Z",
  fill: "white"
})), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
  d: "M630.41 148.89H664.2V83.42H630.41V148.89Z",
  fill: "#5557AE"
})), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
  d: "M664.2 83.42H630.41L600.84 53.85H634.63L664.2 83.42Z",
  fill: "#F1C40F"
})), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
  d: "M664.2 89.76L689.54 115.1H664.2V89.76Z",
  fill: "#F1C40F"
})), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
  d: "M571.28 83.42L600.84 53.85L630.41 83.42V148.89H571.28V83.42Z",
  fill: "#6163C7"
})), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
  d: "M647.3 119.32H655.75V106.65H647.3V119.32Z",
  fill: "#FFDE0F"
})), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
  d: "M656.8 120.38H646.24V105.6H656.8V120.38ZM648.36 118.27H654.69V107.67H648.36V118.27Z",
  fill: "white"
})), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
  d: "M638.86 119.32H647.31V106.65H638.86V119.32Z",
  fill: "#FFDE0F"
})), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
  d: "M648.36 120.38H637.8V105.6H648.36V120.38ZM639.91 118.27H646.24V107.67H639.91V118.27Z",
  fill: "white"
})), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
  d: "M638.86 132H647.31V119.33H638.86V132Z",
  fill: "#FFDE0F"
})), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
  d: "M648.36 133.05H637.8V118.27H648.36V133.05ZM639.91 130.94H646.24V120.38H639.91V130.94Z",
  fill: "white"
})), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
  d: "M647.3 132H655.75V119.33H647.3V132Z",
  fill: "#FFDE0F"
})), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
  d: "M656.8 133.05H646.24V118.27H656.8V133.05ZM648.36 130.94H654.69V120.38H648.36V130.94Z",
  fill: "white"
})), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
  d: "M613.51 119.32H621.96V106.65H613.51V119.32Z",
  fill: "#FFDE0F"
})), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
  d: "M623.03 120.38H612.45V105.6H623.03V120.38ZM614.59 118.27H620.92V107.67H614.59V118.27Z",
  fill: "white"
})), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
  d: "M605.07 119.32H613.52V106.65H605.07V119.32Z",
  fill: "#FFDE0F"
})), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
  d: "M614.57 120.38H604.03V105.6H614.59L614.57 120.38ZM606.12 118.27H612.45V107.67H606.12V118.27Z",
  fill: "white"
})), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
  d: "M605.07 132H613.52V119.33H605.07V132Z",
  fill: "#FFDE0F"
})), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
  d: "M614.57 133.05H604.03V118.27H614.59L614.57 133.05ZM606.12 130.94H612.45V120.38H606.12V130.94Z",
  fill: "white"
})), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
  d: "M613.51 132H621.96V119.33H613.51V132Z",
  fill: "#FFDE0F"
})), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
  d: "M623.03 133.05H612.45V118.27H623.03V133.05ZM614.59 130.94H620.92V120.38H614.59V130.94Z",
  fill: "white"
})), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
  d: "M621.96 47.52H634.63V72.86L621.96 59.89V47.52Z",
  fill: "#5557AE"
})), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
  d: "M689.54 115.1H664.2V148.89H689.54V115.1Z",
  fill: "#6163C7"
})), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
  d: "M672.65 131.99H681.1V123.54H672.65V131.99Z",
  fill: "#FFDE0F"
})), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
  d: "M682.15 133.05H671.59V122.49H682.15V133.05ZM673.7 130.94H680.03V124.6H673.69L673.7 130.94Z",
  fill: "white"
})), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
  d: "M672.65 140.45H681.1V132H672.65V140.45Z",
  fill: "#FFDE0F"
})), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
  d: "M682.15 141.5H671.59V130.94H682.15V141.5ZM673.7 139.39H680.03V133.05H673.69L673.7 139.39Z",
  fill: "white"
})), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
  d: "M596.62 106.65H579.72V148.89H596.62V106.65Z",
  fill: "#926445"
})), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
  d: "M597.67 148.89H578.67V105.6H597.67V148.89ZM580.77 148.89H595.56V107.67H580.77V148.89Z",
  fill: "white"
})), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
  d: "M592.39 122.49H588.17V128.83H592.39V122.49Z",
  fill: "white"
})), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
  d: "M596.61 91.8699H605.03V83.42C605.03 82.3007 604.585 81.2274 603.794 80.436C603.003 79.6446 601.929 79.2 600.81 79.2C599.69 79.1999 598.616 79.6442 597.823 80.4353C597.03 81.2265 596.583 82.2998 596.58 83.42L596.61 91.8699Z",
  fill: "#FFDE0F"
})), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
  d: "M1499.47 89.76L1461.45 58.08L1423.44 89.76V148.89H1499.47V89.76Z",
  fill: "#DF3030"
})), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
  d: "M1423.44 89.76H1381.2V148.89H1423.44V89.76Z",
  fill: "#FF3737"
})), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
  d: "M1381.2 89.76H1423.44L1461.45 58.08H1419.21L1381.2 89.76Z",
  fill: "#7F8C8D"
})), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
  d: "M1402.32 106.65H1393.87V119.32H1402.32V106.65Z",
  fill: "#8DD4FC"
})), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
  d: "M1403.37 120.38H1392.81V105.6H1403.37V120.38ZM1394.92 118.27H1401.26V107.67H1394.92V118.27Z",
  fill: "white"
})), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
  d: "M1410.77 106.65H1402.32V119.32H1410.77V106.65Z",
  fill: "#8DD4FC"
})), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
  d: "M1411.82 120.38H1401.26V105.6H1411.82V120.38ZM1403.37 118.27H1409.71V107.67H1403.37V118.27Z",
  fill: "white"
})), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
  d: "M1410.77 119.32H1402.32V131.99H1410.77V119.32Z",
  fill: "#8DD4FC"
})), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
  d: "M1411.82 133.05H1401.26V118.27H1411.82V133.05ZM1403.37 130.94H1409.71V120.38H1403.37V130.94Z",
  fill: "white"
})), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
  d: "M1402.32 119.32H1393.87V131.99H1402.32V119.32Z",
  fill: "#8DD4FC"
})), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
  d: "M1403.37 133.05H1392.81V118.27H1403.37V133.05ZM1394.92 130.94H1401.26V120.38H1394.92V130.94Z",
  fill: "white"
})), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
  d: "M1444.56 106.65H1436.11V119.32H1444.56V106.65Z",
  fill: "#FFDE0F"
})), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
  d: "M1445.61 120.38H1435.03V105.6H1445.59L1445.61 120.38ZM1437.16 118.27H1443.5V107.67H1437.16V118.27Z",
  fill: "white"
})), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
  d: "M1453.01 106.65H1444.56V119.32H1453.01V106.65Z",
  fill: "#FFDE0F"
})), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
  d: "M1454.03 120.38H1443.47V105.6H1454.03V120.38ZM1445.58 118.27H1451.91V107.67H1445.58V118.27Z",
  fill: "white"
})), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
  d: "M1453.01 119.32H1444.56V131.99H1453.01V119.32Z",
  fill: "#FFDE0F"
})), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
  d: "M1454.03 133.05H1443.47V118.27H1454.03V133.05ZM1445.58 130.94H1451.91V120.38H1445.58V130.94Z",
  fill: "white"
})), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
  d: "M1444.56 119.32H1436.11V131.99H1444.56V119.32Z",
  fill: "#FFDE0F"
})), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
  d: "M1445.61 133.05H1435.03V118.27H1445.59L1445.61 133.05ZM1437.16 130.94H1443.5V120.38H1437.16V130.94Z",
  fill: "white"
})), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
  d: "M1478.35 106.65H1469.9V119.32H1478.35V106.65Z",
  fill: "#8DD4FC"
})), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
  d: "M1479.4 120.38H1468.84V105.6H1479.4V120.38ZM1470.95 118.27H1477.29V107.67H1470.95V118.27Z",
  fill: "white"
})), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
  d: "M1486.8 106.65H1478.35V119.32H1486.8V106.65Z",
  fill: "#8DD4FC"
})), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
  d: "M1487.85 120.38H1477.29V105.6H1487.85V120.38ZM1479.4 118.27H1485.73V107.67H1479.4V118.27Z",
  fill: "white"
})), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
  d: "M1486.8 119.32H1478.35V131.99H1486.8V119.32Z",
  fill: "#8DD4FC"
})), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
  d: "M1487.85 133.05H1477.29V118.27H1487.85V133.05ZM1479.4 130.94H1485.73V120.38H1479.4V130.94Z",
  fill: "white"
})), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
  d: "M1478.35 119.32H1469.9V131.99H1478.35V119.32Z",
  fill: "#8DD4FC"
})), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
  d: "M1479.4 133.05H1468.84V118.27H1479.4V133.05ZM1470.95 130.94H1477.29V120.38H1470.95V130.94Z",
  fill: "white"
})), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
  d: "M1461.45 96.1C1464.95 96.1 1467.79 93.2615 1467.79 89.76C1467.79 86.2586 1464.95 83.42 1461.45 83.42C1457.95 83.42 1455.11 86.2586 1455.11 89.76C1455.11 93.2615 1457.95 96.1 1461.45 96.1Z",
  fill: "#ECF0F1"
})), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
  d: "M1429.77 68.64L1417.1 79.2V51.74H1429.77V68.64Z",
  fill: "#FF3737"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_79_16853"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2224.4,
  height: 148.89,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/houses.35d28884895e120375afd8df9790005d.svg";